import { Inject } from '@angular/core';

import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.inspection.viewer');
import { OnInit, ChangeDetectorRef as CDR, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;
declare let pdfjsLib: any;

@Component({
    selector: 'wiz-page-inspection-viewer',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.inspection.viewer/view.scss */
.inspection-viewer-page {
  --viewer-safe-bottom: env(safe-area-inset-bottom, 0px);
  --viewer-safe-right: env(safe-area-inset-right, 0px);
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  max-height: 100dvh;
  width: 100vw;
  background: #1e1e1e;
  overflow: hidden;
  font-family: "Pretendard", -apple-system, sans-serif;
}

.viewer-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  z-index: 100;
  flex-shrink: 0;
  gap: 8px;
  min-height: 52px;
}
.viewer-toolbar .toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.viewer-toolbar .toolbar-left .tb-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: #f1f5f9;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.viewer-toolbar .toolbar-left .tb-btn i {
  font-size: 18px;
  color: #475569;
}
.viewer-toolbar .toolbar-left .tb-btn:hover {
  background: #e2e8f0;
}
.viewer-toolbar .toolbar-left .tb-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.viewer-toolbar .toolbar-left .tb-info .tb-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.viewer-toolbar .toolbar-left .tb-info .tb-sub {
  font-size: 11px;
  color: #666666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.viewer-toolbar .toolbar-center {
  display: flex;
  align-items: center;
}
.viewer-toolbar .toolbar-center .tool-group {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  background: #f1f5f9;
  border-radius: 12px;
}
.viewer-toolbar .toolbar-center .tool-group .mode-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.viewer-toolbar .toolbar-center .tool-group .mode-btn i {
  font-size: 15px;
  color: #64748b;
}
.viewer-toolbar .toolbar-center .tool-group .mode-btn span {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}
.viewer-toolbar .toolbar-center .tool-group .mode-btn:hover {
  background: #e2e8f0;
}
.viewer-toolbar .toolbar-center .tool-group .mode-btn:disabled {
  opacity: 0.5;
  cursor: wait;
}
.viewer-toolbar .toolbar-center .tool-group .mode-btn.active {
  background: #1976d2;
  box-shadow: 0 2px 6px rgba(25, 118, 210, 0.3);
}
.viewer-toolbar .toolbar-center .tool-group .mode-btn.active i {
  color: #fff;
}
.viewer-toolbar .toolbar-center .tool-group .mode-btn.active span {
  color: #fff;
}
.viewer-toolbar .toolbar-center .tool-group .mode-btn.overview-photo-btn {
  position: relative;
  overflow: visible;
}
.viewer-toolbar .toolbar-center .tool-group .overview-photo-badge {
  position: absolute;
  top: -6px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 0 0 2px #f1f5f9;
}
.viewer-toolbar .toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.viewer-toolbar .toolbar-right .undo-redo-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 50%;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}
.viewer-toolbar .toolbar-right .undo-redo-btn:disabled {
  opacity: 0.35;
  cursor: default;
}
.viewer-toolbar .toolbar-right .undo-redo-btn:not(:disabled):active {
  background: #e2e8f0;
}
.viewer-toolbar .toolbar-right .undo-redo-btn i {
  font-size: 14px;
  color: #475569;
}
.viewer-toolbar .toolbar-right .damage-count {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #ea580c;
  white-space: nowrap;
}
.viewer-toolbar .toolbar-right .damage-count i {
  font-size: 13px;
}
.viewer-toolbar .toolbar-right .tb-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 14px;
  border: none;
  background: #f1f5f9;
  border-radius: 8px;
  cursor: pointer;
  gap: 6px;
  transition: background 0.15s;
  position: relative;
}
.viewer-toolbar .toolbar-right .tb-btn i {
  font-size: 16px;
  color: #475569;
}
.viewer-toolbar .toolbar-right .tb-btn .badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: #dc2626;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.viewer-toolbar .toolbar-right .tb-btn:hover {
  background: #e2e8f0;
}
.viewer-toolbar .toolbar-right .tb-btn.conflict-btn {
  background: #fef3c7;
  border: 1px solid #fcd34d;
  color: #92400e;
}
.viewer-toolbar .toolbar-right .tb-btn.conflict-btn i {
  color: #b45309;
}
.viewer-toolbar .toolbar-right .tb-btn.conflict-btn .conflict-text {
  color: #92400e;
  font-size: 13px;
  font-weight: 700;
}
.viewer-toolbar .toolbar-right .tb-btn.conflict-btn .conflict-badge {
  background: #dc2626;
}
.viewer-toolbar .toolbar-right .tb-btn.conflict-btn:hover {
  background: #fde68a;
}
.viewer-toolbar .toolbar-right .tb-btn.save-btn {
  background: #16a34a;
}
.viewer-toolbar .toolbar-right .tb-btn.save-btn i {
  color: #fff;
}
.viewer-toolbar .toolbar-right .tb-btn.save-btn .save-text {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.viewer-toolbar .toolbar-right .tb-btn.save-btn:hover {
  background: #117f3a;
}
.viewer-toolbar .toolbar-right .tb-btn.export-btn {
  background: #3b82f6;
}
.viewer-toolbar .toolbar-right .tb-btn.export-btn i {
  color: #fff;
}
.viewer-toolbar .toolbar-right .tb-btn.export-btn .save-text {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.viewer-toolbar .toolbar-right .tb-btn.export-btn:hover {
  background: #2563eb;
}
.viewer-toolbar .toolbar-right .tb-btn.export-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.viewer-main {
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  overflow: hidden;
}

.page-sidebar {
  width: 132px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: #111827;
  border-right: 1px solid rgba(148, 163, 184, 0.18);
  z-index: 10;
  transition: width 0.22s ease;
}
.page-sidebar.collapsed {
  width: 44px;
}
.page-sidebar.collapsed .page-sidebar-header {
  justify-content: center;
  padding: 12px 6px 10px;
}
.page-sidebar .page-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.16);
  color: #e5e7eb;
}
.page-sidebar .page-sidebar-header .page-sidebar-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.page-sidebar .page-sidebar-header i {
  font-size: 13px;
  color: #93c5fd;
}
.page-sidebar .page-sidebar-header span {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.page-sidebar .page-sidebar-header .page-sidebar-toggle {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #e5e7eb;
  cursor: pointer;
  transition: all 0.15s;
  appearance: none;
}
.page-sidebar .page-sidebar-header .page-sidebar-toggle:hover {
  background: rgba(96, 165, 250, 0.2);
  color: #bfdbfe;
}
.page-sidebar .page-sidebar-header .page-sidebar-toggle i {
  font-size: 11px;
  color: inherit;
}
.page-sidebar .page-thumbnail-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px 8px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-overflow-scrolling: touch;
}
.page-sidebar .page-thumbnail-list::-webkit-scrollbar {
  width: 6px;
}
.page-sidebar .page-thumbnail-list::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.28);
  border-radius: 999px;
}
.page-sidebar .page-thumbnail {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 8px;
  appearance: none;
  border: 1px solid transparent;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: all 0.18s;
  text-align: left;
}
.page-sidebar .page-thumbnail:hover {
  border-color: rgba(147, 197, 253, 0.4);
  background: rgba(59, 130, 246, 0.1);
}
.page-sidebar .page-thumbnail.active {
  border-color: #60a5fa;
  background: rgba(59, 130, 246, 0.16);
  box-shadow: inset 0 0 0 1px rgba(147, 197, 253, 0.3);
}
.page-sidebar .page-thumbnail-preview {
  position: relative;
  width: 100%;
  min-height: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.92);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.14);
}
.page-sidebar .page-thumbnail-image {
  display: block;
  width: 100%;
  height: auto;
  background: #ffffff;
}
.page-sidebar .page-thumbnail-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 124px;
  color: rgba(226, 232, 240, 0.72);
}
.page-sidebar .page-thumbnail-placeholder i {
  font-size: 18px;
}
.page-sidebar .page-thumbnail-delete {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #f87171;
  cursor: pointer;
  box-shadow: none;
  transition: color 0.15s, opacity 0.15s;
}
.page-sidebar .page-thumbnail-delete:hover {
  background: transparent;
  color: #fca5a5;
}
.page-sidebar .page-thumbnail-delete:focus-visible {
  outline: 1px solid #fca5a5;
  outline-offset: 1px;
}
.page-sidebar .page-thumbnail-delete:disabled {
  cursor: wait;
  opacity: 0.5;
}
.page-sidebar .page-thumbnail-delete i {
  font-size: 10px;
  color: inherit;
  pointer-events: none;
}
.page-sidebar .page-thumbnail-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #e5e7eb;
}
.page-sidebar .page-thumbnail-number {
  font-size: 11px;
  font-weight: 600;
}

.viewer-canvas-area {
  flex: 1;
  position: relative;
  overflow: hidden;
  background: #2a2a2a;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}
.viewer-canvas-area.shape-moving {
  cursor: grabbing;
}
.viewer-canvas-area .pdf-canvas-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
}
.viewer-canvas-area .pdf-canvas-wrapper #pdf-canvas {
  display: block;
  background: #fff;
}
.viewer-canvas-area .pdf-canvas-wrapper .drawing-grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  background-image:
    linear-gradient(to right, var(--grid-color) 1px, transparent 1px),
    linear-gradient(to bottom, var(--grid-color) 1px, transparent 1px);
  background-size: var(--grid-spacing) var(--grid-spacing);
  z-index: 1;
}
.viewer-canvas-area .pdf-canvas-wrapper #annotation-canvas {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 2;
}
.viewer-canvas-area .pdf-canvas-wrapper #drawing-canvas {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 3;
}
.viewer-canvas-area .pdf-canvas-wrapper .marker-label-overlay {
  position: absolute;
  min-width: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  pointer-events: none;
  user-select: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
  z-index: 4;
}
.viewer-canvas-area .pdf-canvas-wrapper .marker-label-overlay.selected {
  min-width: 40px;
  min-height: 40px;
  font-size: 14px;
}
.viewer-canvas-area .pdf-canvas-wrapper .eraser-cursor {
  position: absolute;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.12);
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.45);
  pointer-events: none;
  z-index: 5;
}

.viewer-top-controls {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  max-width: calc(100% - 24px);
  z-index: 50;
}

.point-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  z-index: 99;
  flex-shrink: 0;
  overflow: hidden;
}
.point-toolbar::-webkit-scrollbar {
  height: 3px;
}
.point-toolbar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.point-toolbar .point-toolbar-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  flex-wrap: nowrap;
}
.point-toolbar .point-section {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.point-toolbar .point-section .point-section-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;
  min-width: 28px;
}
.point-toolbar .point-sep {
  width: 1px;
  height: 28px;
  background: #e2e8f0;
  flex-shrink: 0;
}
.point-toolbar .point-tool-group {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: #e2e8f0;
  border-radius: 8px;
  flex-shrink: 0;
}
.point-toolbar .point-tool-group .point-tool-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 8px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.point-toolbar .point-tool-group .point-tool-btn i {
  font-size: 13px;
  color: #64748b;
}
.point-toolbar .point-tool-group .point-tool-btn span {
  font-size: 11px;
  color: #64748b;
  display: none;
}
.point-toolbar .point-tool-group .point-tool-btn:hover {
  background: #f1f5f9;
}
.point-toolbar .point-tool-group .point-tool-btn.active {
  background: #1976d2;
  box-shadow: 0 1px 4px rgba(25, 118, 210, 0.3);
}
.point-toolbar .point-tool-group .point-tool-btn.active i {
  color: #fff;
}
.point-toolbar .point-tool-group .point-tool-btn.active span {
  color: #fff;
}
@media (min-width: 1024px) {
  .point-toolbar .point-tool-group .point-tool-btn span {
    display: inline;
  }
}
.point-toolbar .point-helper {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  border-radius: 6px;
  white-space: nowrap;
  flex-shrink: 0;
}
.point-toolbar .point-helper i {
  font-size: 12px;
  color: #2563eb;
}
.point-toolbar .point-helper span {
  font-size: 11px;
  font-weight: 500;
  color: #1d4ed8;
}
.point-toolbar .point-clear-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  flex-shrink: 0;
}
.point-toolbar .point-clear-btn i {
  font-size: 12px;
  color: #dc2626;
}
.point-toolbar .point-clear-btn span {
  font-size: 11px;
  font-weight: 500;
  color: #dc2626;
}
.point-toolbar .point-clear-btn:hover:not(:disabled) {
  background: #fee2e2;
  border-color: #fca5a5;
}
.point-toolbar .point-clear-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.grid-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  z-index: 99;
  flex-shrink: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.grid-toolbar::-webkit-scrollbar {
  height: 3px;
}
.grid-toolbar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.grid-toolbar .grid-toolbar-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: max-content;
  min-width: min-content;
  margin: 0 auto;
}
.grid-toolbar .grid-toggle-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  border-radius: 7px;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
}
.grid-toolbar .grid-toggle-btn.active {
  border-color: #1976d2;
  background: #1976d2;
  color: #ffffff;
}
.grid-toolbar .grid-toggle-btn i {
  font-size: 12px;
}
.grid-toolbar .grid-toggle-btn span {
  font-size: 11px;
  font-weight: 600;
}
.grid-toolbar .grid-sep {
  width: 1px;
  height: 28px;
  background: #e2e8f0;
  flex-shrink: 0;
}
.grid-toolbar .grid-control {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.grid-toolbar .grid-control-label {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 72px;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}
.grid-toolbar .grid-control-label strong {
  min-width: 36px;
  color: #334155;
  text-align: right;
}
.grid-toolbar .grid-slider {
  width: 130px;
  accent-color: #1976d2;
  cursor: pointer;
}

.draw-toolbar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  z-index: 99;
  flex-shrink: 0;
  overflow: visible;
}
.draw-toolbar .draw-toolbar-inner::-webkit-scrollbar,
.draw-toolbar .draw-subtool-panel::-webkit-scrollbar {
  height: 3px;
}
.draw-toolbar .draw-toolbar-inner::-webkit-scrollbar-thumb,
.draw-toolbar .draw-subtool-panel::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.draw-toolbar .draw-toolbar-inner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: max-content;
  max-width: 100%;
  margin: 0 auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.draw-toolbar .draw-section {
  display: flex;
  align-items: center;
  gap: 6px;
}
.draw-toolbar .draw-section .draw-section-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;
  min-width: 28px;
}
.draw-toolbar .draw-sep {
  width: 1px;
  height: 28px;
  background: #e2e8f0;
  flex-shrink: 0;
}
.draw-toolbar .draw-tool-group {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: #e2e8f0;
  border-radius: 8px;
}
.draw-toolbar .draw-tool-group .draw-tool-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 8px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.draw-toolbar .draw-tool-group .draw-tool-btn i {
  font-size: 13px;
  color: #64748b;
}
.draw-toolbar .draw-tool-group .draw-tool-btn span {
  font-size: 11px;
  color: #64748b;
  display: none;
}
.draw-toolbar .draw-tool-group .draw-tool-btn:hover {
  background: #f1f5f9;
}
.draw-toolbar .draw-tool-group .draw-tool-btn.active {
  background: #1976d2;
  box-shadow: 0 1px 4px rgba(25, 118, 210, 0.3);
}
.draw-toolbar .draw-tool-group .draw-tool-btn.active i {
  color: #fff;
}
.draw-toolbar .draw-tool-group .draw-tool-btn.active span {
  color: #fff;
}
@media (min-width: 1024px) {
  .draw-toolbar .draw-tool-group .draw-tool-btn span {
    display: inline;
  }
}
.draw-toolbar .draw-color-group {
  display: flex;
  gap: 3px;
}
.draw-toolbar .draw-color-group .draw-color-btn {
  width: 26px;
  height: 26px;
  border: 2px solid transparent;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
  padding: 2px;
  transition: all 0.15s;
}
.draw-toolbar .draw-color-group .draw-color-btn .color-swatch {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--swatch-color, #000000);
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.draw-toolbar .draw-color-group .draw-color-btn.active {
  border-color: #1e293b;
  transform: scale(1.15);
}
.draw-toolbar .draw-color-group .draw-color-btn:hover:not(.active) {
  border-color: #94a3b8;
}
.draw-toolbar .draw-width-group {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: #e2e8f0;
  border-radius: 8px;
}
.draw-toolbar .draw-width-group .draw-width-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 8px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
}
.draw-toolbar .draw-width-group .draw-width-btn .width-preview {
  width: 20px;
  min-height: 1px;
  border-radius: 2px;
}
.draw-toolbar .draw-width-group .draw-width-btn .eraser-preview {
  border-radius: 50%;
  border: 2px solid #475569;
  background: rgba(148, 163, 184, 0.18);
  box-sizing: border-box;
  flex-shrink: 0;
}
.draw-toolbar .draw-width-group .draw-width-btn span {
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
}
.draw-toolbar .draw-width-group .draw-width-btn:hover {
  background: #f1f5f9;
}
.draw-toolbar .draw-width-group .draw-width-btn.active {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.draw-toolbar .draw-width-group .draw-width-btn.active span {
  color: #1a1a1a;
  font-weight: 600;
}
.draw-toolbar .draw-subtool-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 120;
  display: flex;
  align-items: center;
  gap: 3px;
  width: max-content;
  max-width: calc(100vw - 16px);
  padding: 5px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.2);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  animation: draw-subtool-drop 0.14s ease-out;
}
@keyframes draw-subtool-drop {
  from {
    opacity: 0;
    transform: translate(-50%, -8px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .draw-toolbar .draw-subtool-panel {
    animation: none;
    transform: translate(-50%, 0);
  }
}
.draw-toolbar .draw-subtool-panel-label {
  padding: 0 4px;
  font-size: 10px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}
.draw-toolbar .shape-tool-selector {
  align-items: stretch;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  max-height: calc(100vh - 150px);
  overflow: auto;
}
.draw-toolbar .shape-tool-category {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.draw-toolbar .shape-tool-category + .shape-tool-category {
  padding-top: 7px;
  border-top: 1px solid #e2e8f0;
}
.draw-toolbar .shape-tool-category-title {
  font-size: 11px;
  font-weight: 700;
  color: #334155;
}
.draw-toolbar .shape-tool-grid {
  display: grid;
  grid-template-columns: repeat(8, 64px);
  gap: 3px;
}
.draw-toolbar .shape-tool-grid .shape-option-btn {
  width: 64px;
  min-height: 54px;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  padding: 4px;
}
.draw-toolbar .shape-option-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 7px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
}
.draw-toolbar .shape-option-btn:hover {
  background: #e2e8f0;
}
.draw-toolbar .shape-option-btn.active {
  background: #1976d2;
  color: #fff;
}
.draw-toolbar .shape-option-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  overflow: visible;
}
.draw-toolbar .shape-option-icon path {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: butt;
  stroke-linejoin: miter;
  vector-effect: non-scaling-stroke;
}
.draw-toolbar .shape-option-btn span {
  font-size: 11px;
  font-weight: 500;
}

.draw-toolbar .line-style-option-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 8px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
}
.draw-toolbar .line-style-option-btn:hover {
  background: #e2e8f0;
}
.draw-toolbar .line-style-option-btn.active {
  background: #1976d2;
  color: #fff;
}
.draw-toolbar .line-style-option-icon {
  width: 40px;
  height: 12px;
  flex-shrink: 0;
  overflow: visible;
}
.draw-toolbar .line-style-option-icon line {
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: butt;
  vector-effect: non-scaling-stroke;
}
.draw-toolbar .line-style-option-btn span {
  font-size: 11px;
  font-weight: 500;
}
.draw-toolbar .fill-pattern-group {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: #e2e8f0;
  border-radius: 8px;
}
.draw-toolbar .fill-pattern-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.draw-toolbar .fill-pattern-btn:hover {
  background: #f1f5f9;
}
.draw-toolbar .fill-pattern-btn.active {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.draw-toolbar .fill-pattern-preview {
  width: 22px;
  height: 16px;
  border: 1px solid #94a3b8;
  border-radius: 3px;
  background-color: #fff;
  flex-shrink: 0;
}
.draw-toolbar .fill-pattern-preview.pattern-grid {
  background-image: repeating-linear-gradient(0deg, transparent 0 4px, #475569 4px 5px), repeating-linear-gradient(90deg, transparent 0 4px, #475569 4px 5px);
}
.draw-toolbar .fill-pattern-preview.pattern-diagonal-grid {
  background-image: repeating-linear-gradient(45deg, transparent 0 4px, #475569 4px 5px), repeating-linear-gradient(-45deg, transparent 0 4px, #475569 4px 5px);
}
.draw-toolbar .fill-pattern-preview.pattern-dots {
  background-image: radial-gradient(circle, #475569 1.4px, transparent 1.6px);
  background-size: 6px 6px;
}
.draw-toolbar .fill-pattern-preview.pattern-diagonal {
  background-image: repeating-linear-gradient(45deg, transparent 0 5px, #475569 5px 6px);
}
.draw-toolbar .fill-pattern-preview.pattern-dots-2 {
  background-image: radial-gradient(circle, transparent 0 1.5px, #475569 1.7px 2.4px, transparent 2.6px);
  background-size: 10px 10px;
}
.draw-toolbar .fill-pattern-preview.pattern-diagonal-2 {
  background-image: repeating-linear-gradient(-45deg, transparent 0 7px, #475569 7px 8px);
}
.draw-toolbar .fill-pattern-preview.pattern-cross {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath d='M2 5H8M5 2V8' fill='none' stroke='%23475569' stroke-width='1'/%3E%3C/svg%3E");
}
.draw-toolbar .fill-pattern-preview.pattern-exposed-rebar {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='16' viewBox='0 0 24 16'%3E%3Cpath d='M0 6H24M0 10H24M-4 2L4 14M-4 14L4 2M20 2L28 14M20 14L28 2' fill='none' stroke='%23475569' stroke-width='1'/%3E%3C/svg%3E");
}
.draw-toolbar .fill-pattern-preview.pattern-hybrid-grid {
  background-image: repeating-linear-gradient(45deg, transparent 0 4px, #475569 4px 5px), repeating-linear-gradient(-45deg, transparent 0 4px, #475569 4px 5px), repeating-linear-gradient(0deg, transparent 0 7px, #475569 7px 8px);
}
.draw-toolbar .fill-pattern-preview.pattern-triangle {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='16' viewBox='0 0 24 16'%3E%3Cpath d='M2 2H22L12 14Z' fill='none' stroke='%23475569' stroke-width='1.2'/%3E%3C/svg%3E");
}
.draw-toolbar .fill-pattern-name {
  display: none;
  font-size: 11px;
  color: #64748b;
}
.draw-toolbar .fill-pattern-btn.active .fill-pattern-name {
  color: #1e293b;
  font-weight: 600;
}
@media (min-width: 1024px) {
  .draw-toolbar .fill-pattern-name {
    display: inline;
  }
}

.draw-toolbar .draw-clear-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.draw-toolbar .draw-clear-btn i {
  font-size: 12px;
  color: #dc2626;
}
.draw-toolbar .draw-clear-btn span {
  font-size: 11px;
  font-weight: 500;
  color: #dc2626;
}
.draw-toolbar .draw-clear-btn:hover:not(:disabled) {
  background: #fee2e2;
  border-color: #fca5a5;
}
.draw-toolbar .draw-clear-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.placement-bar {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.85);
  border-radius: 16px;
  backdrop-filter: blur(8px);
  z-index: 60;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}
.placement-bar .placement-info {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  padding: 0 8px;
}
.placement-bar .placement-info i {
  font-size: 14px;
  color: #ff6b35;
}
.placement-bar button {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.placement-bar button.cancel-btn {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}
.placement-bar button.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.25);
}
.placement-bar button.confirm-btn {
  background: #16a34a;
  color: #fff;
}
.placement-bar button.confirm-btn:hover {
  background: #117f3a;
}
.placement-bar button.confirm-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.zoom-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: rgba(15, 23, 42, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 18px;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.28);
}
.zoom-controls .zoom-status {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 78px;
}
.zoom-controls .zoom-status i {
  font-size: 13px;
  color: #93c5fd;
}
.zoom-controls .zoom-status span {
  font-size: 13px;
  font-weight: 700;
  color: #f8fafc;
  letter-spacing: 0.01em;
}
.zoom-controls .zoom-slider {
  width: 160px;
  accent-color: #60a5fa;
  cursor: pointer;
  background: transparent;
}
.zoom-controls .zoom-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.zoom-controls .zm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, transform 0.15s;
}
.zoom-controls .zm-btn i {
  font-size: 15px;
  color: #f8fafc;
}
.zoom-controls .zm-btn:hover {
  background: rgba(96, 165, 250, 0.18);
  border-color: rgba(96, 165, 250, 0.4);
  transform: translateY(-1px);
}
.zoom-controls .zm-sep {
  width: 1px;
  height: 22px;
  background: rgba(255, 255, 255, 0.14);
}

.page-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  cursor: pointer;
  z-index: 50;
  transition: background 0.2s;
}
.page-nav-btn i {
  font-size: 14px;
  color: #fff;
}
.page-nav-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}
.page-nav-btn:active {
  background: rgba(0, 0, 0, 0.9);
}
.page-nav-btn.page-nav-left {
  left: 12px;
}
.page-nav-btn.page-nav-right {
  right: 12px;
}

.page-info-bar {
  padding: 4px 14px;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 16px;
  display: flex;
  align-items: center;
  align-self: center;
}
.page-info-bar span {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.damage-panel {
  position: absolute;
  top: 0;
  right: var(--viewer-safe-right);
  bottom: 0;
  width: 380px;
  height: auto;
  max-height: 100%;
  min-height: 0;
  background: #ffffff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 80;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.damage-panel.open {
  transform: translateX(0);
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}
.panel-header .panel-tabs {
  display: flex;
  gap: 4px;
}
.panel-header .panel-tabs .tab-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 14px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #666666;
  transition: all 0.15s;
}
.panel-header .panel-tabs .tab-btn i {
  font-size: 14px;
}
.panel-header .panel-tabs .tab-btn.active {
  background: #eff6ff;
  color: #1976d2;
  font-weight: 600;
}
.panel-header .panel-tabs .tab-btn:hover:not(.active) {
  background: #f8fafc;
}
.panel-header .close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
}
.panel-header .close-btn i {
  font-size: 16px;
  color: #94a3b8;
}
.panel-header .close-btn:hover {
  background: #f1f5f9;
}

.panel-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 12px 12px 16px;
  scrollbar-gutter: stable;
  -webkit-overflow-scrolling: touch;
}

.form-section {
  margin-bottom: 20px;
}
.form-section.marker-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 12px;
  margin-bottom: 16px;
}
.form-section.marker-header .marker-num {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
}
.form-section.marker-header .marker-info .marker-label {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
}
.form-section.marker-header .marker-info .marker-type {
  font-size: 12px;
  color: #666666;
  margin-top: 2px;
}
.form-section .section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
}
.form-section .section-title i {
  font-size: 13px;
  color: #1976d2;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}
.category-grid .cat-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 4px;
  border: 2px solid #e2e8f0;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.category-grid .cat-btn i {
  font-size: 16px;
  color: var(--cat-color, #666);
}
.category-grid .cat-btn span {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
}
.category-grid .cat-btn:hover {
  border-color: var(--cat-color, #999);
  background: #fafafa;
}
.category-grid .cat-btn.active {
  border-color: var(--cat-color, #1976d2);
  background: color-mix(in srgb, var(--cat-color, #1976d2) 8%, #fff);
}
.category-grid .cat-btn.active i {
  color: var(--cat-color, #1976d2);
}
.category-grid .cat-btn.active span {
  color: #1a1a1a;
  font-weight: 600;
}

.sub-types {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}
.sub-types .sub-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid #e2e8f0;
  background: #fff;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.15s;
}
.sub-types .sub-btn span {
  font-size: 12px;
  color: #64748b;
}
.sub-types .sub-btn .sub-count {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(59, 130, 246, 0.14);
  color: #1976d2;
  font-size: 11px;
  font-weight: 700;
}
.sub-types .sub-btn:hover {
  border-color: #1976d2;
}
.sub-types .sub-btn.active {
  border-color: #1976d2;
  background: #eff6ff;
}
.sub-types .sub-btn.active span {
  color: #1976d2;
  font-weight: 600;
}

.selection-guide {
  margin-top: 8px;
  font-size: 12px;
  color: #666666;
  line-height: 1.45;
}

.selected-subtypes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.selected-subtype-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1976d2;
  font-size: 12px;
  font-weight: 600;
}

.selected-subtype-remove {
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: rgba(37, 99, 235, 0.12);
  color: #1976d2;
  cursor: pointer;
  transition: background 0.15s ease;
}
.selected-subtype-remove:hover {
  background: rgba(37, 99, 235, 0.2);
}
.selected-subtype-remove i {
  font-size: 10px;
}

.custom-input-wrap {
  margin-top: 10px;
}
.custom-input-wrap .custom-input-row {
  display: flex;
  gap: 8px;
}
.custom-input-wrap .custom-add-btn {
  min-width: 72px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}
.custom-input-wrap .custom-add-btn:hover:not(:disabled) {
  border-color: #1976d2;
  color: #1976d2;
}
.custom-input-wrap .custom-add-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.grade-row {
  display: flex;
  gap: 6px;
}
.grade-row .grade-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 10px 4px;
  border: 2px solid #e2e8f0;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.grade-row .grade-btn .grade-value {
  font-size: 18px;
  font-weight: 800;
  color: var(--grade-color, #999);
}
.grade-row .grade-btn .grade-label {
  font-size: 10px;
  font-weight: 500;
  color: #94a3b8;
}
.grade-row .grade-btn:hover {
  border-color: var(--grade-color, #999);
}
.grade-row .grade-btn.active {
  border-color: var(--grade-color, #1976d2);
  background: color-mix(in srgb, var(--grade-color, #1976d2) 10%, #fff);
}
.grade-row .grade-btn.active .grade-value {
  color: var(--grade-color, #1976d2);
}
.grade-row .grade-btn.active .grade-label {
  color: #1a1a1a;
  font-weight: 600;
}

.measure-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.measure-grid .measure-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.measure-grid .measure-item label {
  font-size: 12px;
  font-weight: 500;
  color: #666666;
}
.measure-grid .measure-item .input-wrap {
  display: flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s;
}
.measure-grid .measure-item .input-wrap:focus-within {
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}
.measure-grid .measure-item .input-wrap input {
  flex: 1;
  padding: 8px 10px;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  min-width: 0;
  -moz-appearance: textfield;
}
.measure-grid .measure-item .input-wrap input::-webkit-outer-spin-button, .measure-grid .measure-item .input-wrap input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.measure-grid .measure-item .input-wrap .unit {
  padding: 0 10px;
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  background: #f8fafc;
  height: 100%;
  display: flex;
  align-items: center;
  border-left: 1px solid #e2e8f0;
}

.memo-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #1a1a1a;
  resize: vertical;
  min-height: 80px;
  outline: none;
  font-family: inherit;
  transition: border-color 0.15s;
}
.memo-input:focus {
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.text-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  font-family: inherit;
  transition: border-color 0.15s;
}
.text-input:focus {
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}
.text-input::placeholder {
  color: #94a3b8;
}

.member-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.member-grid .member-btn {
  padding: 6px 14px;
  border: 1px solid #e2e8f0;
  background: #fff;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.15s;
}
.member-grid .member-btn span {
  font-size: 12px;
  color: #64748b;
}
.member-grid .member-btn:hover {
  border-color: #1976d2;
}
.member-grid .member-btn.active {
  border-color: #1976d2;
  background: #eff6ff;
}
.member-grid .member-btn.active span {
  color: #1976d2;
  font-weight: 600;
}

.size-inputs {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.size-inputs .size-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.size-inputs .size-row label {
  min-width: 50px;
  font-size: 12px;
  font-weight: 500;
  color: #666666;
}
.size-inputs .size-row .size-label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.size-inputs .size-row .size-label .size-check {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #1976d2;
  cursor: pointer;
  flex-shrink: 0;
}
.size-inputs .size-row .size-label span {
  white-space: nowrap;
}
.size-inputs .size-row .size-input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s;
}
.size-inputs .size-row .size-input-wrap:focus-within {
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}
.size-inputs .size-row .size-input-wrap input {
  flex: 1;
  padding: 8px 10px;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  min-width: 0;
  -moz-appearance: textfield;
}
.size-inputs .size-row .size-input-wrap input::-webkit-outer-spin-button, .size-inputs .size-row .size-input-wrap input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.size-inputs .size-row .size-input-wrap .unit-select {
  padding: 0 8px;
  border: none;
  border-left: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  outline: none;
  height: 36px;
}
.size-inputs .size-row .size-input-wrap .unit-label {
  padding: 0 10px;
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  background: #f8fafc;
  height: 100%;
  display: flex;
  align-items: center;
  border-left: 1px solid #e2e8f0;
}

.quantity-display {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 14px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
}
.quantity-display .quantity-label {
  font-size: 12px;
  font-weight: 500;
  color: #16a34a;
}
.quantity-display .quantity-value {
  font-size: 18px;
  font-weight: 700;
  color: #15803d;
  margin-left: auto;
}
.quantity-display .quantity-unit {
  font-size: 13px;
  font-weight: 500;
  color: #16a34a;
}

.quantity-input-row .size-input-wrap {
  display: flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s;
}
.quantity-input-row .size-input-wrap:focus-within {
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}
.quantity-input-row .size-input-wrap input {
  flex: 1;
  padding: 10px 12px;
  border: none;
  outline: none;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  min-width: 0;
  -moz-appearance: textfield;
}
.quantity-input-row .size-input-wrap input::-webkit-outer-spin-button, .quantity-input-row .size-input-wrap input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.quantity-input-row .size-input-wrap .unit-select {
  padding: 0 10px;
  border: none;
  border-left: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  outline: none;
  height: 42px;
}

.quantity-hint {
  margin-top: 6px;
  font-size: 11px;
  color: #16a34a;
  display: flex;
  align-items: center;
  gap: 4px;
}
.quantity-hint::before {
  content: "\f058";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  font-size: 11px;
}

.remark-toggle {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.remark-toggle .remark-btn {
  flex: 1 1 calc(33.333% - 8px);
  min-width: 72px;
  padding: 10px;
  border: 2px solid #e2e8f0;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  transition: all 0.15s;
}
.remark-toggle .remark-btn span {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
}
.remark-toggle .remark-btn:hover {
  border-color: #94a3b8;
}
.remark-toggle .remark-btn.active span {
  font-weight: 600;
}
.remark-toggle .remark-btn.remark-existing.active {
  border-color: #64748b;
  background: #f1f5f9;
}
.remark-toggle .remark-btn.remark-existing.active span {
  color: #475569;
}
.remark-toggle .remark-btn.remark-new.active {
  border-color: #3b82f6;
  background: #eff6ff;
}
.remark-toggle .remark-btn.remark-new.active span {
  color: #3b82f6;
}
.remark-toggle .remark-btn.remark-repair.active {
  border-color: #f59e0b;
  background: #fffbeb;
}
.remark-toggle .remark-btn.remark-repair.active span {
  color: #f59e0b;
}
.remark-toggle .remark-btn.remark-repair-part.active {
  border-color: #8b5cf6;
  background: #f5f3ff;
}
.remark-toggle .remark-btn.remark-repair-part.active span {
  color: #7c3aed;
}
.remark-toggle .remark-btn.remark-increase.active {
  border-color: #16a34a;
  background: #f0fdf4;
}
.remark-toggle .remark-btn.remark-increase.active span {
  color: #16a34a;
}

.photo-capture-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  border: 2px dashed #cbd5e1;
  background: #f8fafc;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 10px;
}
.photo-capture-btn i {
  font-size: 18px;
  color: #1976d2;
}
.photo-capture-btn span {
  font-size: 13px;
  font-weight: 600;
  color: #1976d2;
}
.photo-capture-btn:hover {
  border-color: #1976d2;
  background: #eff6ff;
}

.photo-helper-text {
  margin-bottom: 10px;
  font-size: 11px;
  line-height: 1.5;
  color: #64748b;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.photo-grid .photo-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #e2e8f0;
}
.photo-grid .photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.photo-grid .photo-item .photo-primary-toggle {
  position: absolute;
  left: 6px;
  bottom: 6px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border: none;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.78);
  color: #e2e8f0;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;
}
.photo-grid .photo-item .photo-primary-toggle i {
  font-size: 11px;
}
.photo-grid .photo-item .photo-primary-toggle:hover {
  background: rgba(15, 23, 42, 0.92);
  transform: translateY(-1px);
}
.photo-grid .photo-item .photo-primary-toggle.active {
  background: rgba(22, 163, 74, 0.92);
  color: #ffffff;
}
.photo-grid .photo-item .photo-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  cursor: pointer;
}
.photo-grid .photo-item .photo-remove i {
  font-size: 10px;
  color: #fff;
}
.photo-grid .photo-item .photo-remove:hover {
  background: #dc2626;
}

.form-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  padding: 12px 12px calc(12px + var(--viewer-safe-bottom));
  border-top: 1px solid #e2e8f0;
  margin-top: 0;
  background: #ffffff;
  box-shadow: 0 -8px 20px rgba(15, 23, 42, 0.08);
}
.form-actions button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.form-actions button.delete-btn {
  background: #fef2f2;
  color: #dc2626;
}
.form-actions button.delete-btn:hover {
  background: #fee2e2;
}
.form-actions button.save-form-btn {
  background: #1976d2;
  color: #fff;
}
.form-actions button.save-form-btn:hover {
  background: #1565c0;
}

.damage-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}
.damage-list-empty i {
  font-size: 48px;
  color: #e2e8f0;
  margin-bottom: 16px;
}
.damage-list-empty p {
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  margin: 0;
}
.damage-list-empty .sub-text {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 4px;
}

.damage-list-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.damage-list-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 0 10px;
}
.damage-list-actions .damage-check-all {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
}
.damage-list-actions .damage-check-all input {
  width: 16px;
  height: 16px;
  accent-color: #1976d2;
  cursor: pointer;
}
.damage-list-actions .damage-list-action-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.damage-list-actions .damage-selected-count {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}
.damage-list-actions .damage-delete-selected-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  border-radius: 10px;
  background: #fef2f2;
  color: #dc2626;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
}
.damage-list-actions .damage-delete-selected-btn:hover:not(:disabled) {
  background: #fee2e2;
}
.damage-list-actions .damage-delete-selected-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.damage-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #f8fafc;
  border: 2px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.15s;
}
.damage-card:hover {
  background: #f1f5f9;
}
.damage-card.selected {
  border-color: #1976d2;
  background: #eff6ff;
}
.damage-card .damage-check {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
}
.damage-card .damage-check input {
  width: 16px;
  height: 16px;
  accent-color: #1976d2;
  cursor: pointer;
}
.damage-card .damage-num {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}
.damage-card .damage-info {
  flex: 1;
  min-width: 0;
}
.damage-card .damage-info .damage-top-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.damage-card .damage-info .damage-type-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
}
.damage-card .damage-info .damage-photo-thumb {
  position: relative;
  width: 56px;
  height: 56px;
  padding: 0;
  border: none;
  border-radius: 12px;
  overflow: hidden;
  background: #e2e8f0;
  box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.24);
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.15s, box-shadow 0.15s;
}
.damage-card .damage-info .damage-photo-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.damage-card .damage-info .damage-photo-thumb:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.18);
}
.damage-card .damage-info .damage-photo-count {
  position: absolute;
  right: 4px;
  bottom: 4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.84);
  color: #f8fafc;
  font-size: 10px;
  font-weight: 700;
}
.damage-card .damage-info .damage-sub-inline {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}
.damage-card .damage-info .damage-location-text {
  font-size: 11px;
  color: #666666;
  margin-top: 2px;
}
.damage-card .damage-info .damage-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}
.damage-card .damage-info .damage-meta .meta-badge {
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
}
.damage-card .damage-info .damage-meta .meta-badge.remark-existing {
  background: #64748b;
}
.damage-card .damage-info .damage-meta .meta-badge.remark-new {
  background: #3b82f6;
}
.damage-card .damage-info .damage-meta .meta-badge.remark-repair {
  background: #f59e0b;
}
.damage-card .damage-info .damage-meta .meta-badge.remark-repair-part {
  background: #8b5cf6;
}
.damage-card .damage-info .damage-meta .meta-badge.remark-increase {
  background: #16a34a;
}
.damage-card .damage-info .damage-meta .meta-text {
  font-size: 10px;
  color: #94a3b8;
}
.damage-card .damage-arrow {
  flex-shrink: 0;
}
.damage-card .damage-arrow i {
  font-size: 12px;
  color: #cbd5e1;
}

.sync-conflict-modal {
  position: fixed;
  inset: 0;
  z-index: 158;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.64);
  backdrop-filter: blur(4px);
}

.sync-conflict-dialog {
  width: min(1120px, 100%);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 28px 72px rgba(15, 23, 42, 0.28);
}

.sync-conflict-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.sync-conflict-copy {
  min-width: 0;
}

.sync-conflict-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}
.sync-conflict-title i {
  color: #b45309;
}

.sync-conflict-subtitle {
  margin-top: 3px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.sync-conflict-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sync-conflict-icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
  transition: background 0.15s;
}
.sync-conflict-icon:hover {
  background: #e2e8f0;
}
.sync-conflict-icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.sync-conflict-body {
  flex: 1;
  overflow: auto;
  padding: 16px;
  background: #f8fafc;
}

.sync-conflict-loading,
.sync-conflict-empty {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  background: #fff;
  color: #475569;
  text-align: center;
}
.sync-conflict-loading i,
.sync-conflict-empty i {
  font-size: 28px;
  color: #94a3b8;
}
.sync-conflict-loading p,
.sync-conflict-loading span,
.sync-conflict-empty p,
.sync-conflict-empty span {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
}

.sync-conflict-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sync-conflict-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.sync-conflict-card-head {
  padding: 14px 16px 12px;
  border-bottom: 1px solid #e2e8f0;
}

.sync-conflict-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.sync-conflict-type,
.sync-conflict-action,
.sync-conflict-time {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
}

.sync-conflict-type {
  background: #eff6ff;
  color: #1d4ed8;
}

.sync-conflict-action {
  background: #fef3c7;
  color: #92400e;
}

.sync-conflict-time {
  background: #f1f5f9;
  color: #475569;
}

.sync-conflict-card-title {
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.35;
}

.sync-conflict-audit {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.sync-conflict-audit span {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.sync-conflict-compare {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
}

.sync-conflict-side {
  padding: 14px 16px;
}
.sync-conflict-side.server {
  border-right: 1px solid #e2e8f0;
  background: #fbfdff;
}
.sync-conflict-side.client {
  background: #fffdf7;
}

.sync-conflict-side-title {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}
.sync-conflict-side-title i {
  color: #475569;
}

.sync-conflict-field {
  display: grid;
  grid-template-columns: 74px minmax(0, 1fr);
  gap: 10px;
  padding: 6px 0;
  border-top: 1px solid #edf2f7;
}
.sync-conflict-field:first-of-type {
  border-top: none;
}
.sync-conflict-field .field-label {
  font-size: 12px;
  font-weight: 800;
  color: #64748b;
}
.sync-conflict-field .field-value {
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  word-break: break-word;
}

.sync-conflict-field-diff {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.field-diff-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}
.field-diff-row span {
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
}
.field-diff-row strong {
  min-width: 0;
  font-size: 12px;
  font-weight: 800;
  color: #0f172a;
  word-break: break-word;
}

.sync-conflict-reason {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
}
.sync-conflict-reason label {
  font-size: 12px;
  font-weight: 800;
  color: #334155;
}
.sync-conflict-reason textarea {
  width: 100%;
  min-height: 68px;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 10px 12px;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.45;
  outline: none;
}
.sync-conflict-reason textarea:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.sync-conflict-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
}

.keep-server-btn,
.keep-client-btn {
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;
}
.keep-server-btn:hover,
.keep-client-btn:hover {
  transform: translateY(-1px);
}
.keep-server-btn:disabled,
.keep-client-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}

.keep-server-btn {
  background: #e2e8f0;
  color: #0f172a;
}
.keep-server-btn:hover {
  background: #cbd5e1;
}

.keep-client-btn {
  background: #2563eb;
  color: #fff;
}
.keep-client-btn:hover {
  background: #1d4ed8;
}

.sync-conflict-history {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sync-conflict-history-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #334155;
  font-size: 13px;
  font-weight: 800;
}
.sync-conflict-history-title i {
  color: #64748b;
}

.sync-conflict-history-card {
  display: grid;
  grid-template-columns: minmax(180px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(140px, 0.8fr);
  gap: 10px;
  align-items: start;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  color: #334155;
  font-size: 12px;
}

.history-main,
.history-audit {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.history-main strong,
.history-audit strong {
  color: #0f172a;
  font-size: 13px;
  line-height: 1.35;
}
.history-main span,
.history-audit span {
  color: #64748b;
  font-weight: 700;
  line-height: 1.35;
}

.history-reason,
.history-diff {
  min-width: 0;
  color: #334155;
  font-weight: 700;
  line-height: 1.4;
  word-break: break-word;
}

.damage-photo-preview {
  position: fixed;
  inset: 0;
  z-index: 160;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(2, 6, 23, 0.76);
  backdrop-filter: blur(6px);
}

.overview-photo-modal {
  position: fixed;
  inset: 0;
  z-index: 155;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.64);
  backdrop-filter: blur(4px);
}

.overview-photo-dialog {
  width: min(980px, 100%);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 32px 80px rgba(15, 23, 42, 0.28);
}

.overview-photo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #ffffff, #f8fafc);
}

.overview-photo-copy {
  min-width: 0;
}

.overview-photo-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
}

.overview-photo-subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.overview-photo-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.overview-photo-add,
.overview-photo-close,
.overview-photo-done {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;
}

.overview-photo-add {
  height: 40px;
  padding: 0 14px;
  border-radius: 12px;
  background: #2563eb;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}
.overview-photo-add:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
}

.overview-photo-close {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #334155;
}
.overview-photo-close:hover {
  background: #e2e8f0;
  transform: translateY(-1px);
}

.overview-photo-body {
  flex: 1;
  overflow: auto;
  padding: 24px;
  background: #f8fafc;
}

.overview-photo-empty {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 20px;
  background: #fff;
  color: #475569;
  text-align: center;
}
.overview-photo-empty i {
  font-size: 34px;
  color: #94a3b8;
}
.overview-photo-empty p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.overview-photo-empty .sub-text {
  max-width: 420px;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.5;
}

.overview-photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

.overview-photo-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
}

.overview-photo-preview {
  position: relative;
  aspect-ratio: 4/3;
  border-radius: 14px;
  overflow: hidden;
  background: #e2e8f0;
}
.overview-photo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.overview-photo-remove {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.7);
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;
}
.overview-photo-remove:hover {
  background: rgba(220, 38, 38, 0.88);
}

.overview-photo-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.overview-photo-name {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.overview-photo-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  font-size: 13px;
  color: #0f172a;
}
.overview-photo-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.overview-photo-filename {
  font-size: 12px;
  color: #64748b;
  word-break: break-all;
}

.overview-photo-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px 20px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
}

.overview-photo-guide {
  font-size: 13px;
  color: #64748b;
}

.overview-photo-done {
  height: 40px;
  padding: 0 16px;
  border-radius: 12px;
  background: #0f172a;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}
.overview-photo-done:hover {
  background: #1e293b;
  transform: translateY(-1px);
}

.damage-photo-dialog {
  width: min(920px, 100%);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #0f172a;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.48);
}

.damage-photo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 22px 14px;
  background: linear-gradient(180deg, rgba(30, 41, 59, 0.92), rgba(15, 23, 42, 0.96));
  border-bottom: 1px solid rgba(148, 163, 184, 0.14);
}

.damage-photo-copy {
  min-width: 0;
}

.damage-photo-title {
  font-size: 18px;
  font-weight: 700;
  color: #f8fafc;
}

.damage-photo-subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #cbd5e1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.damage-photo-close {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  color: #f8fafc;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;
}
.damage-photo-close:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-1px);
}

.damage-photo-stage {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 20px;
  min-height: 420px;
  background: radial-gradient(circle at top, rgba(59, 130, 246, 0.15), transparent 44%), #020617;
}

.damage-photo-frame {
  flex: 1;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(255, 255, 255, 0.04);
}
.damage-photo-frame img {
  max-width: 100%;
  max-height: calc(100vh - 280px);
  object-fit: contain;
  display: block;
}

.damage-photo-nav {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.72);
  color: #f8fafc;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, transform 0.15s;
}
.damage-photo-nav:hover {
  background: rgba(30, 41, 59, 0.92);
  transform: translateY(-1px);
}

.damage-photo-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px 20px;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
  background: #0f172a;
}

.damage-photo-counter {
  font-size: 13px;
  font-weight: 700;
  color: #e2e8f0;
  white-space: nowrap;
}

.damage-photo-strip {
  flex: 1;
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 2px;
  -webkit-overflow-scrolling: touch;
}
.damage-photo-strip::-webkit-scrollbar {
  height: 6px;
}
.damage-photo-strip::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.3);
  border-radius: 999px;
}

.damage-photo-strip-item {
  width: 64px;
  height: 64px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 14px;
  overflow: hidden;
  background: #1e293b;
  opacity: 0.72;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.15s, border-color 0.15s, transform 0.15s;
}
.damage-photo-strip-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.damage-photo-strip-item:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}
.damage-photo-strip-item.active {
  opacity: 1;
  border-color: #60a5fa;
  box-shadow: 0 10px 22px rgba(59, 130, 246, 0.24);
}

.viewer-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.65);
  z-index: 200;
}
.viewer-loading .loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.viewer-loading .loading-spinner i {
  font-size: 40px;
  color: #fff;
}
.viewer-loading .loading-text {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 1024px) {
  .viewer-toolbar {
    padding: 4px 8px;
  }
  .viewer-toolbar .toolbar-center .tool-group .mode-btn {
    padding: 6px 8px;
  }
  .viewer-toolbar .toolbar-center .tool-group .mode-btn span {
    display: none;
  }
  .viewer-toolbar .toolbar-right .damage-count {
    display: none;
  }
  .viewer-toolbar .toolbar-right .conflict-btn .conflict-text {
    display: none;
  }
  .viewer-toolbar .toolbar-right .save-btn .save-text {
    display: none;
  }
  .viewer-toolbar .toolbar-right .export-btn .save-text {
    display: none;
  }
  .damage-panel {
    width: 340px;
  }
  .damage-card .damage-info .damage-photo-thumb {
    width: 50px;
    height: 50px;
  }
  .damage-photo-stage {
    min-height: 360px;
  }
  .page-sidebar {
    width: 108px;
  }
  .page-sidebar.collapsed {
    width: 40px;
  }
  .page-sidebar .page-sidebar-header {
    padding: 10px 10px 8px;
  }
  .page-sidebar .page-sidebar-header span {
    font-size: 11px;
  }
  .page-sidebar .page-thumbnail-list {
    padding: 8px 6px 12px;
    gap: 8px;
  }
  .page-sidebar .page-thumbnail {
    padding: 6px;
    border-radius: 12px;
  }
  .page-sidebar .page-thumbnail-preview,
  .page-sidebar .page-thumbnail-placeholder {
    min-height: 100px;
  }
  .page-sidebar .page-thumbnail-number {
    font-size: 10px;
  }
  .point-toolbar {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .point-toolbar .point-section-label {
    display: none;
  }
  .point-toolbar .point-tool-group .point-tool-btn span {
    display: none !important;
  }
  .point-toolbar .point-helper span {
    display: none;
  }
  .point-toolbar .point-clear-btn span {
    display: none;
  }
  .draw-toolbar .draw-section-label {
    display: none;
  }
  .draw-toolbar .draw-tool-group .draw-tool-btn span {
    display: none !important;
  }
  .draw-toolbar .draw-width-group .draw-width-btn span {
    display: none;
  }
  .draw-toolbar .draw-clear-btn span {
    display: none;
  }
}
@media (max-width: 768px) {
  .viewer-toolbar {
    flex-wrap: wrap;
    gap: 4px;
    padding: 4px 6px;
  }
  .viewer-toolbar .toolbar-left {
    order: 1;
    flex: 1;
  }
  .viewer-toolbar .toolbar-left .tb-info .tb-sub {
    display: none;
  }
  .viewer-toolbar .toolbar-right {
    order: 2;
  }
  .viewer-toolbar .toolbar-center {
    order: 3;
    width: 100%;
    justify-content: center;
  }
  .viewer-toolbar .toolbar-center .tool-group {
    width: 100%;
    justify-content: center;
  }
  .point-toolbar {
    padding: 4px 4px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .point-toolbar .point-toolbar-inner {
    gap: 4px;
    width: max-content;
    justify-content: flex-start;
  }
  .point-toolbar .point-sep {
    height: 24px;
  }
  .draw-toolbar {
    padding: 4px 4px;
  }
  .draw-toolbar .draw-toolbar-inner {
    gap: 4px;
  }
  .draw-toolbar .draw-sep {
    height: 24px;
  }
  .draw-toolbar .draw-color-group .draw-color-btn {
    width: 22px;
    height: 22px;
  }
  .damage-panel {
    width: 100%;
    max-width: 100%;
  }
  .photo-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .photo-grid .photo-item .photo-primary-toggle span {
    display: none;
  }
  .damage-card {
    align-items: flex-start;
  }
  .damage-card .damage-info .damage-top-row {
    gap: 8px;
  }
  .damage-card .damage-info .damage-photo-thumb {
    width: 46px;
    height: 46px;
    border-radius: 10px;
  }
  .damage-photo-preview {
    padding: 12px;
  }
  .overview-photo-modal {
    padding: 12px;
  }
  .sync-conflict-modal {
    padding: 12px;
  }
  .sync-conflict-dialog {
    max-height: calc(100vh - 24px);
    border-radius: 14px;
  }
  .sync-conflict-header {
    padding: 14px 16px;
  }
  .sync-conflict-title {
    font-size: 16px;
  }
  .sync-conflict-body {
    padding: 12px;
  }
  .sync-conflict-compare {
    grid-template-columns: 1fr;
  }
  .sync-conflict-field-diff,
  .sync-conflict-history-card {
    grid-template-columns: 1fr;
  }
  .sync-conflict-side.server {
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
  }
  .sync-conflict-card-actions {
    flex-direction: column;
  }
  .keep-server-btn,
  .keep-client-btn {
    width: 100%;
  }
  .overview-photo-dialog {
    max-height: calc(100vh - 24px);
    border-radius: 18px;
  }
  .overview-photo-header {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }
  .overview-photo-header-actions {
    justify-content: space-between;
  }
  .overview-photo-add {
    flex: 1;
  }
  .overview-photo-body {
    padding: 16px;
  }
  .overview-photo-grid {
    grid-template-columns: 1fr;
  }
  .overview-photo-footer {
    flex-direction: column;
    align-items: stretch;
    padding: 14px 16px 16px;
  }
  .overview-photo-done {
    width: 100%;
  }
  .damage-photo-dialog {
    max-height: calc(100vh - 24px);
    border-radius: 18px;
  }
  .damage-photo-header {
    padding: 16px 16px 12px;
  }
  .damage-photo-title {
    font-size: 16px;
  }
  .damage-photo-subtitle {
    font-size: 12px;
  }
  .damage-photo-stage {
    gap: 8px;
    min-height: 300px;
    padding: 12px 8px;
  }
  .damage-photo-frame {
    min-height: 240px;
  }
  .damage-photo-frame img {
    max-height: calc(100vh - 250px);
  }
  .damage-photo-nav {
    width: 40px;
    height: 40px;
  }
  .damage-photo-footer {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px 16px 16px;
  }
  .damage-photo-strip-item {
    width: 56px;
    height: 56px;
  }
  .page-sidebar {
    width: 86px;
  }
  .page-sidebar.collapsed {
    width: 34px;
  }
  .page-sidebar .page-sidebar-header {
    padding: 10px 6px 8px;
  }
  .page-sidebar .page-sidebar-header .page-sidebar-title span {
    display: none;
  }
  .page-sidebar .page-thumbnail-list {
    padding: 8px 5px 10px;
    gap: 6px;
  }
  .page-sidebar .page-thumbnail {
    padding: 5px;
    gap: 6px;
  }
  .page-sidebar .page-thumbnail-preview,
  .page-sidebar .page-thumbnail-placeholder {
    min-height: 82px;
  }
  .page-sidebar .page-thumbnail-meta {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
  }
  .page-sidebar .page-thumbnail-number {
    font-size: 10px;
  }
  .viewer-top-controls {
    top: 10px;
    right: 10px;
    gap: 6px;
    max-width: calc(100% - 20px);
  }
  .zoom-controls {
    gap: 6px;
    padding: 6px 8px;
  }
  .zoom-controls .zoom-status {
    min-width: 68px;
  }
  .zoom-controls .zoom-status span {
    font-size: 12px;
  }
  .zoom-controls .zoom-slider {
    width: 108px;
  }
  .zoom-controls .zoom-actions {
    gap: 6px;
  }
  .zoom-controls .zm-btn {
    width: 30px;
    height: 30px;
  }
  .page-info-bar {
    padding: 4px 10px;
  }
  .page-info-bar span {
    font-size: 11px;
  }
  .category-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .category-grid .cat-btn {
    padding: 8px 2px;
  }
  .category-grid .cat-btn i {
    font-size: 14px;
  }
  .category-grid .cat-btn span {
    font-size: 10px;
  }
  .grade-row .grade-btn {
    padding: 8px 2px;
  }
  .grade-row .grade-btn .grade-value {
    font-size: 16px;
  }
  .measure-grid {
    grid-template-columns: 1fr 1fr;
  }
}`],
})
export class PageInspectionViewerComponent implements OnInit, OnDestroy {
    public Math = Math;

    // ========== Route Parameters ==========
    public facilityId = '';
    public drawingId = '';

    // ========== Data ==========
    public facility: any = null;
    public drawing: any = null;
    public project: any = null;
    public isLoading = true;
    public syncState: any = { workspace_id: '', revision: 0, conflict_count: 0, conflicts: [] };
    public syncConflicts: any[] = [];
    public resolvedSyncConflicts: any[] = [];
    public conflictResolutionReasons: { [id: string]: string } = {};
    public conflictModalVisible = false;
    public isLoadingConflicts = false;
    public resolvingConflictId = '';
    private syncClientId: string = this.resolveSyncClientId();
    private lastSavedEntityState: any = { damage: {}, annotation: {} };
    private localDraftTimer: any = null;
    private localDraftWatchTimer: any = null;
    private localDraftVisibilityHandler: any = null;
    private localDraftWrite: Promise<void> = Promise.resolve();
    private localDraftVersion = 0;
    private localDraftLastWatchSignature = '';
    private localDraftPhotoSignatures: { [id: string]: string } = {};
    private localDraftDirty = false;
    private localDraftRestored = false;

    // ========== PDF ==========
    public pdfDoc: any = null;
    public currentPage = 1;
    public totalPages = 1;
    public sourcePageCount = 1;
    public blankPageCount = 0;
    public blankPageIds: string[] = [];
    public isAddingPage = false;
    public deletingBlankPage = 0;
    public pdfCanvas: HTMLCanvasElement | null = null;
    public pdfCtx: CanvasRenderingContext2D | null = null;
    public annotCanvas: HTMLCanvasElement | null = null;
    public annotCtx: CanvasRenderingContext2D | null = null;
    public pageThumbnails: Array<{ page: number; dataUrl: string; loading: boolean }> = [];
    public isPageSidebarCollapsed = false;

    // ========== Pan / Zoom ==========
    public zoomLevel = 1;
    public panX = 0;
    public panY = 0;
    public pageRotations: { [page: string]: number } = {};
    public drawingNamesByPage: { [page: string]: string } = {};
    public legacyRotationDegrees = 0;
    public isPanning = false;
    public panStartX = 0;
    public panStartY = 0;
    public panStartPanX = 0;
    public panStartPanY = 0;

    // ========== Pinch ==========
    public isPinching = false;
    public pinchStartDist = 0;
    public pinchStartZoom = 1;
    public pinchMidX = 0;
    public pinchMidY = 0;

    // ========== Tap Detection ==========
    public tapStartTime = 0;
    public tapStartPos = { x: 0, y: 0 };
    public wasTap = false;

    // ========== Tool Mode ==========
    public currentMode = 'pan';
    public pointTool = 'add';

    // ========== Damages ==========
    public damages: any[] = [];
    public selectedDamage: any = null;
    public damageCounter = 0;

    // ========== Marker Drag ==========
    public isDraggingMarker = false;
    public dragTarget: any = null;

    // ========== Arrow Drag (Long Press) ==========
    public isArrowDragging = false;
    public arrowDragTarget: any = null;
    public longPressTimer: any = null;
    public longPressStartPos = { x: 0, y: 0 };

    // ========== Export ==========
    public exporting = false;
    public isSaving = false;
    public hasSavedExportFiles = false;
    public exportStage: 'idle' | 'saving' | 'exporting' = 'idle';
    public offlineMissingItems: any[] = [];
    public viewerDataFromOfflineCache = false;

    // ========== UI Panel ==========
    public showPanel = false;
    public panelMode = 'form';
    public formData: any = this.newFormData();
    public checkedDamageIds: string[] = [];
    public facilityOverviewPhotos: any[] = [];
    public overviewPhotoModalVisible = false;
    public photoPreviewVisible = false;
    public photoPreviewDamage: any = null;
    public photoPreviewPhotos: any[] = [];
    public photoPreviewIndex = 0;

    // ========== Drawing Shape Move (Long Press) ==========
    public drawingShapeLongPressTimer: any = null;
    public drawingShapeLongPressStartPos = { x: 0, y: 0 };
    public isMovingDrawingShape = false;
    public movingDrawingShape: any = null;
    public drawingShapeMoveStartPoint: { x: number; y: number } | null = null;
    public drawingShapeMoveOriginalPoints: any[] = [];

    // ========== Drawing (마커 드로잉) ==========
    public drawCanvas: HTMLCanvasElement | null = null;
    public drawCtx: CanvasRenderingContext2D | null = null;
    public drawings: any[] = [];
    public isDrawing = false;
    public currentStroke: any = null;
    public drawColor = '#000000';
    public drawWidth = 1;
    public eraserSize = 24;
    public drawTool = 'freehand'; // freehand, line, rect, ellipse, retaining-wall, pier, fill, arrow, eraser
    public shapeTool = 'rect';
    public showShapeMenu = false;
    public lineStyle = 'solid';
    public showLineStyleMenu = false;
    public fillPattern = 'grid';
    public showFillPatternMenu = false;
    public drawStartPoint: { x: number; y: number } | null = null;
    public showDrawToolbar = false;

    // ========== Drawing Grid ==========
    public gridEnabled = false;
    public showGridToolbar = false;
    public gridSpacing = 40;
    public gridBrightness = 25;
    public readonly GRID_SPACING_MIN = 16;
    public readonly GRID_SPACING_MAX = 120;
    public readonly GRID_BRIGHTNESS_MIN = 10;
    public readonly GRID_BRIGHTNESS_MAX = 70;

    public eraserCursor = { visible: false, x: 0, y: 0 };

    // ========== Undo / Redo ==========
    public undoStack: any[] = [];
    public redoStack: any[] = [];

    public DRAW_COLORS = [
        { color: '#ef4444', name: '빨강' },
        { color: '#3b82f6', name: '파랑' },
        { color: '#22c55e', name: '초록' },
        { color: '#000000', name: '검정' },
        { color: '#eab308', name: '노랑' },
        { color: '#a855f7', name: '보라' },
        { color: '#f97316', name: '주황' },
        { color: '#ffffff', name: '흰색' }
    ];

    public DRAW_WIDTHS = [
        { value: 1, name: '얇게' },
        { value: 3, name: '보통' },
        { value: 5, name: '굵게' },
        { value: 8, name: '매우 굵게' }
    ];

    public ERASER_SIZES = [
        { value: 12, name: '작게' },
        { value: 24, name: '보통' },
        { value: 36, name: '크게' },
        { value: 52, name: '매우 크게' }
    ];

    public SHAPE_TOOL_CATEGORIES = ['도형', '건축', '토목'];

    public SHAPE_TOOLS = [
        { value: 'rect', name: '사각형', category: '도형', iconPath: 'M3 4H21V20H3Z' },
        { value: 'ellipse', name: '원/타원', category: '도형', iconPath: 'M3 12A9 7 0 1 0 21 12A9 7 0 1 0 3 12Z' },
        { value: 'shape-1', name: '도형1', category: '도형', iconPath: 'M12 3H21V21H3V12H12Z' },
        { value: 'shape-2', name: '도형2', category: '도형', iconPath: 'M8 2H16V22H8Z M8 4H16 M8 20H16' },
        { value: 'shape-3', name: '도형3', category: '도형', iconPath: 'M2 7H22V17H2Z M2 10.33H22 M2 13.67H22' },
        { value: 'shape-4', name: '도형4', category: '도형', iconPath: 'M2 18A10 10 0 0 1 22 18H2Z' },
        { value: 'shape-5-new', name: '도형5', category: '도형', iconPath: 'M3 3H12V7H21V21H3Z' },
        { value: 'shape-6', name: '도형6', category: '도형', iconPath: 'M6 5H18L22 19H2Z' },
        { value: 'shape-7', name: '도형7', category: '도형', iconPath: 'M3 21H21V3Z' },
        { value: 'shape-8-new', name: '도형8', category: '도형', iconPath: 'M7 2H17V10H7Z M7 14H17V22H7Z' },
        { value: 'shape-9', name: '도형9', category: '도형', iconPath: 'M2 2H22V22H2Z M8 8H16V16H8Z' },
        { value: 'shape-10', name: '도형10', category: '도형', iconPath: 'M2 21L16 3H22V21Z' },
        { value: 'shape-11', name: '도형11', category: '도형', iconPath: 'M2 2H22V22H2Z M2 2L7 7 M9 9L15 15 M17 17L22 22 M22 2L17 7 M15 9L9 15 M7 17L2 22' },
        { value: 'shape-12', name: '도형12', category: '도형', iconPath: 'M6 3H22L18 21H2Z' },
        { value: 'shape-13', name: '도형13', category: '도형', iconPath: 'M1 20L6 4 M4 20L9 4L13 20L18 4 M16 20L21 4' },
        { value: 'shape-14', name: '도형14', category: '도형', iconPath: 'M2 5H22V11L15 19H9L2 11Z' },
        { value: 'building-1', name: '건축1', category: '건축', iconPath: 'M3 3H21V21H3Z M5 5H19V19H5Z' },
        { value: 'building-2', name: '건축2', category: '건축', iconPath: 'M2 8H22V16H2Z M3 10H13 M11 14H21 M12 3V21' },
        { value: 'shape-5', name: '건축3', category: '건축', iconPath: 'M4 3A17 17 0 0 1 21 20H4Z' },
        { value: 'civil-1', name: '토목1', category: '토목', iconPath: 'M4 2H20V22H4Z M4 3H20 M4 4H20 M4 5H20 M4 11H20 M4 13H20 M4 19H20 M4 20H20 M4 21H20' },
        { value: 'civil-2', name: '토목2', category: '토목', iconPath: 'M3 3H21V6L15 10V22H9V10L3 6Z' },
        { value: 'civil-3', name: '토목3', category: '토목', iconPath: 'M9 2H15V22H9Z M9 4H15 M9 8H15' },
        { value: 'civil-4', name: '토목4', category: '토목', iconPath: 'M2 4H22V6L19 8V21 M16 7L14 8V21 M5 8V21 M8 8L10 7H14 M3 21H9 M15 21H21' },
        { value: 'civil-5', name: '토목5', category: '토목', iconPath: 'M2 4H22V22H19V8L17 7H7L5 8V22H2Z' },
        { value: 'civil-6', name: '토목6', category: '토목', iconPath: 'M3 3H21V21H3Z M7 3V21 M11 3V21 M15 3V21 M19 3V21 M3 7H21 M3 11H21 M3 15H21 M3 19H21' },
        { value: 'civil-7', name: '토목7', category: '토목', iconPath: 'M3 3H21V21H3Z M8 8H16V16H8Z M3 3L8 8 M21 3L16 8 M21 21L16 16 M3 21L8 16' },
        { value: 'civil-8', name: '토목8', category: '토목', iconPath: 'M3 3H21V21H3Z M8 5H16L19 8V16L16 19H8L5 16V8Z' }
    ];

    // Former civil tools stay renderable for saved-data compatibility only.
    // They are absent from both the selector and movable drawing types.
    public DRAWING_SHAPE_TYPES = [
        'rect', 'ellipse',
        'shape-1', 'shape-2', 'shape-3', 'shape-4',
        'shape-5', 'shape-5-new', 'shape-6', 'shape-7',
        'shape-8', 'shape-8-new', 'shape-9', 'shape-10',
        'shape-11', 'shape-12', 'shape-13', 'shape-14',
        'building-1', 'building-2',
        'civil-1', 'civil-2', 'civil-3', 'civil-4',
        'civil-5', 'civil-6', 'civil-7', 'civil-8'
    ];

    public LINE_STYLES = [
        { value: 'solid', name: '직선', dash: [], dashPreview: '' },
        { value: 'dashed', name: '점선', dash: [3, 2], dashPreview: '6 4' },
        {
            value: 'dash-dot',
            name: '1점 쇄선',
            dash: [8, 2, 1, 2],
            dashPreview: '12 4 2 4'
        },
        {
            value: 'dash-dot-dot',
            name: '2점 쇄선',
            dash: [8, 2, 1, 2, 1, 2],
            dashPreview: '12 4 2 4 2 4'
        }
    ];

    public FILL_PATTERNS = [
        { value: 'dots', name: '도트' },
        { value: 'dots-2', name: '도트2' },
        { value: 'diagonal', name: '사선' },
        { value: 'diagonal-2', name: '사선2' },
        { value: 'diagonal-grid', name: '사선격자' },
        { value: 'triangle', name: '삼각' },
        { value: 'grid', name: '수직격자' },
        { value: 'cross', name: '십자' },
        { value: 'exposed-rebar', name: '철근노출' },
        { value: 'hybrid-grid', name: '혼합격자' }
    ];

    public DRAW_TOOLS = [
        { value: 'freehand', name: '자유곡선', icon: 'fa-pen' },
        { value: 'line', name: '직선', icon: 'fa-minus' },
        { value: 'shape', name: '도형', icon: 'fa-shapes' },
        { value: 'fill', name: '채우기', icon: 'fa-fill-drip' },
        { value: 'arrow', name: '화살표', icon: 'fa-arrow-right' },
        { value: 'eraser', name: '지우개', icon: 'fa-eraser' }
    ];

    public POINT_TOOLS = [
        { value: 'add', name: '추가', icon: 'fa-location-dot' },
        { value: 'select', name: '선택', icon: 'fa-crosshairs' },
        { value: 'erase', name: '지우개', icon: 'fa-eraser' }
    ];

    // ========== Constants ==========
    public CATEGORIES = [
        { name: '균열', icon: 'fa-bolt', color: '#ef4444', subs: ['표면균열', '관통균열', '망상균열', '균열(기타)'] },
        { name: '박리/박락', icon: 'fa-layer-group', color: '#f97316', subs: ['박리', '박락', '층분리'] },
        { name: '철근노출', icon: 'fa-grip-lines', color: '#dc2626', subs: ['철근노출', '철근부식', '강재노출'] },
        { name: '누수/백태', icon: 'fa-droplet', color: '#3b82f6', subs: ['누수', '유출수', '백태', '석회화'] },
        { name: '부식/마모', icon: 'fa-shield-halved', color: '#a855f7', subs: ['부식', '마모', '세굴', '풍화'] },
        { name: '변형/변위', icon: 'fa-arrows-left-right-to-line', color: '#eab308', subs: ['처짐', '변위', '뒤틀림', '팽창'] },
        { name: '파손/결손', icon: 'fa-hammer', color: '#64748b', subs: ['파손', '결손', '단면손실'] },
        { name: '이음부/받침', icon: 'fa-link', color: '#14b8a6', subs: ['신축이음 이상', '받침 이상', '교좌장치 이상'] },
        { name: '기타', icon: 'fa-ellipsis', color: '#6b7280', subs: ['배수 불량', '포장 손상', '기타'] }
    ];

    public MEMBERS = ['슬래브', '보', '기둥', '벽체', '바닥판', '교대', '교각', '거더', '난간', '포장', '배수시설', '신축이음', '받침', '기초', '기타'];
    public REMARKS_OPTIONS = ['기존', '신규', '보수', '보수부', '증가'];
    public MEASUREMENT_FIELDS = [
        { key: 'width', label: '폭' },
        { key: 'breadth', label: '너비' },
        { key: 'length', label: '길이' },
        { key: 'depth', label: '깊이' }
    ];
    public BASE_QUANTITY_UNITS = ['m²', 'm', 'cm²', 'cm', 'mm²', 'mm'];

    private readonly VIEWER_STATE_META_TYPE = '__viewer_state__';
    private lastSavedSnapshot = '';
    private hasSnapshotBaseline = false;

    // ========== Event Refs ==========
    private _wheel: any;
    private _mousedown: any;
    private _mousemove: any;
    private _mouseup: any;
    private _touchstart: any;
    private _touchmove: any;
    private _touchend: any;
    private _touchcancel: any;
    private container: HTMLElement | null = null;
    private thumbnailGenerationToken = 0;
    private damagePhotoPreviewPressTimer: any = null;
    private damagePhotoPreviewWasLongPress = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    // ================================================================
    //  LIFECYCLE
    // ================================================================

    async ngOnInit() {
        this.facilityId = WizRoute.segment.facilityId || '';
        this.drawingId = WizRoute.segment.drawingId || '';
        await this.loadData();
        this.startLocalDraftWatcher();
        this.ref.detectChanges();
        setTimeout(async () => {
            this.initViewer();
            if (this.drawing) await this.loadPDF();
            else { this.isLoading = false; this.ref.detectChanges(); }
        }, 150);
    }

    ngOnDestroy() {
        this.stopLocalDraftWatcher();
        if (this.localDraftDirty) void this.flushLocalDraft('destroy');
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
            this.longPressTimer = null;
        }
        this.cancelDrawingShapeMove(true);
        this.cancelDamagePhotoPreviewPress();
        this.removeEvents();
    }

    // ================================================================
    //  DATA LOADING
    // ================================================================

    async loadData() {
        const { code, data, message } = await wiz.call("get_viewer_data", {
            facility_id: this.facilityId,
            drawing_id: this.drawingId
        });
        if (code === 200) {
            this.facility = data.facility;
            this.drawing = data.drawing;
            this.project = data.project;
            this.hasSavedExportFiles = data.has_saved_export_files === true;
            this.offlineMissingItems = Array.isArray(data.offline_missing) ? data.offline_missing : [];
            this.viewerDataFromOfflineCache = data.offline === true;
            this.syncState = data.sync || { workspace_id: '', revision: 0, conflict_count: 0, conflicts: [] };
            this.syncConflicts = this.syncState.conflicts || [];
            this.resolvedSyncConflicts = this.syncState.resolved_conflicts || [];
            this.damages = data.damages || [];
            this.facilityOverviewPhotos = this.normalizeFacilityOverviewPhotos(data.overview_photos || []);
            const drawingPayload = this.parseDrawingPayload(data.drawings);
            this.drawings = drawingPayload.drawings;
            this.pageRotations = drawingPayload.pageRotations;
            this.legacyRotationDegrees = drawingPayload.legacyRotation;
            this.blankPageCount = drawingPayload.blankPageCount;
            this.blankPageIds = drawingPayload.blankPageIds;
            this.drawingNamesByPage = drawingPayload.drawingNamesByPage;
            this.normalizeLoadedDamages();
            this.ensureSyncMetadataForCurrentState(false);
            this.lastSavedEntityState = this.buildSyncEntityState();
            this.lastSavedSnapshot = this.buildSaveStateSnapshot();
            this.hasSnapshotBaseline = true;
            await this.restoreLocalDraft();
        } else {
            await this.service.alert.show({
                title: '오류',
                message: message || data?.message || data?.missing?.join(', ') || '도면 정보를 불러올 수 없습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            void this.goBack();
        }
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    private getLocalDraftId(): string {
        return this.syncClientId + ':' + this.drawingId;
    }

    private getLocalDraftPhotoSignature(photo: any): string {
        const data = photo?.data;
        if (typeof data === 'string') return data.length + ':' + data.slice(0, 64) + ':' + data.slice(-64);
        if (typeof Blob !== 'undefined' && data instanceof Blob) return data.size + ':' + data.type;
        return '';
    }

    private packLocalDraftPhotos(photos: any[], scope: string, ownerId: any, draftId: string, files: any[], active: Set<string>): any[] {
        return (Array.isArray(photos) ? photos : []).map((photo: any, index: number) => {
            const packed = { ...photo };
            const data = photo?.data;
            const localData = (typeof data === 'string' && data.startsWith('data:'))
                || (typeof Blob !== 'undefined' && data instanceof Blob);
            if (!localData) return packed;
            const photoId = String(photo?.id || index);
            const fileId = draftId + ':' + scope + ':' + String(ownerId || 'item') + ':' + photoId;
            const signature = this.getLocalDraftPhotoSignature(photo);
            active.add(fileId);
            if (this.localDraftPhotoSignatures[fileId] !== signature) {
                files.push({ id: fileId, draft_id: draftId, data, signature, updated_at: Date.now() });
                this.localDraftPhotoSignatures[fileId] = signature;
            }
            packed.data = '';
            packed.draft_file_id = fileId;
            return packed;
        });
    }

    private hydrateLocalDraftPhotos(photos: any[], files: Map<string, any>): any[] {
        return (Array.isArray(photos) ? photos : []).map((photo: any) => {
            const hydrated = { ...photo };
            const fileId = String(photo?.draft_file_id || '');
            if (fileId && files.has(fileId)) hydrated.data = files.get(fileId).data;
            delete hydrated.draft_file_id;
            return hydrated;
        });
    }

    private buildLocalDraftWatchSignature(): string {
        const photoMeta = (photos: any[]) => (Array.isArray(photos) ? photos : []).map((photo: any) => ({
            id: photo?.id || '',
            representative: photo?.isRepresentative === true,
            size: typeof photo?.data === 'string' ? photo.data.length : Number(photo?.data?.size || 0),
            updated_at: photo?.updatedAt || photo?.updated_at || ''
        }));
        const form = this.selectedDamage ? { ...this.formData, photos: photoMeta(this.formData?.photos) } : null;
        return JSON.stringify({
            selected_damage_id: this.selectedDamage?.id || '',
            form,
            overview: photoMeta(this.facilityOverviewPhotos),
            blank_page_ids: this.blankPageIds,
            page_rotations: this.pageRotations,
            drawing_names: this.drawingNamesByPage
        });
    }

    private startLocalDraftWatcher() {
        if (!this.isCapacitor() || this.localDraftWatchTimer) return;
        this.localDraftLastWatchSignature = this.buildLocalDraftWatchSignature();
        this.localDraftWatchTimer = setInterval(() => {
            if (this.isSaving) return;
            const signature = this.buildLocalDraftWatchSignature();
            if (signature !== this.localDraftLastWatchSignature) {
                this.localDraftLastWatchSignature = signature;
                this.scheduleLocalDraftSave('form-or-page-change');
            }
        }, 500);
        this.localDraftVisibilityHandler = () => {
            if (document.hidden && this.localDraftDirty) void this.flushLocalDraft('background');
        };
        document.addEventListener('visibilitychange', this.localDraftVisibilityHandler);
        window.addEventListener('pagehide', this.localDraftVisibilityHandler);
    }

    private stopLocalDraftWatcher() {
        if (this.localDraftTimer) clearTimeout(this.localDraftTimer);
        if (this.localDraftWatchTimer) clearInterval(this.localDraftWatchTimer);
        this.localDraftTimer = null;
        this.localDraftWatchTimer = null;
        if (this.localDraftVisibilityHandler) {
            document.removeEventListener('visibilitychange', this.localDraftVisibilityHandler);
            window.removeEventListener('pagehide', this.localDraftVisibilityHandler);
            this.localDraftVisibilityHandler = null;
        }
    }

    private scheduleLocalDraftSave(reason: string = 'change', immediate: boolean = false) {
        if (!this.isCapacitor() || !this.hasSnapshotBaseline || !wiz.offline?.storage) return;
        this.localDraftDirty = true;
        if (this.localDraftTimer) clearTimeout(this.localDraftTimer);
        this.localDraftTimer = null;
        if (immediate) void this.flushLocalDraft(reason);
        else this.localDraftTimer = setTimeout(() => {
            this.localDraftTimer = null;
            void this.flushLocalDraft(reason);
        }, 500);
    }

    private async flushLocalDraft(reason: string = 'change'): Promise<number> {
        if (!this.isCapacitor() || !this.hasSnapshotBaseline || !this.drawingId || !wiz.offline?.storage) return this.localDraftVersion;
        if (!this.localDraftDirty && reason !== 'manual-save') return this.localDraftVersion;
        if (this.localDraftTimer) clearTimeout(this.localDraftTimer);
        this.localDraftTimer = null;
        this.localDraftDirty = false;

        const storage = wiz.offline.storage;
        const draftId = this.getLocalDraftId();
        const version = ++this.localDraftVersion;
        const files: any[] = [];
        const active = new Set<string>();
        const damages = this.buildSnapshotDamages().map((damage: any) => ({
            ...damage,
            photos: this.packLocalDraftPhotos(damage?.photos, 'damage', damage?.id, draftId, files, active)
        }));
        const drawings = this.buildSnapshotDrawingPayload();
        const overviewPhotos = this.packLocalDraftPhotos(this.facilityOverviewPhotos, 'overview', this.facilityId, draftId, files, active);
        const formData = this.selectedDamage ? {
            ...this.formData,
            photos: this.packLocalDraftPhotos(this.formData?.photos, 'form', this.selectedDamage?.id, draftId, files, active)
        } : null;
        const record: any = {
            id: draftId,
            schema_version: 1,
            client_id: this.syncClientId,
            project_id: this.project?.id || '',
            facility_id: this.facilityId,
            drawing_id: this.drawingId,
            base_revision: Number(this.syncState?.revision || 0),
            version,
            status: 'dirty',
            reason,
            damages,
            drawings,
            overview_photos: overviewPhotos,
            selected_damage_id: this.selectedDamage?.id || '',
            form_data: formData,
            panel_open: this.showPanel && this.panelMode === 'form',
            updated_at: Date.now()
        };
        const staleFiles = Object.keys(this.localDraftPhotoSignatures).filter((id: string) => !active.has(id));

        this.localDraftWrite = this.localDraftWrite.catch(() => {}).then(async () => {
            const existing = await storage.get('inspection_drafts', draftId);
            record.queued_operation_id = existing?.queued_operation_id || '';
            record.queued_version = Number(existing?.queued_version || 0);
            for (const file of files) await storage.put('inspection_draft_files', file);
            for (const fileId of staleFiles) {
                await storage.delete('inspection_draft_files', fileId);
                delete this.localDraftPhotoSignatures[fileId];
            }
            await storage.put('inspection_drafts', record);
        });
        await this.localDraftWrite.catch((error: any) => {
            this.localDraftPhotoSignatures = {};
            this.localDraftDirty = true;
            console.warn('[InspectionAutosave] draft write failed', error);
        });
        return version;
    }

    private async restoreLocalDraft(): Promise<boolean> {
        if (!this.isCapacitor() || !this.drawingId || !wiz.offline?.storage) return false;
        const storage = wiz.offline.storage;
        const draftId = this.getLocalDraftId();
        try {
            const record = await storage.get('inspection_drafts', draftId);
            if (!record || record.schema_version !== 1) return false;
            const fileRecords = await storage.getAllByIndex('inspection_draft_files', 'draft_id', draftId);
            const files = new Map(fileRecords.map((item: any) => [String(item.id), item]));
            this.localDraftPhotoSignatures = {};
            for (const item of fileRecords) this.localDraftPhotoSignatures[String(item.id)] = String(item.signature || '');
            this.damages = (Array.isArray(record.damages) ? record.damages : []).map((damage: any) => ({
                ...damage,
                photos: this.hydrateLocalDraftPhotos(damage?.photos, files)
            }));
            this.facilityOverviewPhotos = this.normalizeFacilityOverviewPhotos(
                this.hydrateLocalDraftPhotos(record.overview_photos, files)
            );
            const drawingPayload = this.parseDrawingPayload(record.drawings);
            this.drawings = drawingPayload.drawings;
            this.pageRotations = drawingPayload.pageRotations;
            this.legacyRotationDegrees = drawingPayload.legacyRotation;
            this.blankPageCount = drawingPayload.blankPageCount;
            this.blankPageIds = drawingPayload.blankPageIds;
            this.drawingNamesByPage = drawingPayload.drawingNamesByPage;
            this.normalizeLoadedDamages();
            this.ensureSyncMetadataForCurrentState(false);
            const selectedDamageId = String(record.selected_damage_id || '');
            this.selectedDamage = selectedDamageId
                ? this.damages.find((damage: any) => String(damage?.id || '') === selectedDamageId) || null
                : null;
            if (this.selectedDamage && record.form_data) {
                this.formData = {
                    ...record.form_data,
                    photos: this.hydrateLocalDraftPhotos(record.form_data?.photos, files)
                };
                this.showPanel = record.panel_open === true;
                this.panelMode = 'form';
            } else {
                this.selectedDamage = null;
                this.showPanel = false;
            }
            this.localDraftVersion = Number(record.version || 0);
            this.localDraftDirty = false;
            this.localDraftRestored = true;
            this.localDraftLastWatchSignature = this.buildLocalDraftWatchSignature();
            console.info('[InspectionAutosave] restored', {
                drawing_id: this.drawingId,
                version: this.localDraftVersion,
                status: record.status
            });
            return true;
        } catch (error) {
            console.warn('[InspectionAutosave] draft restore failed', error);
            return false;
        }
    }

    private async clearLocalDraft(version: number = Number.MAX_SAFE_INTEGER) {
        if (!this.isCapacitor() || !wiz.offline?.storage) return;
        await this.localDraftWrite.catch(() => {});
        const storage = wiz.offline.storage;
        const draftId = this.getLocalDraftId();
        const record = await storage.get('inspection_drafts', draftId);
        if (record && Number(record.version || 0) <= Number(version)) {
            if (typeof storage.deleteInspectionDraft === 'function') await storage.deleteInspectionDraft(draftId);
            else await storage.delete('inspection_drafts', draftId);
            this.localDraftPhotoSignatures = {};
            this.localDraftDirty = false;
        }
    }

    private async markLocalDraftQueued(operationId: string) {
        if (!this.isCapacitor() || !wiz.offline?.storage) return;
        await this.localDraftWrite.catch(() => {});
        const storage = wiz.offline.storage;
        const draftId = this.getLocalDraftId();
        const record = await storage.get('inspection_drafts', draftId);
        if (!record) return;
        record.status = 'queued';
        record.queued_operation_id = String(operationId || '');
        record.queued_version = Number(record.version || 0);
        record.updated_at = Date.now();
        await storage.put('inspection_drafts', record);
    }

    get pendingConflictCount(): number {
        if (Array.isArray(this.syncConflicts) && this.syncConflicts.length > 0) {
            return this.syncConflicts.length;
        }
        return Number(this.syncState?.conflict_count || 0);
    }

    get hasSyncConflicts(): boolean {
        return this.pendingConflictCount > 0;
    }

    async openConflictModal() {
        this.conflictModalVisible = true;
        this.ref.detectChanges();
        await this.loadSyncConflicts(true);
    }

    closeConflictModal() {
        this.conflictModalVisible = false;
        this.ref.detectChanges();
    }

    async loadSyncConflicts(showErrorAlert: boolean = true) {
        if (!this.project?.id || !this.facilityId || !this.drawingId) return;
        this.isLoadingConflicts = true;
        this.ref.detectChanges();
        try {
            const { code, data } = await wiz.call('load_conflicts', {
                project_id: this.project.id,
                facility_id: this.facilityId,
                drawing_id: this.drawingId
            });
            if (code === 200) {
                this.syncConflicts = data?.conflicts || [];
                this.resolvedSyncConflicts = data?.resolved_conflicts || [];
                this.syncState = {
                    ...(this.syncState || {}),
                    workspace_id: data?.workspace_id || this.syncState?.workspace_id || '',
                    conflict_count: Number(data?.count || this.syncConflicts.length),
                    conflicts: this.syncConflicts,
                    resolved_conflicts: this.resolvedSyncConflicts
                };
            } else if (showErrorAlert) {
                await this.service.alert.show({
                    title: '충돌 조회 실패',
                    message: data || '충돌 목록을 불러오지 못했습니다.',
                    status: 'error',
                    action: '확인',
                    cancel: false
                });
            }
        } catch (e) {
            console.error('Load conflicts error:', e);
            if (showErrorAlert) {
                await this.service.alert.show({
                    title: '충돌 조회 실패',
                    message: '충돌 목록을 불러오지 못했습니다.',
                    status: 'error',
                    action: '확인',
                    cancel: false
                });
            }
        } finally {
            this.isLoadingConflicts = false;
            this.ref.detectChanges();
        }
    }

    async resolveSyncConflict(conflict: any, resolution: 'server' | 'client') {
        if (!conflict?.id || this.resolvingConflictId) return;

        const keepClient = resolution === 'client';
        const reason = String(this.conflictResolutionReasons[conflict.id] || '').trim();
        if (!reason) {
            await this.service.alert.show({
                title: '해결 사유 필요',
                message: '충돌 처리 사유를 입력해주세요.',
                status: 'warning',
                action: '확인',
                cancel: false
            });
            return;
        }

        const confirmed = await this.service.alert.show({
            title: keepClient ? '내 변경 반영' : '서버본 유지',
            message: keepClient
                ? '이 충돌 항목에 내 변경 내용을 적용하고 처리 이력을 남깁니다.'
                : '이 충돌 항목은 현재 서버 저장본을 유지하고 처리 이력을 남깁니다.',
            status: 'warning',
            action: keepClient ? '반영' : '유지',
            cancel: '취소'
        });
        if (!confirmed) return;

        this.resolvingConflictId = conflict.id;
        this.ref.detectChanges();
        await this.service.loading.show();
        try {
            const { code, data } = await wiz.call('resolve_conflict', {
                project_id: this.project?.id || '',
                facility_id: this.facilityId,
                drawing_id: this.drawingId,
                conflict_id: conflict.id,
                resolution,
                resolution_reason: reason
            });
            await this.service.loading.hide();

            if (code === 200) {
                this.applyResolvedConflictData(data);
                delete this.conflictResolutionReasons[conflict.id];
            } else {
                await this.service.alert.show({
                    title: '충돌 처리 실패',
                    message: data || '충돌 항목을 처리하지 못했습니다.',
                    status: 'error',
                    action: '확인',
                    cancel: false
                });
            }
        } catch (e) {
            await this.service.loading.hide();
            console.error('Resolve conflict error:', e);
            await this.service.alert.show({
                title: '충돌 처리 실패',
                message: '충돌 항목을 처리하지 못했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        } finally {
            this.resolvingConflictId = '';
            this.ref.detectChanges();
        }
    }

    applyResolvedConflictData(data: any) {
        if (Array.isArray(data?.damages)) {
            this.damages = data.damages;
            this.normalizeLoadedDamages();
            this.ensureSyncMetadataForCurrentState(false);
        }
        if (data?.drawings) {
            const drawingPayload = this.parseDrawingPayload(data.drawings);
            this.drawings = drawingPayload.drawings;
            this.pageRotations = drawingPayload.pageRotations;
            this.legacyRotationDegrees = drawingPayload.legacyRotation;
            this.blankPageCount = drawingPayload.blankPageCount;
            this.blankPageIds = drawingPayload.blankPageIds;
            this.drawingNamesByPage = drawingPayload.drawingNamesByPage;
            this.syncVirtualPages();
            this.ensureSyncMetadataForCurrentState(false);
        }

        const sync = data?.sync || data || {};
        this.syncConflicts = sync.conflicts || [];
        this.resolvedSyncConflicts = sync.resolved_conflicts || data?.resolved_conflicts || this.resolvedSyncConflicts || [];
        this.syncState = {
            ...(this.syncState || {}),
            revision: sync.revision ?? this.syncState?.revision ?? 0,
            conflict_count: Number(sync.conflict_count || this.syncConflicts.length),
            conflicts: this.syncConflicts,
            resolved_conflicts: this.resolvedSyncConflicts
        };
        this.lastSavedEntityState = this.buildSyncEntityState();
        this.lastSavedSnapshot = this.buildSaveStateSnapshot();
        this.hasSnapshotBaseline = true;
        this.renderMarkers();
        this.renderDrawings();
        this.ref.detectChanges();
    }

    getConflictEntityLabel(conflict: any): string {
        if (conflict?.entity_type === 'damage') return '손상';
        if (conflict?.entity_type === 'annotation') {
            if (conflict?.entity_id === '__viewer_state__') return '도면 상태';
            return '드로잉';
        }
        return '항목';
    }

    getConflictActionLabel(action: string): string {
        if (action === 'create') return '추가';
        if (action === 'update') return '수정';
        if (action === 'delete') return '삭제';
        return action || '-';
    }

    getConflictTitle(conflict: any): string {
        const entity = this.getConflictEntityLabel(conflict);
        const action = this.getConflictActionLabel(conflict?.action);
        const payload = conflict?.client_payload || conflict?.server_payload;
        const name = this.getConflictPayloadName(payload, conflict?.entity_type);
        return name ? `${entity} ${action} · ${name}` : `${entity} ${action}`;
    }

    getConflictPayloadName(payload: any, entityType: string): string {
        if (!payload) return '';
        if (entityType === 'damage') {
            const label = this.getDamageContentSummary(payload);
            const parts = [payload.member, payload.location].filter((item: any) => !!item);
            return [label !== '유형 미지정' ? label : '', ...parts].filter((item: any) => !!item).join(' · ');
        }
        if (payload.metaType === this.VIEWER_STATE_META_TYPE) return '회전/페이지 상태';
        return [payload.tool || payload.type || payload.shape, payload.page ? `${payload.page}페이지` : ''].filter((item: any) => !!item).join(' · ');
    }

    getConflictPayloadFields(conflict: any, side: 'server' | 'client'): Array<{ label: string; value: string }> {
        const payload = side === 'server' ? conflict?.server_payload : conflict?.client_payload;
        if (!payload) return [{ label: '상태', value: conflict?.action === 'delete' && side === 'client' ? '삭제' : '없음' }];

        if (conflict?.entity_type === 'damage') {
            const measurements = payload.measurements || {};
            return [
                { label: '내용', value: this.getDamageContentSummary(payload) },
                { label: '부재', value: payload.member || '-' },
                { label: '위치', value: payload.location || '-' },
                { label: '페이지', value: String(payload.page || '-') },
                { label: '비고', value: payload.remark || '-' },
                { label: '물량', value: [measurements.quantity, measurements.quantityUnit].filter((item: any) => item !== undefined && item !== null && item !== '').join(' ') || '-' },
                { label: '사진', value: `${Array.isArray(payload.photos) ? payload.photos.length : 0}장` }
            ];
        }

        if (payload.metaType === this.VIEWER_STATE_META_TYPE) {
            const rotationByPage = payload.rotationByPage || {};
            return [
                { label: '유형', value: '도면 상태' },
                { label: '회전 페이지', value: `${Object.keys(rotationByPage).length}개` },
                { label: '빈 페이지', value: `${this.normalizeBlankPageIds(payload.blankPageIds, payload.blankPageCount).length}장` },
                { label: '기본 회전', value: payload.rotation !== undefined ? `${payload.rotation}도` : '-' }
            ];
        }

        return [
            { label: '도구', value: payload.tool || payload.type || payload.shape || '-' },
            { label: '페이지', value: String(payload.page || '-') },
            { label: '색상', value: payload.color || '-' },
            { label: '두께', value: payload.width !== undefined ? String(payload.width) : '-' }
        ];
    }

    formatConflictDate(value: string): string {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return date.toLocaleString('ko-KR', {
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    onConflictReasonInput(conflictId: string, value: string) {
        this.conflictResolutionReasons[conflictId] = value;
        this.ref.detectChanges();
    }

    getConflictAuditUser(conflict: any, role: 'assignee' | 'reviewer'): string {
        if (!conflict) return '-';
        const display = conflict[role];
        const id = conflict[`${role}_id`];
        if (display) return display;
        return id || '-';
    }

    getConflictChangedFieldText(conflict: any, side: 'server' | 'client' | 'overlap'): string {
        const key = side === 'server'
            ? 'server_changed_fields'
            : side === 'client'
                ? 'client_changed_fields'
                : 'overlap_fields';
        const fields = Array.isArray(conflict?.[key]) ? conflict[key] : [];
        if (fields.length === 0) return '-';
        return fields.slice(0, 6).join(', ') + (fields.length > 6 ? ` 외 ${fields.length - 6}개` : '');
    }

    getResolutionLabel(resolution: string): string {
        if (resolution === 'client') return '내 변경 반영';
        if (resolution === 'server') return '서버본 유지';
        return resolution || '-';
    }

    getResolvedDiffSummary(conflict: any): string {
        const diff = Array.isArray(conflict?.resolved_diff) ? conflict.resolved_diff : [];
        if (diff.length === 0) return '변경 없음';
        const fields = diff.map((item: any) => item?.field).filter((field: any) => !!field);
        return fields.slice(0, 5).join(', ') + (fields.length > 5 ? ` 외 ${fields.length - 5}개` : '');
    }

    async blockExportForPendingConflicts(): Promise<boolean> {
        await this.loadSyncConflicts(false);
        if (!this.hasSyncConflicts) return false;

        await this.service.alert.show({
            title: '충돌 처리 필요',
            message: `미해결 동시 수정 충돌 ${this.pendingConflictCount}건이 있습니다. 처리 이력을 남긴 뒤 추출할 수 있습니다.`,
            status: 'warning',
            action: '충돌 보기',
            cancel: false
        });
        await this.openConflictModal();
        return true;
    }

    async loadPDF() {
        if (!this.drawing) { this.isLoading = false; this.ref.detectChanges(); return; }
        let loadedFromCache = false;
        try {
            const pdfUrl = this.resolveNativeUrl(`/api/file/pdf?id=${encodeURIComponent(this.drawingId)}`);
            if (typeof pdfjsLib === 'undefined') await this.loadPdfJs();
            pdfjsLib.GlobalWorkerOptions.workerSrc = this.getPdfJsAssetUrl('pdf.worker.min.js');
            const cachedPdf = await this.getCachedPdfBytes();

            if ((this.viewerDataFromOfflineCache || (wiz.offline?.isOffline && wiz.offline.isOffline())) && cachedPdf) {
                this.pdfDoc = await pdfjsLib.getDocument({ data: cachedPdf }).promise;
                loadedFromCache = true;
            } else {
                try {
                    this.pdfDoc = await pdfjsLib.getDocument({
                        url: pdfUrl,
                        withCredentials: true
                    }).promise;
                } catch (networkError) {
                    if (!cachedPdf) throw networkError;
                    this.pdfDoc = await pdfjsLib.getDocument({ data: cachedPdf }).promise;
                    loadedFromCache = true;
                }
            }

            this.sourcePageCount = this.pdfDoc.numPages;
            this.totalPages = Math.max(1, this.sourcePageCount + this.blankPageCount);
            this.currentPage = Math.min(Math.max(this.currentPage, 1), this.totalPages);
            this.initPageThumbnails();
            void this.generatePageThumbnails();
            await this.renderPage(this.currentPage);
            this.fitToScreen();
            this.isLoading = false;
            if (loadedFromCache && this.offlineMissingItems.length > 0) {
                this.offlineMissingItems = this.offlineMissingItems.filter((item: any) => item.category !== 'drawing_pdf');
            }
            this.ref.detectChanges();
        } catch (e) {
            console.error('PDF load error:', e);
            this.isLoading = false;
            this.ref.detectChanges();
            await this.showPdfMissingAlert(e);
        }
    }

    loadPdfJs(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (typeof pdfjsLib !== 'undefined') { resolve(); return; }
            const s = document.createElement('script');
            s.src = this.getPdfJsAssetUrl('pdf.min.js');
            s.onload = () => resolve();
            s.onerror = () => {
                const fallback = document.createElement('script');
                fallback.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
                fallback.onload = () => resolve();
                fallback.onerror = () => reject(new Error('PDF.js 런타임 파일을 불러올 수 없습니다.'));
                document.head.appendChild(fallback);
            };
            document.head.appendChild(s);
        });
    }

    private getPdfJsAssetUrl(fileName: string): string {
        return `${window.location.origin}/assets/pdfjs/${fileName}`;
    }

    private async getCachedPdfBytes(): Promise<Uint8Array | null> {
        try {
            if (wiz.offline?.storage && this.drawingId) {
                const cached = await wiz.offline.storage.get('files', `pdf_${this.drawingId}`);
                if (cached) {
                    if (cached.data instanceof ArrayBuffer) return new Uint8Array(cached.data);
                    if (ArrayBuffer.isView(cached.data)) {
                        return new Uint8Array(cached.data.buffer, cached.data.byteOffset, cached.data.byteLength);
                    }
                    if (cached.blob && typeof cached.blob.arrayBuffer === 'function') {
                        return new Uint8Array(await cached.blob.arrayBuffer());
                    }
                }
            }

        } catch (error) {
            console.warn('Cached PDF read failed:', error);
        }
        return null;
    }

    private async showPdfMissingAlert(error: any) {
        const missing = await this.getOfflineMissingFileLabels('drawing_pdf');
        const filename = this.drawing?.filename || this.drawing?.name || `도면 PDF ${this.drawingId}`;
        const list = missing.length > 0 ? missing : [`도면 PDF: ${filename}`];
        await this.service.alert.show({
            title: '도면 PDF 캐시 누락',
            message: `네트워크 없이 열 수 없는 파일이 있습니다.\n${list.map((item: string) => `- ${item}`).join('\n')}`,
            status: 'error',
            action: '확인',
            cancel: false
        });
    }

    private async getOfflineMissingFileLabels(category: string = ''): Promise<string[]> {
        try {
            const projectId = this.project?.id || '';
            if (!projectId || !wiz.offline?.prefetch) return [];
            const items = await wiz.offline.prefetch.getMissingItems(projectId, category ? [category] : undefined);
            return (items || []).map((item: any) => item.label || item.filename || item.ref_id).filter((item: any) => !!item);
        } catch (error) {
            console.warn('Offline missing item lookup failed:', error);
            return [];
        }
    }

    private async getVirtualPageViewport(pageNumber: number, scale: number = 2): Promise<{ sourcePage: any; viewport: any }> {
        if (pageNumber > this.sourcePageCount) {
            return {
                sourcePage: null,
                viewport: {
                    width: 841.89 * scale,
                    height: 595.28 * scale
                }
            };
        }

        const sourcePage = await this.pdfDoc.getPage(
            Math.min(Math.max(pageNumber, 1), this.sourcePageCount)
        );
        return {
            sourcePage,
            viewport: sourcePage.getViewport({ scale })
        };
    }

    async renderPage(num: number) {
        if (!this.pdfDoc || !this.pdfCanvas || !this.pdfCtx) return;
        const { sourcePage, viewport } = await this.getVirtualPageViewport(num, 2);
        this.pdfCanvas.width = viewport.width;
        this.pdfCanvas.height = viewport.height;
        if (this.annotCanvas) {
            this.annotCanvas.width = viewport.width;
            this.annotCanvas.height = viewport.height;
        }
        if (this.drawCanvas) {
            this.drawCanvas.width = viewport.width;
            this.drawCanvas.height = viewport.height;
        }
        this.pdfCtx.save();
        this.pdfCtx.fillStyle = '#ffffff';
        this.pdfCtx.fillRect(0, 0, viewport.width, viewport.height);
        if (sourcePage) {
            await sourcePage.render({ canvasContext: this.pdfCtx, viewport }).promise;
        }
        this.pdfCtx.restore();
        this.currentPage = num;
        this.renderMarkers();
        this.renderDrawings();
        this.ref.detectChanges();
        setTimeout(() => this.scrollCurrentThumbnailIntoView(), 0);
    }

    initPageThumbnails() {
        this.pageThumbnails = Array.from({ length: this.totalPages }, (_: any, index: number) => ({
            page: index + 1,
            dataUrl: '',
            loading: true
        }));
        this.ref.detectChanges();
    }

    async generatePageThumbnails() {
        if (!this.pdfDoc) return;
        const token = ++this.thumbnailGenerationToken;

        for (let pageNumber = 1; pageNumber <= this.totalPages; pageNumber++) {
            if (token !== this.thumbnailGenerationToken) return;

            try {
                const { viewport: baseViewport } = await this.getVirtualPageViewport(pageNumber, 1);
                const scale = Math.min(1, 120 / baseViewport.width, 160 / baseViewport.height);
                const { sourcePage, viewport } = await this.getVirtualPageViewport(pageNumber, scale);
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                if (!ctx) continue;

                canvas.width = viewport.width;
                canvas.height = viewport.height;
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, viewport.width, viewport.height);
                if (sourcePage) {
                    await sourcePage.render({ canvasContext: ctx, viewport }).promise;
                }

                const rotatedCanvas = this.rotateCanvasForExport(
                    canvas,
                    this.getPageRotation(pageNumber)
                );
                this.pageThumbnails[pageNumber - 1] = {
                    page: pageNumber,
                    dataUrl: rotatedCanvas.toDataURL('image/jpeg', 0.82),
                    loading: false
                };
            } catch (error) {
                console.error('Thumbnail render error:', error);
                this.pageThumbnails[pageNumber - 1] = {
                    page: pageNumber,
                    dataUrl: '',
                    loading: false
                };
            }

            this.pageThumbnails = [...this.pageThumbnails];
            this.ref.detectChanges();
        }
    }

    async goToPage(pageNumber: number) {
        if (!this.pdfDoc) return;
        if (pageNumber < 1 || pageNumber > this.totalPages) return;
        if (pageNumber === this.currentPage) {
            this.scrollCurrentThumbnailIntoView();
            return;
        }
        await this.renderPage(pageNumber);
        this.fitToScreen();
    }

    togglePageSidebar() {
        this.isPageSidebarCollapsed = !this.isPageSidebarCollapsed;
        this.ref.detectChanges();

        if (!this.isPageSidebarCollapsed) {
            setTimeout(() => this.scrollCurrentThumbnailIntoView(), 0);
        }
    }

    scrollCurrentThumbnailIntoView() {
        const activeThumb = document.getElementById(`page-thumb-${this.currentPage}`);
        if (activeThumb) {
            activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
    }

    // ================================================================
    //  VIEWER INIT & EVENTS
    // ================================================================

    initViewer() {
        this.container = document.getElementById('viewer-container');
        this.pdfCanvas = document.getElementById('pdf-canvas') as HTMLCanvasElement;
        this.annotCanvas = document.getElementById('annotation-canvas') as HTMLCanvasElement;
        this.drawCanvas = document.getElementById('drawing-canvas') as HTMLCanvasElement;
        if (this.pdfCanvas) this.pdfCtx = this.pdfCanvas.getContext('2d');
        if (this.annotCanvas) this.annotCtx = this.annotCanvas.getContext('2d');
        if (this.drawCanvas) this.drawCtx = this.drawCanvas.getContext('2d');
        this.setupEvents();
    }

    setupEvents() {
        if (!this.container) return;
        this._wheel = this.onWheel.bind(this);
        this._mousedown = this.onPointerDown.bind(this);
        this._mousemove = this.onPointerMove.bind(this);
        this._mouseup = this.onPointerUp.bind(this);
        this._touchstart = this.onTouchStart.bind(this);
        this._touchmove = this.onTouchMove.bind(this);
        this._touchend = this.onTouchEnd.bind(this);
        this._touchcancel = this.onTouchCancel.bind(this);

        this.container.addEventListener('wheel', this._wheel, { passive: false });
        this.container.addEventListener('mousedown', this._mousedown);
        this.container.addEventListener('mousemove', this._mousemove);
        this.container.addEventListener('mouseup', this._mouseup);
        this.container.addEventListener('mouseleave', this._mouseup);
        this.container.addEventListener('touchstart', this._touchstart, { passive: false });
        this.container.addEventListener('touchmove', this._touchmove, { passive: false });
        this.container.addEventListener('touchend', this._touchend);
        this.container.addEventListener('touchcancel', this._touchcancel);
    }

    removeEvents() {
        if (!this.container) return;
        this.container.removeEventListener('wheel', this._wheel);
        this.container.removeEventListener('mousedown', this._mousedown);
        this.container.removeEventListener('mousemove', this._mousemove);
        this.container.removeEventListener('mouseup', this._mouseup);
        this.container.removeEventListener('mouseleave', this._mouseup);
        this.container.removeEventListener('touchstart', this._touchstart);
        this.container.removeEventListener('touchmove', this._touchmove);
        this.container.removeEventListener('touchend', this._touchend);
        this.container.removeEventListener('touchcancel', this._touchcancel);
    }

    // ================================================================
    //  COORDINATE HELPERS
    // ================================================================

    normalizeBlankPageCount(value: any): number {
        const numeric = Math.floor(Number(value));
        if (!Number.isFinite(numeric)) return 0;
        return Math.max(0, Math.min(numeric, 200));
    }

    normalizeBlankPageIds(value: any, fallbackCount: any = 0): string[] {
        const values = Array.isArray(value) ? value : [];
        const ids: string[] = [];
        const seen = new Set<string>();
        for (const item of values) {
            const id = String(item || '').trim();
            if (!id || id.length > 128 || seen.has(id)) continue;
            seen.add(id);
            ids.push(id);
        }
        if (ids.length === 0) {
            return Array.from(
                { length: this.normalizeBlankPageCount(fallbackCount) },
                (_: any, index: number) => `legacy_blank_${index + 1}`
            );
        }
        return ids.slice(0, 200);
    }

    normalizeDrawingNamesByPage(value: any): { [page: string]: string } {
        const source = value && typeof value === 'object' && Array.isArray(value) === false ? value : {};
        const normalized: { [page: string]: string } = {};
        for (const rawPage of Object.keys(source)) {
            const page = Number(rawPage);
            const name = String(source[rawPage] || '').trim();
            if (
                !Number.isInteger(page)
                || page < 1
                || String(page) !== rawPage
                || !name
                || name.length > 128
                || /[\u0000-\u001f\u007f]/.test(name)
            ) {
                continue;
            }
            normalized[rawPage] = name;
        }
        return normalized;
    }

    normalizeRotationQuarterTurnsByPage(value: any): { [page: string]: number } {
        const result: { [page: string]: number } = {};
        if (!value || typeof value !== 'object' || Array.isArray(value)) return result;

        for (const [page, rawTurns] of Object.entries(value)) {
            const pageNumber = Number(page);
            const turns = Number(rawTurns);
            if (
                !Number.isInteger(pageNumber)
                || pageNumber < 1
                || String(pageNumber) !== page
                || !Number.isInteger(turns)
                || turns < 0
                || turns > 3
            ) {
                continue;
            }
            result[page] = turns;
        }
        return result;
    }

    rotationQuarterTurnsToDegrees(value: any): { [page: string]: number } {
        const result: { [page: string]: number } = {};
        for (const [page, turns] of Object.entries(this.normalizeRotationQuarterTurnsByPage(value))) {
            const degrees = Number(turns) * 90;
            if (degrees !== 0) result[page] = degrees;
        }
        return result;
    }

    parseDrawingPayload(raw: any): { drawings: any[]; pageRotations: { [page: string]: number }; legacyRotation: number; blankPageCount: number; blankPageIds: string[]; drawingNamesByPage: { [page: string]: string } } {
        let legacyRotation = 0;
        let pageRotations: { [page: string]: number } = {};
        let blankPageCount = 0;
        let blankPageIds: string[] = [];
        let drawingNamesByPage: { [page: string]: string } = {};
        let drawings = Array.isArray(raw) ? raw : [];

        if (raw && typeof raw === 'object' && Array.isArray(raw) === false) {
            legacyRotation = this.normalizeRotation(raw.rotation);
            const quarterTurns = this.normalizeRotationQuarterTurnsByPage(raw.rotationQuarterTurnsByPage);
            pageRotations = Object.keys(quarterTurns).length > 0
                ? this.rotationQuarterTurnsToDegrees(quarterTurns)
                : this.normalizePageRotations(raw.rotationByPage);
            blankPageIds = this.normalizeBlankPageIds(raw.blankPageIds, raw.blankPageCount);
            blankPageCount = blankPageIds.length;
            drawingNamesByPage = this.normalizeDrawingNamesByPage(raw.drawingNameByPage);
            if (Array.isArray(raw.drawings)) drawings = raw.drawings;
            else if (Array.isArray(raw.strokes)) drawings = raw.strokes;
            else drawings = [];
        }

        const normalizedDrawings: any[] = [];
        for (const item of drawings) {
            if (!item || typeof item !== 'object') continue;
            if (this.isViewerStateItem(item)) {
                const quarterTurns = this.normalizeRotationQuarterTurnsByPage(item.rotationQuarterTurnsByPage);
                if (Object.keys(quarterTurns).length > 0) {
                    pageRotations = this.rotationQuarterTurnsToDegrees(quarterTurns);
                    legacyRotation = 0;
                } else if (item.rotationByPage && typeof item.rotationByPage === 'object') {
                    pageRotations = this.normalizePageRotations(item.rotationByPage);
                } else {
                    legacyRotation = this.normalizeRotation(item.rotation);
                }
                blankPageIds = this.normalizeBlankPageIds(item.blankPageIds, item.blankPageCount);
                blankPageCount = blankPageIds.length;
                drawingNamesByPage = this.normalizeDrawingNamesByPage(item.drawingNameByPage);
                continue;
            }
            normalizedDrawings.push(item);
        }

        return { drawings: normalizedDrawings, pageRotations, legacyRotation, blankPageCount, blankPageIds, drawingNamesByPage };
    }

    buildDrawingPayload(): any[] {
        const rotationByPage = this.buildRotationMapForSave();
        const rotationQuarterTurnsByPage = this.buildRotationQuarterTurnsMapForSave();
        const blankPageIds = this.normalizeBlankPageIds(this.blankPageIds, this.blankPageCount);
        return [
            ...this.drawings,
            {
                metaType: this.VIEWER_STATE_META_TYPE,
                rotationByPage,
                rotationQuarterTurnsByPage,
                blankPageCount: blankPageIds.length,
                blankPageIds,
                drawingNameByPage: this.normalizeDrawingNamesByPage(this.drawingNamesByPage)
            }
        ];
    }

    buildSnapshotDrawingPayload(): any[] {
        const blankPageIds = this.normalizeBlankPageIds(this.blankPageIds, this.blankPageCount);
        const viewerState: any = {
            metaType: this.VIEWER_STATE_META_TYPE,
            rotationByPage: this.buildRotationMapForSave(),
            rotationQuarterTurnsByPage: this.buildRotationQuarterTurnsMapForSave(),
            blankPageCount: blankPageIds.length,
            blankPageIds,
            drawingNameByPage: this.normalizeDrawingNamesByPage(this.drawingNamesByPage)
        };

        const legacyRotation = this.normalizeRotation(this.legacyRotationDegrees);
        if (legacyRotation !== 0) viewerState.rotation = legacyRotation;

        return [
            ...this.drawings,
            viewerState
        ];
    }

    buildSelectedDamageDraft(): any | null {
        if (!this.selectedDamage) return null;

        const resolvedDamageTypes = this.selectedDamageTypes;
        const representativeDamageType = this.getRepresentativeDamageType(resolvedDamageTypes);
        const cat = this.CATEGORIES.find((item: any) => item.name === representativeDamageType);
        const memberCustom = (this.formData.memberCustom || '').trim();
        const resolvedMember = this.formData.member === '기타'
            ? (memberCustom || '기타')
            : (this.formData.member || '');
        const resolvedDamageSubTypes = this.getDraftDamageSubTypes();
        const resolvedDamageSubType = resolvedDamageSubTypes[resolvedDamageSubTypes.length - 1] || '';

        return {
            ...this.selectedDamage,
            location: this.formData.location || '',
            member: resolvedMember,
            damageType: representativeDamageType,
            damageTypes: resolvedDamageTypes,
            damageSubType: resolvedDamageSubType || '',
            damageSubTypes: resolvedDamageSubTypes,
            measurements: this.normalizeMeasurements(this.formData.measurements),
            photos: this.cloneDamagePhotos(this.formData.photos, this.formData.photoRepresentativeLocked === true),
            photoRepresentativeLocked: this.formData.photoRepresentativeLocked === true,
            remark: this.formData.remark || '신규',
            color: cat ? cat.color : '#ef4444'
        };
    }

    cloneDamagePhotos(photos: any, keepRepresentative: boolean = false): any[] {
        return this.normalizeDamagePhotos(photos, { keepRepresentative }).map((photo: any) => ({ ...photo }));
    }

    normalizeDamagePhotos(photos: any, options: { keepRepresentative?: boolean } = {}): any[] {
        const source = Array.isArray(photos) ? photos : [];
        const fallbackTimestamp = new Date().toISOString();
        const keepRepresentative = options.keepRepresentative === true;
        const normalized = source
            .filter((photo: any) => photo && typeof photo === 'object' && photo.data)
            .map((photo: any, index: number) => ({
                ...photo,
                id: photo.id || this.generateId(),
                name: photo.name || `photo_${index + 1}`,
                timestamp: photo.timestamp || fallbackTimestamp,
                isRepresentative: photo.isRepresentative === true
            }));

        if (normalized.length === 0) return [];

        let representativeIndex = -1;
        if (keepRepresentative) {
            for (let index = 0; index < normalized.length; index++) {
                if (normalized[index].isRepresentative === true) {
                    representativeIndex = index;
                }
            }
        }

        if (representativeIndex < 0) {
            representativeIndex = normalized.length - 1;
        }

        return normalized.map((photo: any, index: number) => ({
            ...photo,
            isRepresentative: index === representativeIndex
        }));
    }

    getDamagePhotos(damage: any): any[] {
        if (!damage || !Array.isArray(damage.photos)) return [];
        return damage.photos;
    }

    getDamagePhotoCount(damage: any): number {
        return this.getDamagePhotos(damage).length;
    }

    getDamageRepresentativePhoto(damage: any): any | null {
        const photos = this.getDamagePhotos(damage);
        if (photos.length === 0) return null;
        return photos.find((photo: any) => photo.isRepresentative) || photos[photos.length - 1] || null;
    }

    normalizeDamageSubTypes(value: any, fallback: any = ''): string[] {
        const items: string[] = [];

        const appendItem = (item: any) => {
            const normalized = String(item || '').trim();
            if (normalized) items.push(normalized);
        };

        if (Array.isArray(value)) {
            for (const item of value) appendItem(item);
        } else if (typeof value === 'string' || typeof value === 'number') {
            appendItem(value);
        }

        if (items.length === 0) {
            appendItem(fallback);
        }

        return items;
    }

    normalizeDamageTypes(value: any, fallback: any = ''): string[] {
        const items: string[] = [];
        const seen = new Set<string>();

        const appendItem = (item: any) => {
            const normalized = String(item || '').trim();
            if (!normalized || seen.has(normalized)) return;
            seen.add(normalized);
            items.push(normalized);
        };

        if (Array.isArray(value)) {
            for (const item of value) appendItem(item);
        } else if (typeof value === 'string' || typeof value === 'number') {
            appendItem(value);
        }

        if (items.length === 0) {
            appendItem(fallback);
        }

        return items;
    }

    getDamageTypeItems(damage: any): string[] {
        if (!damage) return [];
        return this.normalizeDamageTypes(damage.damageTypes, damage.damageType);
    }

    getRepresentativeDamageType(damageTypes: any): string {
        const items = this.normalizeDamageTypes(damageTypes);
        for (let index = items.length - 1; index >= 0; index--) {
            if (items[index] !== '기타') return items[index];
        }
        return items[items.length - 1] || '';
    }

    get selectedDamageTypes(): string[] {
        return this.normalizeDamageTypes(this.formData.damageTypes, this.formData.damageType);
    }

    isDamageTypeSelected(damageType: string): boolean {
        return this.selectedDamageTypes.includes(damageType);
    }

    isKnownDamageSubtype(subType: string): boolean {
        const normalized = String(subType || '').trim();
        if (!normalized) return false;

        return this.CATEGORIES.some((category: any) => Array.isArray(category.subs) && category.subs.includes(normalized));
    }

    getSubtypesByDamageTypes(damageTypes: string[]): string[] {
        const items: string[] = [];
        const seen = new Set<string>();

        for (const damageType of this.normalizeDamageTypes(damageTypes)) {
            const subtypes = this.getSubtypesByDamageType(damageType);
            for (const subtype of subtypes) {
                if (seen.has(subtype)) continue;
                seen.add(subtype);
                items.push(subtype);
            }
        }

        return items;
    }

    getDamageContentItems(damage: any): string[] {
        if (!damage) return [];

        const items = this.normalizeDamageSubTypes(damage.damageSubTypes, damage.damageSubType);
        if (items.length > 0) return items;

        return this.getDamageTypeItems(damage);
    }

    getDamageContentSummary(damage: any): string {
        if (!damage) return '유형 미지정';

        const damageTypes = this.getDamageTypeItems(damage);
        const damageTypeSummary = damageTypes.join(', ');
        const contentItems = this.getDamageContentItems(damage);
        const filteredContents = contentItems.filter((item: string) => !damageTypes.includes(item));

        if (damageTypeSummary === '' && contentItems.length === 0) {
            return '유형 미지정';
        }

        if (damageTypes.length === 1 && damageTypes[0] === '기타' && filteredContents.length > 0) {
            return filteredContents.join(', ');
        }

        if (filteredContents.length === 0) {
            return damageTypeSummary || contentItems.join(', ');
        }

        if (!damageTypeSummary) {
            return filteredContents.join(', ');
        }

        return `${damageTypeSummary} · ${filteredContents.join(', ')}`;
    }

    get selectedDamageContents(): string[] {
        return this.normalizeDamageSubTypes(this.formData.damageSubTypes, this.formData.damageSubType);
    }

    getDamageSubTypeSelectedCount(subType: string): number {
        return this.selectedDamageContents.filter((item: string) => item === subType).length;
    }

    getDraftDamageSubTypes(): string[] {
        let items = this.selectedDamageContents;
        const pendingCustom = this.isDamageTypeSelected('기타')
            ? String(this.formData.damageTypeCustom || '').trim()
            : '';

        if (pendingCustom) {
            items = [...items, pendingCustom];
        }

        return items;
    }

    flushPendingDamageTypeCustom() {
        if (!this.isDamageTypeSelected('기타')) return;

        const pendingCustom = String(this.formData.damageTypeCustom || '').trim();
        if (!pendingCustom) return;

        this.formData.damageSubTypes = [...this.selectedDamageContents, pendingCustom];
        this.formData.damageSubType = pendingCustom;
        this.formData.damageTypeCustom = '';
    }

    resolveSyncClientId(): string {
        const key = 'inspectpro.sync.client_id';
        try {
            const existing = localStorage.getItem(key);
            if (existing) return existing;
            const generated = (typeof crypto !== 'undefined' && crypto.randomUUID)
                ? crypto.randomUUID()
                : `client_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
            localStorage.setItem(key, generated);
            return generated;
        } catch (error) {
            return `client_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
        }
    }

    normalizeLoadedDamages() {
        for (const d of this.damages) {
            if (d.arrow && !d.arrows) {
                d.arrows = [d.arrow];
                delete d.arrow;
            } else if (!d.arrows) {
                d.arrows = [];
            }
            d.measurements = this.normalizeMeasurements(d.measurements);
            d.photoRepresentativeLocked = d.photoRepresentativeLocked === true;
            d.photos = this.cloneDamagePhotos(d.photos, d.photoRepresentativeLocked);
            d.damageTypes = this.normalizeDamageTypes(d.damageTypes, d.damageType);
            d.damageType = this.getRepresentativeDamageType(d.damageTypes);
            d.damageSubTypes = this.normalizeDamageSubTypes(d.damageSubTypes, d.damageSubType);
            d.damageSubType = d.damageSubTypes[d.damageSubTypes.length - 1] || d.damageSubType || '';
        }
        this.normalizeDamageNumbers();
    }

    ensureSyncEntity(entity: any, type: string, touch: boolean = false) {
        void type;
        void touch;
        if (!entity || typeof entity !== 'object') return;
        if (!entity.id) entity.id = this.generateId();
    }

    ensureSyncMetadataForCurrentState(touch: boolean = false) {
        for (const damage of this.damages) this.ensureSyncEntity(damage, 'damage', touch);
        for (const drawing of this.drawings) this.ensureSyncEntity(drawing, 'annotation', touch);
    }

    getSyncEntityId(entity: any): string {
        if (entity && entity.metaType === this.VIEWER_STATE_META_TYPE) return '__viewer_state__';
        return String(entity?.id || '');
    }

    stripSyncOnlyFields(value: any): any {
        if (Array.isArray(value)) return value.map((item: any) => this.stripSyncOnlyFields(item));
        if (value && typeof value === 'object') {
            const result: any = {};
            for (const key of Object.keys(value)) {
                if (['syncType', 'syncClientId', 'syncCreatedAt', 'syncCreatedBy', 'syncUpdatedAt', 'syncUpdatedBy'].includes(key)) {
                    continue;
                }
                result[key] = this.stripSyncOnlyFields(value[key]);
            }
            return result;
        }
        return value;
    }

    buildSyncEntityState(): any {
        const state: any = { damage: {}, annotation: {} };
        const damageItems = this.buildSnapshotDamages();
        const annotationItems = this.buildSnapshotDrawingPayload().map((item: any) => {
            if (item && item.metaType === this.VIEWER_STATE_META_TYPE) {
                return { ...item, id: '__viewer_state__' };
            }
            return item;
        });

        const addItem = (type: string, item: any) => {
            const id = this.getSyncEntityId(item);
            if (!id) return;
            const payload = this.sortSnapshotValue(this.stripSyncOnlyFields(item));
            state[type][id] = {
                payload,
                hash: JSON.stringify(payload)
            };
        };

        damageItems.forEach((item: any) => addItem('damage', item));
        annotationItems.forEach((item: any) => addItem('annotation', item));
        return state;
    }

    buildSyncOperations(): any[] {
        const current = this.buildSyncEntityState();
        const previous = this.lastSavedEntityState || { damage: {}, annotation: {} };
        const operations: any[] = [];
        const createdAt = new Date().toISOString();
        const makeOperation = (type: string, entityId: string, action: string, payload: any, beforeHash: string = '', payloadHash: string = '', beforePayload: any = undefined) => {
            const opId = `${this.syncClientId}_${Date.now()}_${operations.length}_${this.generateId()}`;
            const operation: any = {
                op_id: opId,
                operation_id: opId,
                entity_type: type,
                entity_id: entityId,
                action,
                base_revision: this.syncState?.revision || 0,
                client_id: this.syncClientId,
                created_at: createdAt
            };
            if (beforeHash) operation.before_hash = beforeHash;
            if (beforePayload !== undefined) operation.before_payload = beforePayload;
            if (payload !== undefined) operation.payload = payload;
            if (payloadHash) operation.payload_hash = payloadHash;
            return operation;
        };

        const appendOps = (type: string) => {
            const currentMap = current[type] || {};
            const previousMap = previous[type] || {};

            for (const id of Object.keys(currentMap)) {
                const prev = previousMap[id];
                const cur = currentMap[id];
                if (!prev) {
                    operations.push(makeOperation(type, id, 'create', cur.payload, '', cur.hash));
                } else if (prev.hash !== cur.hash) {
                    operations.push(makeOperation(type, id, 'update', cur.payload, prev.hash, cur.hash, prev.payload));
                }
            }

            for (const id of Object.keys(previousMap)) {
                if (!currentMap[id]) {
                    operations.push(makeOperation(type, id, 'delete', undefined, previousMap[id].hash, previousMap[id].hash, previousMap[id].payload));
                }
            }
        };

        appendOps('damage');
        appendOps('annotation');
        return operations;
    }

    hashText(value: string): string {
        let hash = 2166136261;
        for (let i = 0; i < value.length; i++) {
            hash ^= value.charCodeAt(i);
            hash = Math.imul(hash, 16777619);
        }
        return (hash >>> 0).toString(16).padStart(8, '0');
    }

    buildSaveOperationId(operations: any[]): string {
        const opIds = (Array.isArray(operations) ? operations : [])
            .map((operation: any) => operation?.operation_id || operation?.op_id)
            .filter((id: any) => !!id)
            .join('|');
        if (opIds) {
            return `${this.syncClientId}_${this.syncState?.revision || 0}_${this.hashText(opIds)}`;
        }
        return `${this.syncClientId}_${this.syncState?.revision || 0}_noop_${Date.now()}_${this.generateId()}`;
    }

    buildSnapshotDamages(): any[] {
        const snapshotDamages = this.damages.map((damage: any) => ({
            ...damage,
            points: Array.isArray(damage.points) ? damage.points.map((point: any) => ({ ...point })) : [],
            arrows: Array.isArray(damage.arrows) ? damage.arrows.map((arrow: any) => ({ ...arrow })) : [],
            measurements: this.normalizeMeasurements(damage.measurements),
            photos: Array.isArray(damage.photos) ? damage.photos.map((photo: any) => ({ ...photo })) : []
        }));

        const draft = this.buildSelectedDamageDraft();
        if (!draft || !this.selectedDamage) return snapshotDamages;

        const selectedIndex = this.damages.indexOf(this.selectedDamage);
        if (selectedIndex < 0 || selectedIndex >= snapshotDamages.length) return snapshotDamages;

        snapshotDamages[selectedIndex] = {
            ...draft,
            points: Array.isArray(draft.points) ? draft.points.map((point: any) => ({ ...point })) : [],
            arrows: Array.isArray(draft.arrows) ? draft.arrows.map((arrow: any) => ({ ...arrow })) : [],
            measurements: this.normalizeMeasurements(draft.measurements),
            photos: Array.isArray(draft.photos) ? draft.photos.map((photo: any) => ({ ...photo })) : []
        };

        return snapshotDamages;
    }

    sortSnapshotValue(value: any): any {
        if (Array.isArray(value)) {
            return value.map((item: any) => this.sortSnapshotValue(item));
        }

        if (value && typeof value === 'object') {
            const sorted: any = {};
            for (const key of Object.keys(value).sort()) {
                sorted[key] = this.sortSnapshotValue(value[key]);
            }
            return sorted;
        }

        return value;
    }

    buildSaveStateSnapshot(): string {
        return JSON.stringify(this.sortSnapshotValue({
            damages: this.buildSnapshotDamages(),
            drawings: this.buildSnapshotDrawingPayload(),
            overviewPhotos: this.facilityOverviewPhotos
        }));
    }

    get hasUnsavedChanges(): boolean {
        if (!this.hasSnapshotBaseline) return false;
        return this.buildSaveStateSnapshot() !== this.lastSavedSnapshot;
    }

    syncSelectedDamageFromForm(closePanel: boolean = true) {
        if (!this.selectedDamage) return;

        this.flushPendingDamageTypeCustom();

        const draft = this.buildSelectedDamageDraft();
        if (!draft) return;

        Object.assign(this.selectedDamage, draft);
        this.renderMarkers();

        if (closePanel) {
            this.showPanel = false;
            this.selectedDamage = null;
        }

        this.ref.detectChanges();
    }

    isViewerStateItem(item: any): boolean {
        return !!item && item.metaType === this.VIEWER_STATE_META_TYPE;
    }

    normalizeRotation(value: any): number {
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return 0;
        const snapped = Math.round(numeric / 90) * 90;
        return ((snapped % 360) + 360) % 360;
    }

    normalizePageRotations(value: any): { [page: string]: number } {
        const result: { [page: string]: number } = {};
        if (!value || typeof value !== 'object') return result;

        for (const [page, rotation] of Object.entries(value)) {
            const pageNumber = Number(page);
            if (!Number.isInteger(pageNumber) || pageNumber < 1) continue;
            const normalized = this.normalizeRotation(rotation);
            if (normalized === 0) continue;
            result[String(pageNumber)] = normalized;
        }

        return result;
    }

    ensureExplicitPageRotations() {
        if (this.legacyRotationDegrees === 0) return;
        const pageCount = Math.max(this.totalPages, this.currentPage, 1);
        for (let page = 1; page <= pageCount; page++) {
            const key = String(page);
            if (this.pageRotations[key] === undefined) {
                this.pageRotations[key] = this.legacyRotationDegrees;
            }
        }
        this.legacyRotationDegrees = 0;
    }

    getPageRotation(page: number): number {
        if (!Number.isInteger(page) || page < 1) return 0;
        const explicit = this.pageRotations[String(page)];
        if (explicit !== undefined) return this.normalizeRotation(explicit);
        return this.legacyRotationDegrees;
    }

    setPageRotation(page: number, value: number) {
        if (!Number.isInteger(page) || page < 1) return;
        this.ensureExplicitPageRotations();
        const key = String(page);
        const normalized = this.normalizeRotation(value);
        if (normalized === 0) delete this.pageRotations[key];
        else this.pageRotations[key] = normalized;
    }

    buildRotationMapForSave(): { [page: string]: number } {
        const rotationByPage = this.normalizePageRotations(this.pageRotations);

        if (this.legacyRotationDegrees !== 0) {
            const pageCount = Math.max(this.totalPages, this.currentPage, 1);
            for (let page = 1; page <= pageCount; page++) {
                const key = String(page);
                if (rotationByPage[key] === undefined) {
                    rotationByPage[key] = this.legacyRotationDegrees;
                }
            }
        }

        return rotationByPage;
    }

    getPageRotationQuarterTurns(page: number): number {
        return Math.round(this.getPageRotation(page) / 90) % 4;
    }

    buildRotationQuarterTurnsMapForSave(): { [page: string]: number } {
        this.ensureExplicitPageRotations();
        const result: { [page: string]: number } = {};
        const pageCount = Math.max(this.totalPages, this.currentPage, 1);
        for (let page = 1; page <= pageCount; page++) {
            result[String(page)] = this.getPageRotationQuarterTurns(page);
        }
        return result;
    }

    get rotationQuarterTurns(): number {
        return this.getPageRotationQuarterTurns(this.currentPage);
    }

    get rotationDegrees(): number {
        return this.getPageRotation(this.currentPage);
    }

    set rotationDegrees(value: number) {
        this.setPageRotation(this.currentPage, value);
    }

    getRotationOffset(width: number = this.pdfCanvas?.width || 0, height: number = this.pdfCanvas?.height || 0, rotationDegrees: number = this.rotationDegrees): { x: number; y: number } {
        switch (rotationDegrees) {
            case 90:
                return { x: height, y: 0 };
            case 180:
                return { x: width, y: height };
            case 270:
                return { x: 0, y: width };
            default:
                return { x: 0, y: 0 };
        }
    }

    getRotatedCanvasSize(width: number = this.pdfCanvas?.width || 0, height: number = this.pdfCanvas?.height || 0, rotationDegrees: number = this.rotationDegrees): { width: number; height: number } {
        if (rotationDegrees === 90 || rotationDegrees === 270) {
            return { width: height, height: width };
        }
        return { width, height };
    }

    rotatePointToCanvas(x: number, y: number, width: number, height: number, rotationDegrees: number = this.rotationDegrees): { x: number; y: number } {
        switch (rotationDegrees) {
            case 90:
                return { x: y, y: -x };
            case 180:
                return { x: -x, y: -y };
            case 270:
                return { x: -y, y: x };
            default:
                return { x, y };
        }
    }

    rotatePointForDisplay(x: number, y: number, width: number, height: number, rotationDegrees: number = this.rotationDegrees): { x: number; y: number } {
        switch (rotationDegrees) {
            case 90:
                return { x: height - y, y: x };
            case 180:
                return { x: width - x, y: height - y };
            case 270:
                return { x: y, y: width - x };
            default:
                return { x, y };
        }
    }

    getMarkerLabelTransform(rotationDegrees: number = this.rotationDegrees): string {
        return `translate(-50%, -50%) rotate(${-rotationDegrees}deg)`;
    }

    getMarkerLabelStyle(marker: any): any {
        const point = marker?.points?.[0];
        if (!point) return null;

        return {
            left: `${point.x}px`,
            top: `${point.y}px`,
            transform: this.getMarkerLabelTransform()
        };
    }

    getCanvasCoords(clientX: number, clientY: number): { x: number; y: number } | null {
        if (!this.container || !this.pdfCanvas) return null;
        const rect = this.container.getBoundingClientRect();
        const offset = this.getRotationOffset(this.pdfCanvas.width, this.pdfCanvas.height, this.rotationDegrees);
        const rotatedX = (clientX - rect.left - this.panX) / this.zoomLevel - offset.x;
        const rotatedY = (clientY - rect.top - this.panY) / this.zoomLevel - offset.y;
        const point = this.rotatePointToCanvas(rotatedX, rotatedY, this.pdfCanvas.width, this.pdfCanvas.height, this.rotationDegrees);
        if (point.x < 0 || point.y < 0 || point.x > this.pdfCanvas.width || point.y > this.pdfCanvas.height) return null;
        return point;
    }

    isUIElement(target: EventTarget | null): boolean {
        if (!target || !(target instanceof HTMLElement)) return false;
        return !!target.closest('.viewer-top-controls, .zoom-controls, .page-controls, .page-nav-btn, .page-info-bar, .placement-bar, .draw-toolbar, button');
    }

    // ================================================================
    //  PAN / ZOOM
    // ================================================================

    get wrapperTransform(): string {
        const offset = this.getRotationOffset(undefined, undefined, this.rotationDegrees);
        return `translate(${this.panX}px, ${this.panY}px) scale(${this.zoomLevel}) translate(${offset.x}px, ${offset.y}px) rotate(${this.rotationDegrees}deg)`;
    }

    fitToScreen() {
        if (!this.container || !this.pdfCanvas) return;
        const cw = this.container.clientWidth;
        const ch = this.container.clientHeight;
        const canvasSize = this.getRotatedCanvasSize(this.pdfCanvas.width, this.pdfCanvas.height, this.rotationDegrees);
        if (canvasSize.width === 0 || canvasSize.height === 0) return;
        this.zoomLevel = Math.min(cw / canvasSize.width, ch / canvasSize.height) * 0.92;
        this.panX = (cw - canvasSize.width * this.zoomLevel) / 2;
        this.panY = (ch - canvasSize.height * this.zoomLevel) / 2;
        this.ref.detectChanges();
    }

    rotateClockwise() {
        const nextQuarterTurns = (this.rotationQuarterTurns + 1) % 4;
        this.rotationDegrees = nextQuarterTurns * 90;
        this.renderMarkers();
        this.renderDrawings();
        void this.generatePageThumbnails();
        this.fitToScreen();
    }

    get rotationLabel(): string {
        return `${this.rotationQuarterTurns} (${this.rotationDegrees}°)`;
    }

    zoomAtPoint(delta: number, cx: number, cy: number) {
        this.setZoomLevel(this.zoomLevel + delta, cx, cy);
    }

    setZoomLevel(nextZoom: number, cx: number, cy: number) {
        const oldZoom = this.zoomLevel || 1;
        const newZoom = Math.max(0.3, Math.min(5, nextZoom));
        if (Math.abs(newZoom - oldZoom) < 0.0001) return;
        this.panX = cx - (cx - this.panX) * (newZoom / oldZoom);
        this.panY = cy - (cy - this.panY) * (newZoom / oldZoom);
        this.zoomLevel = newZoom;
        this.ref.detectChanges();
    }

    get zoomPercent(): number {
        return Math.round(this.zoomLevel * 100);
    }

    onZoomSliderInput(value: any) {
        if (!this.container) return;
        const percent = Number(value);
        if (!Number.isFinite(percent)) return;
        this.setZoomLevel(percent / 100, this.container.clientWidth / 2, this.container.clientHeight / 2);
    }

    zoomIn() {
        if (!this.container) return;
        this.zoomAtPoint(0.2, this.container.clientWidth / 2, this.container.clientHeight / 2);
    }

    zoomOut() {
        if (!this.container) return;
        this.zoomAtPoint(-0.2, this.container.clientWidth / 2, this.container.clientHeight / 2);
    }

    // ================================================================
    //  MOUSE EVENTS (with marker drag + drawing support)
    // ================================================================

    onWheel(e: WheelEvent) {
        e.preventDefault();
        if (!this.container) return;
        const rect = this.container.getBoundingClientRect();
        this.zoomAtPoint(e.deltaY > 0 ? -0.1 : 0.1, e.clientX - rect.left, e.clientY - rect.top);
    }

    // drawing-shape-pointer-down-v2
    onPointerDown(e){if(e.button!==0||this.isUIElement(e.target))return;let rect=this.container.getBoundingClientRect(),sx=e.clientX-rect.left,sy=e.clientY-rect.top;this.longPressTimer&&(clearTimeout(this.longPressTimer),this.longPressTimer=null);this.cancelDrawingShapeMove(true);this.drawingShapeGestureTarget=null;this.tapStartTime=Date.now();this.tapStartPos={x:sx,y:sy};this.wasTap=true;this.isDraggingMarker=false;this.dragTarget=null;this.isArrowDragging=false;this.arrowDragTarget=null;if(this.currentMode==="draw"){let cp=this.getCanvasCoords(e.clientX,e.clientY);if(cp){let shape=this.findMovableDrawingShapeAt(cp.x,cp.y);if(shape){let moveStart={x:cp.x,y:cp.y};this.drawingShapeGestureTarget=shape;this.drawingShapeLongPressStartPos={x:sx,y:sy};this.drawingShapeLongPressTimer=setTimeout(()=>{this.drawingShapeLongPressTimer=null;this.beginDrawingShapeMove(shape,moveStart)},500);this.drawTool==="eraser"&&this.updateEraserCursor(cp.x,cp.y);return}this.drawTool!=="fill"&&(this.updateEraserCursor(cp.x,cp.y),this.startDrawing(cp.x,cp.y))}return}this.hideEraserCursor();if(this.currentMode==="point"&&this.pointTool!=="erase"){let cp=this.getCanvasCoords(e.clientX,e.clientY);if(cp){let marker=this.findMarkerAt(cp.x,cp.y);marker&&(this.longPressStartPos={x:sx,y:sy},this.longPressTimer=setTimeout(()=>{this.isArrowDragging=true;this.arrowDragTarget=marker;this.wasTap=false;this.isPanning=false},500))}}if(this.currentMode==="pan"){let cp=this.getCanvasCoords(e.clientX,e.clientY);if(cp){let marker=this.findMarkerAt(cp.x,cp.y);marker&&(this.dragTarget=marker)}}this.isPanning=true;this.panStartX=sx;this.panStartY=sy;this.panStartPanX=this.panX;this.panStartPanY=this.panY}












































































    // drawing-shape-pointer-move-v2
    onPointerMove(e){let cp=this.getCanvasCoords(e.clientX,e.clientY);if(this.drawingShapeLongPressTimer&&this.container){let rect=this.container.getBoundingClientRect(),sx=e.clientX-rect.left,sy=e.clientY-rect.top,dx=sx-this.drawingShapeLongPressStartPos.x,dy=sy-this.drawingShapeLongPressStartPos.y;if(Math.sqrt(dx*dx+dy*dy)>10){this.clearDrawingShapeLongPress();if(this.drawingShapeGestureTarget){this.drawingShapeGestureTarget=null;this.wasTap=false;if(cp&&this.currentMode==="draw"&&this.drawTool!=="fill"){this.updateEraserCursor(cp.x,cp.y);this.startDrawing(cp.x,cp.y)}}}}if(this.isMovingDrawingShape){cp&&this.updateDrawingShapeMove(cp.x,cp.y);return}this.currentMode==="draw"&&this.drawTool==="eraser"&&cp?this.updateEraserCursor(cp.x,cp.y):this.eraserCursor.visible&&this.hideEraserCursor();if(this.currentMode==="draw"&&this.drawTool==="fill"){if(this.container){let rect=this.container.getBoundingClientRect(),dx=e.clientX-rect.left-this.tapStartPos.x,dy=e.clientY-rect.top-this.tapStartPos.y;Math.sqrt(dx*dx+dy*dy)>8&&(this.wasTap=false)}return}if(this.currentMode==="draw"&&this.isDrawing){cp&&this.continueDrawing(cp.x,cp.y);return}if(this.isArrowDragging&&this.arrowDragTarget){let arrowPoint=this.getCanvasCoords(e.clientX,e.clientY);if(arrowPoint){this.renderMarkers();let ctx=this.annotCtx,p=this.arrowDragTarget.points[0];ctx.save();ctx.strokeStyle="#000000";ctx.lineWidth=2.5;ctx.lineCap="round";this.drawArrow(ctx,p.x,p.y,arrowPoint.x,arrowPoint.y,2.5);ctx.restore()}return}if(this.longPressTimer){if(!this.container)return;let rect=this.container.getBoundingClientRect(),sx=e.clientX-rect.left,sy=e.clientY-rect.top,ldx=sx-this.longPressStartPos.x,ldy=sy-this.longPressStartPos.y;Math.sqrt(ldx*ldx+ldy*ldy)>10&&(clearTimeout(this.longPressTimer),this.longPressTimer=null)}if(!this.isPanning)return;let rect=this.container.getBoundingClientRect(),sx=e.clientX-rect.left,sy=e.clientY-rect.top,dx=sx-this.panStartX,dy=sy-this.panStartY;if(Math.abs(dx)>5||Math.abs(dy)>5){this.wasTap=false;if(this.dragTarget&&this.currentMode==="pan"){this.isDraggingMarker=true;let markerPoint=this.getCanvasCoords(e.clientX,e.clientY);markerPoint&&this.dragTarget.points&&this.dragTarget.points.length>0&&(this.dragTarget.points[0].x=markerPoint.x,this.dragTarget.points[0].y=markerPoint.y,this.renderMarkers(),this.ref.detectChanges());return}}this.isDraggingMarker||(this.panX=this.panStartPanX+dx,this.panY=this.panStartPanY+dy,this.ref.detectChanges())}







































































































    // drawing-shape-pointer-up-v2
    onPointerUp(e){this.longPressTimer&&(clearTimeout(this.longPressTimer),this.longPressTimer=null);this.clearDrawingShapeLongPress();if(this.isMovingDrawingShape){let cp=this.getCanvasCoords(e.clientX,e.clientY);cp&&this.updateDrawingShapeMove(cp.x,cp.y);this.drawingShapeGestureTarget=null;this.finishDrawingShapeMove();return}if(this.currentMode==="draw"&&this.drawingShapeGestureTarget){let shape=this.drawingShapeGestureTarget;this.drawingShapeGestureTarget=null;let cp=this.getCanvasCoords(e.clientX,e.clientY);if(cp&&this.wasTap&&Date.now()-this.tapStartTime<500){let handled=this.handleDrawingShapeTap(shape,cp.x,cp.y);!handled&&this.drawTool==="fill"&&this.handleTap(cp.x,cp.y);this.drawTool==="eraser"?this.updateEraserCursor(cp.x,cp.y):this.hideEraserCursor();return}}if(this.isUIElement(e.target)){this.isPanning=false;this.isDraggingMarker=false;this.dragTarget=null;this.isArrowDragging=false;this.arrowDragTarget=null;return}if(this.isArrowDragging&&this.arrowDragTarget){let cp=this.getCanvasCoords(e.clientX,e.clientY);if(cp){let p=this.arrowDragTarget.points[0],dist=Math.sqrt((cp.x-p.x)**2+(cp.y-p.y)**2);if(dist>15){let newArrow={toX:cp.x,toY:cp.y};this.arrowDragTarget.arrows||(this.arrowDragTarget.arrows=[]);this.arrowDragTarget.arrows.push(newArrow);this.pushUndo({type:"add-arrow",data:this.arrowDragTarget,arrow:newArrow})}}this.isArrowDragging=false;this.arrowDragTarget=null;this.isPanning=false;this.renderMarkers();this.ref.detectChanges();return}if(this.currentMode==="draw"&&this.isDrawing){let cp=this.getCanvasCoords(e.clientX,e.clientY);cp?this.endDrawing(cp.x,cp.y):this.cancelCurrentDrawing();this.drawTool==="eraser"&&(cp?this.updateEraserCursor(cp.x,cp.y):this.hideEraserCursor());return}if(this.isDraggingMarker){this.isDraggingMarker=false;this.dragTarget=null;this.isPanning=false;this.renderMarkers();this.ref.detectChanges();return}if(this.wasTap&&Date.now()-this.tapStartTime<300){let cp=this.getCanvasCoords(e.clientX,e.clientY);cp&&this.handleTap(cp.x,cp.y)}this.isPanning=false;this.dragTarget=null;(this.currentMode!=="draw"||this.drawTool!=="eraser")&&this.hideEraserCursor()}
















































































    // ================================================================
    //  TOUCH EVENTS (with marker drag + drawing support)
    // ================================================================

    onTouchStart(e: TouchEvent) {
        if (this.isUIElement(e.target as EventTarget)) return;
        e.preventDefault();
        if (e.touches.length === 2) {
            this.wasTap = false;
            // Pinch to zoom — stop drawing and restore an uncommitted shape move.
            if (this.isDrawing) {
                this.cancelCurrentDrawing();
            }
            this.cancelDrawingShapeMove(true);
            this.isPinching = true;
            this.isPanning = false;
            this.isDraggingMarker = false;
            this.dragTarget = null;
            const d = this.getTouchDist(e.touches[0], e.touches[1]);
            const m = this.getTouchMid(e.touches[0], e.touches[1]);
            this.pinchStartDist = d;
            this.pinchStartZoom = this.zoomLevel;
            this.pinchMidX = m.x;
            this.pinchMidY = m.y;
            this.panStartPanX = this.panX;
            this.panStartPanY = this.panY;
        } else if (e.touches.length === 1) {
            this.onPointerDown({
                clientX: e.touches[0].clientX,
                clientY: e.touches[0].clientY,
                button: 0,
                target: e.target
            } as any);
        }
    }

    onTouchMove(e: TouchEvent) {
        if (this.isUIElement(e.target as EventTarget)) return;
        e.preventDefault();
        if (e.touches.length === 2 && this.isPinching) {
            const d = this.getTouchDist(e.touches[0], e.touches[1]);
            const m = this.getTouchMid(e.touches[0], e.touches[1]);
            const newZoom = Math.max(0.3, Math.min(5, this.pinchStartZoom * (d / this.pinchStartDist)));
            const rect = this.container!.getBoundingClientRect();
            const midX = m.x - rect.left;
            const midY = m.y - rect.top;
            const startMidX = this.pinchMidX - rect.left;
            const startMidY = this.pinchMidY - rect.top;
            this.panX = this.panStartPanX + (midX - startMidX) - (midX - this.panStartPanX) * (newZoom / this.pinchStartZoom - 1);
            this.panY = this.panStartPanY + (midY - startMidY) - (midY - this.panStartPanY) * (newZoom / this.pinchStartZoom - 1);
            this.zoomLevel = newZoom;
            this.ref.detectChanges();
        } else if (e.touches.length === 1 && !this.isPinching) {
            this.onPointerMove({
                clientX: e.touches[0].clientX,
                clientY: e.touches[0].clientY
            } as MouseEvent);
        }
    }

    onTouchEnd(e: TouchEvent) {
        if (this.isPinching) {
            if (e.touches.length < 2) this.isPinching = false;
            return;
        }
        if (e.touches.length === 0 && e.changedTouches.length > 0) {
            const t = e.changedTouches[0];
            this.onPointerUp({ clientX: t.clientX, clientY: t.clientY } as MouseEvent);
        }
    }

    onTouchCancel() {
        if (this.isDrawing) this.cancelCurrentDrawing();
        this.cancelDrawingShapeMove(true);
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
            this.longPressTimer = null;
        }
        this.wasTap = false;
        this.isArrowDragging = false;
        this.arrowDragTarget = null;
        this.isPinching = false;
        this.isPanning = false;
        this.isDraggingMarker = false;
        this.dragTarget = null;
        this.hideEraserCursor();
    }

    getTouchDist(t1: Touch, t2: Touch): number {
        return Math.sqrt((t1.clientX - t2.clientX) ** 2 + (t1.clientY - t2.clientY) ** 2);
    }

    getTouchMid(t1: Touch, t2: Touch): { x: number; y: number } {
        return { x: (t1.clientX + t2.clientX) / 2, y: (t1.clientY + t2.clientY) / 2 };
    }

    // ================================================================
    //  TAP HANDLING & TOOL DISPATCH
    // ================================================================

    handleTap(x: number, y: number) {
        if (this.currentMode === 'pan') {
            const marker = this.findMarkerAt(x, y);
            if (marker) {
                this.selectDamage(marker);
            } else {
                this.selectedDamage = null;
                if (this.panelMode === 'form') this.showPanel = false;
                this.renderMarkers();
                this.ref.detectChanges();
            }
        } else if (this.currentMode === 'point') {
            const marker = this.findMarkerAt(x, y);
            if (this.pointTool === 'erase') {
                if (marker) {
                    this.removeDamageMarker(marker);
                }
            } else if (this.pointTool === 'select') {
                if (marker) {
                    this.selectDamage(marker);
                } else {
                    this.selectedDamage = null;
                    if (this.panelMode === 'form') this.showPanel = false;
                    this.renderMarkers();
                    this.ref.detectChanges();
                }
            } else if (marker) {
                this.selectDamage(marker);
            } else {
                this.createDamageMarker('point', [{ x, y }]);
            }
        } else if (this.currentMode === 'draw' && this.drawTool === 'fill') {
            this.applyFillAt(x, y);
        }
    }

    setPointTool(tool: string) {
        this.pointTool = tool;

        if (tool !== 'select') {
            this.selectedDamage = null;
            if (this.panelMode === 'form') this.showPanel = false;
            this.renderMarkers();
        }

        this.ref.detectChanges();
    }

    setMode(mode: string) {
        this.cancelDrawingShapeMove(true);
        // 모드 전환 시 진행 중 드로잉이 있으면 취소
        if (this.isDrawing) {
            this.cancelCurrentDrawing();
        }
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
            this.longPressTimer = null;
        }
        this.isArrowDragging = false;
        this.arrowDragTarget = null;
        this.currentMode = mode;
        this.showGridToolbar = false;
        this.showDrawToolbar = (mode === 'draw');
        if (mode !== 'draw') {
            this.showShapeMenu = false;
            this.showLineStyleMenu = false;
            this.showFillPatternMenu = false;
        }

        if (mode !== 'point') {
            this.pointTool = 'add';
        }

        if (mode !== 'draw' || this.drawTool !== 'eraser') {
            this.hideEraserCursor();
        }

        this.ref.detectChanges();
    }

    toggleGridToolbar() {
        this.showGridToolbar = !this.showGridToolbar;
        this.ref.detectChanges();
    }

    toggleGrid() {
        this.gridEnabled = !this.gridEnabled;
        this.ref.detectChanges();
    }

    setGridSpacing(value: any) {
        const next = Number(value);
        if (!Number.isFinite(next)) return;
        this.gridSpacing = Math.max(
            this.GRID_SPACING_MIN,
            Math.min(this.GRID_SPACING_MAX, Math.round(next))
        );
        this.ref.detectChanges();
    }

    setGridBrightness(value: any) {
        const next = Number(value);
        if (!Number.isFinite(next)) return;
        this.gridBrightness = Math.max(
            this.GRID_BRIGHTNESS_MIN,
            Math.min(this.GRID_BRIGHTNESS_MAX, Math.round(next))
        );
        this.ref.detectChanges();
    }

    get gridColor(): string {
        const alpha = Math.max(
            this.GRID_BRIGHTNESS_MIN,
            Math.min(this.GRID_BRIGHTNESS_MAX, this.gridBrightness)
        ) / 100;
        return `rgba(100, 116, 139, ${alpha})`;
    }

    get isShapeToolActive(): boolean {
        return this.SHAPE_TOOLS.some((item: any) => item.value === this.drawTool);
    }

    get selectedShapeToolName(): string {
        return this.SHAPE_TOOLS.find((item: any) => item.value === this.shapeTool)?.name || '도형';
    }

    get selectedLineStyleName(): string {
        return this.LINE_STYLES.find((item: any) => item.value === this.lineStyle)?.name || '직선';
    }

    isDrawToolActive(tool: string): boolean {
        return tool === 'shape' ? this.isShapeToolActive : this.drawTool === tool;
    }

    setDrawTool(tool: string) {
        this.cancelDrawingShapeMove(true);
        if (this.isDrawing) this.cancelCurrentDrawing();

        if (tool === 'shape') {
            const wasShapeActive = this.isShapeToolActive;
            if (!wasShapeActive) this.drawTool = this.shapeTool;
            this.showShapeMenu = !wasShapeActive || !this.showShapeMenu;
            this.showLineStyleMenu = false;
            this.showFillPatternMenu = false;
        } else if (tool === 'line') {
            const wasLineActive = this.drawTool === 'line';
            this.drawTool = 'line';
            this.showLineStyleMenu = !wasLineActive || !this.showLineStyleMenu;
            this.showShapeMenu = false;
            this.showFillPatternMenu = false;
        } else if (tool === 'fill') {
            const wasFillActive = this.drawTool === 'fill';
            this.drawTool = 'fill';
            this.showFillPatternMenu = !wasFillActive || !this.showFillPatternMenu;
            this.showShapeMenu = false;
            this.showLineStyleMenu = false;
        } else {
            this.drawTool = tool;
            this.showShapeMenu = false;
            this.showLineStyleMenu = false;
            this.showFillPatternMenu = false;
        }

        if (tool !== 'eraser') {
            this.hideEraserCursor();
        }

        this.ref.detectChanges();
    }

    getShapeToolsByCategory(category: string): any[] {
        return this.SHAPE_TOOLS.filter((item: any) => item.category === category);
    }

    selectShapeTool(tool: string) {
        if (!this.SHAPE_TOOLS.some((item: any) => item.value === tool)) return;
        this.cancelDrawingShapeMove(true);
        if (this.isDrawing) this.cancelCurrentDrawing();
        this.shapeTool = tool;
        this.drawTool = tool;
        this.showShapeMenu = false;
        this.showLineStyleMenu = false;
        this.showFillPatternMenu = false;
        this.hideEraserCursor();
        this.ref.detectChanges();
    }

    selectLineStyle(style: string) {
        if (!this.LINE_STYLES.some((item: any) => item.value === style)) return;
        this.cancelDrawingShapeMove(true);
        if (this.isDrawing) this.cancelCurrentDrawing();
        this.lineStyle = style;
        this.drawTool = 'line';
        this.showLineStyleMenu = false;
        this.showShapeMenu = false;
        this.showFillPatternMenu = false;
        this.hideEraserCursor();
        this.ref.detectChanges();
    }

    selectFillPattern(pattern: string) {
        if (!this.FILL_PATTERNS.some((item: any) => item.value === pattern)) return;
        this.fillPattern = pattern;
        this.showFillPatternMenu = false;
        this.showShapeMenu = false;
        this.showLineStyleMenu = false;
        this.ref.detectChanges();
    }

    selectDrawSize(size: number) {
        if (this.drawTool === 'eraser') {
            this.eraserSize = size;
        } else {
            this.drawWidth = size;
        }
        this.ref.detectChanges();
    }

    get activeDrawSizes() {
        return this.drawTool === 'eraser' ? this.ERASER_SIZES : this.DRAW_WIDTHS;
    }

    get drawSizeLabel(): string {
        return this.drawTool === 'eraser' ? '지우개 크기' : '두께';
    }

    isDrawSizeActive(size: number): boolean {
        return this.drawTool === 'eraser' ? this.eraserSize === size : this.drawWidth === size;
    }

    getEraserPreviewSize(size: number): number {
        return Math.max(12, Math.min(26, Math.round(size * 0.5)));
    }

    get eraserCursorSize(): number {
        return this.eraserSize;
    }

    updateEraserCursor(x: number, y: number) {
        if (this.currentMode !== 'draw' || this.drawTool !== 'eraser') return;
        this.eraserCursor = { visible: true, x, y };
        this.ref.detectChanges();
    }

    hideEraserCursor() {
        if (!this.eraserCursor.visible) return;
        this.eraserCursor = { visible: false, x: 0, y: 0 };
        this.ref.detectChanges();
    }

    // ================================================================
    //  DRAWING: START / CONTINUE / END
    // ================================================================

    startDrawing(x: number, y: number) {
        const strokeType = this.drawTool === 'eraser' ? 'eraser' : this.drawTool;
        const strokeWidth = this.drawTool === 'eraser' ? this.eraserSize : this.drawWidth;

        this.isDrawing = true;
        this.drawStartPoint = { x, y };
        this.currentStroke = {
            id: this.generateId(),
            type: strokeType,
            color: this.drawColor,
            width: strokeWidth,
            page: this.currentPage,
            points: [{ x, y }]
        };
        if (strokeType === 'line') {
            this.currentStroke.lineStyle = this.lineStyle;
        }
        if (this.DRAWING_SHAPE_TYPES.includes(strokeType)) {
            // Capture the page rotation only while the shape is created.
            // Its geometry is corrected to the screen axes at input time,
            // then remains in page coordinates and rotates with the page.
            this.currentStroke.shapeBaseRotation = this.rotationDegrees;
        }

        if (strokeType === 'freehand' || strokeType === 'eraser') {
            // Start rendering immediately for freehand
            this.renderDrawingPreview();
        }
    }

    continueDrawing(x: number, y: number) {
        if (!this.isDrawing || !this.currentStroke) return;

        if (this.currentStroke.type === 'freehand' || this.currentStroke.type === 'eraser') {
            this.currentStroke.points.push({ x, y });
            this.renderDrawingPreview();
        } else {
            // For shapes: keep only start + current end for preview
            this.currentStroke.points = [this.drawStartPoint!, { x, y }];
            this.renderDrawingPreview();
        }
    }

    endDrawing(x: number, y: number) {
        if (!this.isDrawing || !this.currentStroke) return;

        if (this.currentStroke.type === 'freehand' || this.currentStroke.type === 'eraser') {
            this.currentStroke.points.push({ x, y });
        } else {
            this.currentStroke.points = [this.drawStartPoint!, { x, y }];
        }

        if (this.currentStroke.type === 'freehand') {
            const isClosed = this.isClosedFreehandStroke(this.currentStroke);
            this.currentStroke.closed = isClosed;
            if (isClosed) {
                const first = this.currentStroke.points[0];
                const lastIndex = this.currentStroke.points.length - 1;
                this.currentStroke.points[lastIndex] = { x: first.x, y: first.y };
            }
        }

        // Only save if the stroke has meaningful length
        if (this.isValidStroke(this.currentStroke)) {
            const insertIndex = this.drawings.length;
            this.drawings.push(this.currentStroke);
            this.pushUndo({ type: 'add-drawing', data: this.currentStroke, index: insertIndex });
        }

        this.currentStroke = null;
        this.isDrawing = false;
        this.drawStartPoint = null;
        this.renderDrawings();
        this.ref.detectChanges();
    }

    cancelCurrentDrawing() {
        this.currentStroke = null;
        this.isDrawing = false;
        this.drawStartPoint = null;
        this.renderDrawings();
    }

    isValidStroke(stroke: any): boolean {
        if (!stroke || !stroke.points || stroke.points.length === 0) return false;
        if (stroke.type === 'freehand' || stroke.type === 'eraser') return stroke.points.length >= 2;
        if (stroke.points.length < 2) return false;
        const p0 = stroke.points[0];
        const p1 = stroke.points[1];
        const dist = Math.sqrt((p1.x - p0.x) ** 2 + (p1.y - p0.y) ** 2);
        return dist > 3; // minimum 3px distance
    }

    getFreehandClosureTolerance(stroke: any, adjustForZoom: boolean = true): number {
        const screenTolerance = Math.max(18, (Number(stroke?.width) || 3) * 4);
        return adjustForZoom
            ? screenTolerance / Math.max(Number(this.zoomLevel) || 1, 0.3)
            : screenTolerance;
    }

    getPolygonArea(points: any[]): number {
        let area = 0;
        for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
            area += points[j].x * points[i].y - points[i].x * points[j].y;
        }
        return Math.abs(area) / 2;
    }

    isClosedFreehandStroke(stroke: any, adjustForZoom: boolean = true): boolean {
        if (!stroke || stroke.type !== 'freehand' || !Array.isArray(stroke.points) || stroke.points.length < 4) return false;
        if (typeof stroke.closed === 'boolean') return stroke.closed;

        const points = stroke.points;
        const first = points[0];
        const last = points[points.length - 1];
        const tolerance = this.getFreehandClosureTolerance(stroke, adjustForZoom);
        if (Math.hypot(last.x - first.x, last.y - first.y) > tolerance) return false;

        const xs = points.map((point: any) => point.x);
        const ys = points.map((point: any) => point.y);
        const width = Math.max(...xs) - Math.min(...xs);
        const height = Math.max(...ys) - Math.min(...ys);
        return width >= tolerance * 1.5
            && height >= tolerance * 1.5
            && this.getPolygonArea(points) >= tolerance * tolerance;
    }

    isPointInPolygon(x: number, y: number, points: any[]): boolean {
        let inside = false;
        for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
            const current = points[i];
            const previous = points[j];
            const intersects = (current.y > y) !== (previous.y > y)
                && x < ((previous.x - current.x) * (y - current.y)) / (previous.y - current.y) + current.x;
            if (intersects) inside = !inside;
        }
        return inside;
    }

    // drawing-shape-rotation-projection-v2
    getDrawingShapeBaseRotation(stroke){return this.normalizeRotation(stroke?.shapeBaseRotation??0)}getDrawingShapeRotation(stroke){return this.normalizeRotation(stroke?.shapeRotation??0)}rotateDrawingShapeVector(x,y,rotationDegrees,inverse=false){let rotation=this.normalizeRotation(rotationDegrees);if(inverse)rotation=this.normalizeRotation(-rotation);switch(rotation){case 90:return{x:-y,y:x};case 180:return{x:-x,y:-y};case 270:return{x:y,y:-x};default:return{x,y}}}projectDrawingShapeRatio(stroke,xRatio,yRatio){if(!stroke?.points||stroke.points.length<2)return null;let p0=stroke.points[0],p1=stroke.points[1],rotation=this.getDrawingShapeBaseRotation(stroke),displayDelta=this.rotateDrawingShapeVector(p1.x-p0.x,p1.y-p0.y,rotation),canvasVector=this.rotateDrawingShapeVector(displayDelta.x*xRatio,displayDelta.y*yRatio,rotation,true),point={x:p0.x+canvasVector.x,y:p0.y+canvasVector.y},shapeRotation=this.getDrawingShapeRotation(stroke);if(!shapeRotation)return point;let center={x:(p0.x+p1.x)/2,y:(p0.y+p1.y)/2},rotated=this.rotateDrawingShapeVector(point.x-center.x,point.y-center.y,shapeRotation);return{x:center.x+rotated.x,y:center.y+rotated.y}}getDrawingEllipseGeometry(stroke){if(!stroke?.points||stroke.points.length<2)return null;let p0=stroke.points[0],p1=stroke.points[1],rotation=this.getDrawingShapeRotation(stroke),radiusX=Math.abs(p1.x-p0.x)/2,radiusY=Math.abs(p1.y-p0.y)/2;if(rotation===90||rotation===270){let swap=radiusX;radiusX=radiusY;radiusY=swap};return{centerX:(p0.x+p1.x)/2,centerY:(p0.y+p1.y)/2,radiusX,radiusY}}
















































    getShapePolygon(stroke: any): any[] {
        if (!stroke?.points || stroke.points.length < 2) return [];
        // The signed drag is interpreted in the screen axes captured at
        // pointer-down, preserving drag-direction mirroring on rotated pages.
        const normalized: { [key: string]: number[][] } = {
            rect: [[0, 0], [1, 0], [1, 1], [0, 1]],
            'retaining-wall': [[0, 0], [0.66, 0], [1, 0.5], [1, 1], [0, 1]],
            pier: [
                [0, 0], [1, 0], [1, 0.12], [0.76, 0.24],
                [0.76, 0.76], [1, 0.88], [1, 1], [0, 1],
                [0, 0.88], [0.24, 0.76], [0.24, 0.24], [0, 0.12]
            ],
            'retaining-wall-2': [[0, 1], [1, 0], [1, 1]],
            'shape-1': [[0.5, 0], [1, 0], [1, 1], [0, 1], [0, 0.5], [0.5, 0.5]],
            'shape-2': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'shape-3': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'shape-5-new': [[0, 0], [0.5, 0], [0.5, 0.21], [1, 0.21], [1, 1], [0, 1]],
            'shape-6': [[0.18, 0], [0.82, 0], [1, 1], [0, 1]],
            'shape-7': [[0, 1], [1, 0], [1, 1]],
            'shape-8': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'shape-8-new': [[0, 0], [1, 0], [1, 0.407], [0, 0.407]],
            'shape-9': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'shape-10': [[0, 1], [0.705, 0], [1, 0], [1, 1]],
            'shape-11': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'shape-12': [[0.162, 0], [1, 0], [0.838, 1], [0, 1]],
            'shape-13': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'shape-14': [[0, 0], [1, 0], [1, 0.5], [0.613, 1], [0.387, 1], [0, 0.5]],
            'building-1': [[0.028, 0.02], [0.972, 0.02], [0.972, 0.98], [0.028, 0.98]],
            'building-2': [[0, 1 / 3], [1, 1 / 3], [1, 2 / 3], [0, 2 / 3]],
            'civil-1': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'civil-2': [
                [0, 0], [1, 0], [1, 0.107], [0.620, 0.272],
                [0.620, 1], [0.380, 1], [0.380, 0.272], [0, 0.107]
            ],
            'civil-3': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'civil-4': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'civil-5': [
                [0, 0], [1, 0], [1, 1], [0.896, 1], [0.896, 0.164],
                [0.852, 0.119], [0.148, 0.119], [0.104, 0.164], [0.104, 1], [0, 1]
            ],
            'civil-6': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'civil-7': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'civil-8': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'pier-3': [[0, 0], [1, 0], [1, 1], [0, 1]],
            'pier-2': [
                [0, 0], [1, 0], [1, 0.08455], [5 / 6, 0.1268],
                [5 / 6, 0.8732], [1, 0.91545], [1, 1], [0, 1],
                [0, 0.91545], [1 / 6, 0.8732], [1 / 6, 0.1268], [0, 0.08455]
            ]
        };
        let points = normalized[stroke.type];
        const curveSegments = 32;
        if (stroke.type === 'shape-4') {
            points = [];
            for (let index = 0; index <= curveSegments; index++) {
                const angle = Math.PI - Math.PI * index / curveSegments;
                points.push([0.5 + 0.5 * Math.cos(angle), 1 - Math.sin(angle)]);
            }
        } else if (stroke.type === 'shape-5') {
            points = [];
            for (let index = 0; index <= curveSegments; index++) {
                const angle = -Math.PI / 2 + (Math.PI / 2) * index / curveSegments;
                points.push([Math.cos(angle), 1 + Math.sin(angle)]);
            }
            points.push([0, 1]);
        }
        if (!points) return [];
        return points
            .map(([xRatio, yRatio]: number[]) =>
                this.projectDrawingShapeRatio(stroke, xRatio, yRatio)
            )
            .filter((point: any) => point !== null);
    }

    getShapePolygons(stroke: any): any[][] {
        if (!stroke?.points || stroke.points.length < 2) return [];
        if (stroke.type !== 'shape-8-new') {
            const polygon = this.getShapePolygon(stroke);
            return polygon.length >= 3 ? [polygon] : [];
        }
        const normalizedPolygons = [
            [[0, 0], [1, 0], [1, 0.407], [0, 0.407]],
            [[0, 0.593], [1, 0.593], [1, 1], [0, 1]]
        ];
        return normalizedPolygons.map((polygon: number[][]) =>
            polygon
                .map(([xRatio, yRatio]: number[]) =>
                    this.projectDrawingShapeRatio(stroke, xRatio, yRatio)
                )
                .filter((point: any) => point !== null)
        );
    }

    isLineOnlyDrawingShape(stroke: any): boolean {
        return stroke?.type === 'shape-13' || stroke?.type === 'civil-4';
    }

    getShapeLineSegments(stroke: any): any[][] {
        if (!stroke?.points || stroke.points.length < 2) return [];
        const normalized: { [key: string]: number[][][] } = {
            'shape-2': [
                [[0, 0.0883], [1, 0.0883]],
                [[0, 0.9120], [1, 0.9120]]
            ],
            'shape-3': [
                [[0, 1 / 3], [1, 1 / 3]],
                [[0, 2 / 3], [1, 2 / 3]]
            ],
            'shape-8': [
                [[0.07, 0.15], [0.93, 0.15]],
                [[0.93, 0.15], [0.93, 0.85]],
                [[0.93, 0.85], [0.07, 0.85]],
                [[0.07, 0.85], [0.07, 0.15]]
            ],
            'shape-9': [
                [[0.3, 0.3], [0.7, 0.3]],
                [[0.7, 0.3], [0.7, 0.7]],
                [[0.7, 0.7], [0.3, 0.7]],
                [[0.3, 0.7], [0.3, 0.3]]
            ],
            'shape-11': [
                [[0, 0], [0.25, 0.25]], [[0.30, 0.30], [0.35, 0.35]],
                [[0.39, 0.39], [0.61, 0.61]], [[0.65, 0.65], [0.70, 0.70]],
                [[0.75, 0.75], [1, 1]], [[1, 0], [0.75, 0.25]],
                [[0.70, 0.30], [0.65, 0.35]], [[0.61, 0.39], [0.39, 0.61]],
                [[0.35, 0.65], [0.30, 0.70]], [[0.25, 0.75], [0, 1]]
            ],
            'shape-13': [
                [[0.000, 1], [0.115, 0]], [[0.071, 1], [0.186, 0]],
                [[0.151, 1], [0.265, 0]], [[0.265, 0], [0.345, 1]],
                [[0.229, 0.38], [0.309, 1]], [[0.186, 0.70], [0.229, 1]],
                [[0.345, 1], [0.460, 0]], [[0.416, 1], [0.531, 0]],
                [[0.496, 1], [0.610, 0]], [[0.610, 0], [0.690, 1]],
                [[0.574, 0.38], [0.654, 1]], [[0.531, 0.70], [0.574, 1]],
                [[0.690, 1], [0.805, 0]], [[0.761, 1], [0.876, 0]],
                [[0.841, 1], [0.956, 0]], [[0.956, 0], [1.000, 1]],
                [[0.920, 0.38], [1.000, 1]], [[0.876, 0.70], [0.920, 1]]
            ],
            'building-1': [
                [[0.053, 0.046], [0.947, 0.046]], [[0.947, 0.046], [0.947, 0.954]],
                [[0.947, 0.954], [0.053, 0.954]], [[0.053, 0.954], [0.053, 0.046]],
                [[0.000, 0.033], [0.120, 0.033]], [[0.160, 0.033], [0.200, 0.033]],
                [[0.240, 0.033], [0.440, 0.033]], [[0.480, 0.033], [0.520, 0.033]],
                [[0.560, 0.033], [0.760, 0.033]], [[0.800, 0.033], [0.840, 0.033]],
                [[0.880, 0.033], [1.000, 0.033]], [[0.000, 0.967], [0.120, 0.967]],
                [[0.160, 0.967], [0.200, 0.967]], [[0.240, 0.967], [0.440, 0.967]],
                [[0.480, 0.967], [0.520, 0.967]], [[0.560, 0.967], [0.760, 0.967]],
                [[0.800, 0.967], [0.840, 0.967]], [[0.880, 0.967], [1.000, 0.967]],
                [[0.041, 0.000], [0.041, 0.120]], [[0.041, 0.160], [0.041, 0.200]],
                [[0.041, 0.240], [0.041, 0.440]], [[0.041, 0.480], [0.041, 0.520]],
                [[0.041, 0.560], [0.041, 0.760]], [[0.041, 0.800], [0.041, 0.840]],
                [[0.041, 0.880], [0.041, 1.000]], [[0.959, 0.000], [0.959, 0.120]],
                [[0.959, 0.160], [0.959, 0.200]], [[0.959, 0.240], [0.959, 0.440]],
                [[0.959, 0.480], [0.959, 0.520]], [[0.959, 0.560], [0.959, 0.760]],
                [[0.959, 0.800], [0.959, 0.840]], [[0.959, 0.880], [0.959, 1.000]]
            ],
            'civil-1': [
                [[0, 0.0257], [1, 0.0257]], [[0, 0.0363], [1, 0.0363]],
                [[0, 0.0618], [1, 0.0618]], [[0, 0.4690], [1, 0.4690]],
                [[0, 0.5307], [1, 0.5307]], [[0, 0.9380], [1, 0.9380]],
                [[0, 0.9636], [1, 0.9636]], [[0, 0.9743], [1, 0.9743]]
            ],
            'civil-3': [
                [[0, 0.1034], [1, 0.1034]],
                [[0, 0.2724], [1, 0.2724]]
            ],
            'civil-4': [
                [[0, 0], [1, 0]], [[0, 0], [0, 0.080]],
                [[0, 0.080], [0.154, 0.200]], [[0.154, 0.200], [0.154, 1]],
                [[0.096, 1], [0.309, 1]], [[0.250, 0.200], [0.250, 1]],
                [[0.250, 0.200], [0.330, 0.145]], [[0.330, 0.145], [0.670, 0.145]],
                [[0.670, 0.145], [0.750, 0.200]], [[0.750, 0.200], [0.750, 1]],
                [[0.846, 0.200], [0.846, 1]], [[0.691, 1], [0.904, 1]],
                [[0.846, 0.200], [1, 0.080]], [[1, 0.080], [1, 0]]
            ],
            'civil-7': [
                [[0.3, 0.3], [0.7, 0.3]], [[0.7, 0.3], [0.7, 0.7]],
                [[0.7, 0.7], [0.3, 0.7]], [[0.3, 0.7], [0.3, 0.3]],
                [[0, 0], [0.3, 0.3]], [[1, 0], [0.7, 0.3]],
                [[1, 1], [0.7, 0.7]], [[0, 1], [0.3, 0.7]]
            ],
            'civil-8': [
                [[0.150, 0.075], [0.850, 0.075]], [[0.850, 0.075], [0.925, 0.150]],
                [[0.925, 0.150], [0.925, 0.850]], [[0.925, 0.850], [0.850, 0.925]],
                [[0.850, 0.925], [0.150, 0.925]], [[0.150, 0.925], [0.075, 0.850]],
                [[0.075, 0.850], [0.075, 0.150]], [[0.075, 0.150], [0.150, 0.075]]
            ],
            'building-2': [
                [[0.027, 1 / 3], [0.027, 2 / 3]],
                [[0.973, 1 / 3], [0.973, 2 / 3]],
                [[0.027, 0.45], [0.519, 0.45]],
                [[0.481, 0.55], [0.973, 0.55]],
                [[0.5, 0], [0.5, 1]]
            ],
            'pier-3': [
                [[0, 0.0883], [1, 0.0883]],
                [[0, 0.9120], [1, 0.9120]]
            ],
            'pier-2': [
                [[0, 0.08455], [1, 0.08455]],
                [[0, 0.91545], [1, 0.91545]]
            ]
        };
        let lines = normalized[stroke.type] || [];
    // civil-6-dynamic-grid-v2
    // civil-6-dynamic-grid-v3
        if (stroke.type === 'civil-6') {
            lines = [];
            const rotation = this.getDrawingShapeBaseRotation(stroke);
            const p0 = stroke.points[0], p1 = stroke.points[1];
            const delta = this.rotateDrawingShapeVector(p1.x - p0.x, p1.y - p0.y, rotation);
            const width = Math.max(1, Math.abs(delta.x)), height = Math.max(1, Math.abs(delta.y)); const positions = (length) => { const count = Math.max(1, Math.floor((length - 0.001) / 25)); if (length <= 25) return [0.5]; return Array.from({ length: count }, (_, index) => Math.min((index + 1) * 25 / length, 0.999)); };
            const dashes = (length) => Array.from({ length: Math.max(1, Math.ceil(length / 8)) }, (_, index) => [Math.min(index * 8 / length, 1), Math.min((index * 8 + 5) / length, 1)]).filter(([start]) => start < 1);
            for (const y of positions(height)) for (const [start, end] of dashes(width)) lines.push([[start, y], [end, y]]);
            for (const x of positions(width)) for (const [start, end] of dashes(height)) lines.push([[x, start], [x, end]]);
        }
                return lines.map(([start, end]: number[][]) => [
            this.projectDrawingShapeRatio(stroke, start[0], start[1]),
            this.projectDrawingShapeRatio(stroke, end[0], end[1])
        ]);
    }

    // drawing-shape-hit-test-v2
    isPointInDrawingShape(x,y,stroke){if(stroke?.type==="ellipse"&&stroke.points?.length>=2){let geometry=this.getDrawingEllipseGeometry(stroke);if(!geometry||geometry.radiusX<=0||geometry.radiusY<=0)return false;return((x-geometry.centerX)/geometry.radiusX)**2+((y-geometry.centerY)/geometry.radiusY)**2<=1}return this.getShapePolygons(stroke).some(polygon=>polygon.length>=3&&this.isPointInPolygon(x,y,polygon))}














    isPointInFillableDrawing(x: number, y: number, stroke: any): boolean {
        if (stroke?.type === 'freehand') {
            return this.isClosedFreehandStroke(stroke, false)
                && this.isPointInPolygon(x, y, stroke.points);
        }
        if (this.isLineOnlyDrawingShape(stroke)) return false;
        return this.isPointInDrawingShape(x, y, stroke);
    }

    findFillableShapeAt(x: number, y: number): any | null {
        for (let i = this.drawings.length - 1; i >= 0; i--) {
            const stroke = this.drawings[i];
            if (stroke?.page !== this.currentPage) continue;
            if (this.isPointInFillableDrawing(x, y, stroke)) return stroke;
        }
        return null;
    }

    isMovableDrawingShape(stroke: any): boolean {
        return !!stroke
            && Array.isArray(stroke.points)
            && stroke.points.length >= 2
            && this.DRAWING_SHAPE_TYPES.includes(stroke.type);
    }

    findMovableDrawingShapeAt(x: number, y: number): any | null {
        for (let i = this.drawings.length - 1; i >= 0; i--) {
            const stroke = this.drawings[i];
            if (stroke?.page !== this.currentPage) continue;
            if (!this.isMovableDrawingShape(stroke)) continue;
            if (this.isPointInDrawingShape(x, y, stroke)) return stroke;
        }
        return null;
    }

    cloneDrawingPoints(points: any[]): any[] {
        return Array.isArray(points) ? points.map((point: any) => ({ ...point })) : [];
    }

    // drawing-shape-gesture-helpers-v2
    clearDrawingShapeLongPress(){this.drawingShapeLongPressTimer&&(clearTimeout(this.drawingShapeLongPressTimer),this.drawingShapeLongPressTimer=null)}resetDrawingShapeTap(){this.lastDrawingShapeTapAt=0;this.lastDrawingShapeTapTarget=null;this.lastDrawingShapeTapPos=null}applyDrawingShapeRotation(stroke,value){let rotation=this.normalizeRotation(value);rotation===0?delete stroke.shapeRotation:stroke.shapeRotation=rotation}rotateDrawingShapeClockwise(stroke){if(!this.isMovableDrawingShape(stroke)||this.drawings.indexOf(stroke)<0)return false;let before=this.normalizeRotation(stroke.shapeRotation??0),after=this.normalizeRotation(before+90);this.applyDrawingShapeRotation(stroke,after);this.pushUndo({type:"rotate-drawing",data:stroke,drawingId:stroke.id,before,after});this.renderDrawings();this.ref.detectChanges();return true}deleteDrawingShapeObject(stroke){let index=this.drawings.indexOf(stroke);if(index<0||!this.isMovableDrawingShape(stroke))return false;this.pushUndo({type:"delete-drawing",data:stroke,drawingId:stroke.id,index});this.drawings.splice(index,1);this.renderDrawings();this.ref.detectChanges();return true}handleDrawingShapeTap(stroke,x,y){let now=Date.now(),previous=this.lastDrawingShapeTapTarget,same=previous&&(previous===stroke||previous.id&&stroke?.id&&previous.id===stroke.id),point=this.lastDrawingShapeTapPos,tolerance=24/Math.max(Number(this.zoomLevel)||1,.3),isDouble=same&&point&&now-this.lastDrawingShapeTapAt<=450&&Math.hypot(x-point.x,y-point.y)<=tolerance;if(isDouble){this.resetDrawingShapeTap();return this.drawTool==="eraser"?this.deleteDrawingShapeObject(stroke):this.rotateDrawingShapeClockwise(stroke)}this.lastDrawingShapeTapAt=now;this.lastDrawingShapeTapTarget=stroke;this.lastDrawingShapeTapPos={x,y};return false}





    // drawing-shape-begin-move-v2
    beginDrawingShapeMove(e,t){if(this.currentMode!=="draw"||e?.page!==this.currentPage||this.drawings.indexOf(e)<0||!this.isMovableDrawingShape(e))return false;this.isDrawing&&this.cancelCurrentDrawing();this.isMovingDrawingShape=true;this.movingDrawingShape=e;this.drawingShapeGestureTarget=e;this.drawingShapeMoveStartPoint={x:t.x,y:t.y};this.drawingShapeMoveOriginalPoints=this.cloneDrawingPoints(e.points);this.wasTap=false;this.isPanning=false;this.resetDrawingShapeTap();this.hideEraserCursor();this.renderDrawings();this.ref.detectChanges();return true}


















    updateDrawingShapeMove(x: number, y: number) {
        const stroke = this.movingDrawingShape;
        const start = this.drawingShapeMoveStartPoint;
        const original = this.drawingShapeMoveOriginalPoints;
        if (!this.isMovingDrawingShape || !stroke || !start || original.length === 0) return;

        let dx = x - start.x;
        let dy = y - start.y;
        const xs = original.map((point: any) => Number(point.x)).filter(Number.isFinite);
        const ys = original.map((point: any) => Number(point.y)).filter(Number.isFinite);
        const canvasWidth = Number(this.drawCanvas?.width);
        const canvasHeight = Number(this.drawCanvas?.height);

        if (xs.length && Number.isFinite(canvasWidth) && canvasWidth > 0) {
            const minDx = -Math.min(...xs);
            const maxDx = canvasWidth - Math.max(...xs);
            if (minDx <= maxDx) dx = Math.max(minDx, Math.min(maxDx, dx));
        }
        if (ys.length && Number.isFinite(canvasHeight) && canvasHeight > 0) {
            const minDy = -Math.min(...ys);
            const maxDy = canvasHeight - Math.max(...ys);
            if (minDy <= maxDy) dy = Math.max(minDy, Math.min(maxDy, dy));
        }

        stroke.points = original.map((point: any) => ({
            ...point,
            x: Number(point.x) + dx,
            y: Number(point.y) + dy
        }));
        this.renderDrawings();
        this.ref.detectChanges();
    }

    finishDrawingShapeMove(): boolean {
        if (!this.isMovingDrawingShape || !this.movingDrawingShape) return false;

        const stroke = this.movingDrawingShape;
        const before = this.cloneDrawingPoints(this.drawingShapeMoveOriginalPoints);
        const after = this.cloneDrawingPoints(stroke.points);
        const moved = before.length === after.length && before.some((point: any, index: number) =>
            point.x !== after[index]?.x || point.y !== after[index]?.y
        );

        if (moved) {
            this.pushUndo({
                type: 'move-drawing',
                data: stroke,
                drawingId: stroke.id,
                before,
                after
            });
        }

        this.isMovingDrawingShape = false;
        this.movingDrawingShape = null;
        this.drawingShapeMoveStartPoint = null;
        this.drawingShapeMoveOriginalPoints = [];
        this.renderDrawings();
        this.ref.detectChanges();
        return moved;
    }

    // drawing-shape-cancel-move-v2
    cancelDrawingShapeMove(e=true){this.clearDrawingShapeLongPress();let wasMoving=this.isMovingDrawingShape;e&&wasMoving&&this.movingDrawingShape&&this.drawingShapeMoveOriginalPoints.length>0&&(this.movingDrawingShape.points=this.cloneDrawingPoints(this.drawingShapeMoveOriginalPoints));this.isMovingDrawingShape=false;this.movingDrawingShape=null;this.drawingShapeGestureTarget=null;this.drawingShapeMoveStartPoint=null;this.drawingShapeMoveOriginalPoints=[];wasMoving&&(this.renderDrawings(),this.ref.detectChanges())}



















    resolveDrawingFillPattern(stroke: any): string {
        const requested = String(stroke?.fillPattern || '').trim();
        if (this.FILL_PATTERNS.some((item: any) => item.value === requested)) {
            return requested;
        }
        return String(stroke?.fillColor || '').trim() ? 'grid' : '';
    }

    resolveDrawingFillColor(stroke: any): string {
        return String(stroke?.fillColor || stroke?.color || '#ef4444').trim() || '#ef4444';
    }

    applyDrawingFillState(stroke: any, state: any) {
        for (const key of ['closed', 'fillPattern', 'fillColor']) {
            if (state[key] === undefined) delete stroke[key];
            else stroke[key] = state[key];
        }
    }

    applyFillAt(x: number, y: number): boolean {
        const stroke = this.findFillableShapeAt(x, y);
        if (!stroke) return false;

        const before = {
            closed: stroke.closed,
            fillPattern: stroke.fillPattern,
            fillColor: stroke.fillColor
        };
        const after = {
            closed: stroke.type === 'freehand' ? true : stroke.closed,
            fillPattern: this.fillPattern,
            fillColor: this.drawColor
        };
        if (
            before.closed === after.closed
            && before.fillPattern === after.fillPattern
            && before.fillColor === after.fillColor
        ) return true;

        this.applyDrawingFillState(stroke, after);
        this.pushUndo({ type: 'fill-drawing', data: stroke, drawingId: stroke.id, before, after });
        this.renderDrawings();
        this.ref.detectChanges();
        return true;
    }

    findDrawingActionIndex(action: any): number {
        const directIndex = this.drawings.indexOf(action?.data);
        if (directIndex >= 0) return directIndex;
        const drawingId = action?.drawingId || action?.data?.id;
        return drawingId
            ? this.drawings.findIndex((drawing: any) => drawing?.id === drawingId)
            : -1;
    }

    resolveFillDrawingActionTarget(action: any): any | null {
        const index = this.findDrawingActionIndex(action);
        return index >= 0 ? this.drawings[index] : null;
    }

    // ================================================================
    //  DRAWING: ERASE
    // ================================================================

    eraseStrokeAt(x: number, y: number) {
        const pageDrawings = this.drawings.filter((d: any) => d.page === this.currentPage);
        const threshold = 15;

        for (let i = pageDrawings.length - 1; i >= 0; i--) {
            const stroke = pageDrawings[i];
            if (this.isPointNearStroke(x, y, stroke, threshold)) {
                const idx = this.drawings.indexOf(stroke);
                if (idx > -1) {
                    this.pushUndo({ type: 'delete-drawing', data: stroke, index: idx });
                    this.drawings.splice(idx, 1);
                }
                this.renderDrawings();
                this.ref.detectChanges();
                return;
            }
        }

        // Check marker arrows for erasing
        const pageMarkers = this.damages.filter((d: any) => d.page === this.currentPage);
        for (const m of pageMarkers) {
            if (!m.arrows || !m.points[0]) continue;
            for (let ai = m.arrows.length - 1; ai >= 0; ai--) {
                const arrow = m.arrows[ai];
                const dist = this.distPointToLine(x, y, m.points[0].x, m.points[0].y, arrow.toX, arrow.toY);
                if (dist < threshold) {
                    this.pushUndo({ type: 'delete-arrow', data: m, arrow: arrow, arrowIndex: ai });
                    m.arrows.splice(ai, 1);
                    this.renderMarkers();
                    this.ref.detectChanges();
                    return;
                }
            }
        }
    }

    isPointNearStroke(x: number, y: number, stroke: any, threshold: number): boolean {
        if (!stroke.points || stroke.points.length === 0) return false;

        if (stroke.type === 'freehand') {
            for (const p of stroke.points) {
                if (Math.sqrt((x - p.x) ** 2 + (y - p.y) ** 2) < threshold) return true;
            }
            return false;
        }

        const p0 = stroke.points[0];
        const p1 = stroke.points[stroke.points.length - 1];
        if (stroke.type === 'line' || stroke.type === 'arrow') {
            return this.distPointToLine(x, y, p0.x, p0.y, p1.x, p1.y) < threshold;
        }

        const lineOnly = this.isLineOnlyDrawingShape(stroke);
        const polygons = this.getShapePolygons(stroke);
        if (!lineOnly) {
            for (const polygon of polygons) {
                if (this.isPointInPolygon(x, y, polygon)) return true;
                for (let i = 0; i < polygon.length; i++) {
                    const start = polygon[i];
                    const end = polygon[(i + 1) % polygon.length];
                    if (this.distPointToLine(x, y, start.x, start.y, end.x, end.y) < threshold) {
                        return true;
                    }
                }
            }
        }
        for (const [start, end] of this.getShapeLineSegments(stroke)) {
            if (this.distPointToLine(x, y, start.x, start.y, end.x, end.y) < threshold) {
                return true;
            }
        }
        if (polygons.length > 0 || lineOnly) return false;

        if (stroke.type === 'ellipse') {
            const cx = (p0.x + p1.x) / 2;
            const cy = (p0.y + p1.y) / 2;
            const rx = Math.abs(p1.x - p0.x) / 2;
            const ry = Math.abs(p1.y - p0.y) / 2;
            if (rx === 0 || ry === 0) return false;
            const ellipseVal = ((x - cx) / rx) ** 2 + ((y - cy) / ry) ** 2;
            return ellipseVal <= 1 + (threshold / Math.min(rx, ry));
        }

        return false;
    }

    distPointToLine(px: number, py: number, x1: number, y1: number, x2: number, y2: number): number {
        const A = px - x1;
        const B = py - y1;
        const C = x2 - x1;
        const D = y2 - y1;
        const dot = A * C + B * D;
        const lenSq = C * C + D * D;
        let t = lenSq !== 0 ? dot / lenSq : -1;
        t = Math.max(0, Math.min(1, t));
        const nearX = x1 + t * C;
        const nearY = y1 + t * D;
        return Math.sqrt((px - nearX) ** 2 + (py - nearY) ** 2);
    }

    async clearAllDrawings() {
        const confirmed = await this.service.alert.show({
            title: '전체 지우기',
            message: '현재 페이지의 모든 드로잉을 삭제하시겠습니까?',
            status: 'warning',
            action: '삭제',
            actionBtn: 'btn-red',
            cancel: '취소'
        });
        if (!confirmed) return;
        const removed = this.drawings.filter((d: any) => d.page === this.currentPage);
        if (removed.length > 0) this.pushUndo({ type: 'clear-drawings', data: removed, page: this.currentPage });
        this.drawings = this.drawings.filter((d: any) => d.page !== this.currentPage);
        this.renderDrawings();
        this.ref.detectChanges();
    }

    async clearAllDamages() {
        const pageDamages = this.pageDamages;
        if (pageDamages.length === 0) return;

        const confirmed = await this.service.alert.show({
            title: '손상 전체 삭제',
            message: '현재 페이지의 손상표시를 모두 삭제하시겠습니까?',
            status: 'warning',
            action: '삭제',
            actionBtn: 'btn-red',
            cancel: '취소'
        });
        if (!confirmed) return;

        const removed = pageDamages.map((damage: any) => ({
            damage,
            index: this.damages.indexOf(damage)
        }));

        this.pushUndo({ type: 'clear-damages', data: removed, page: this.currentPage });
        this.damages = this.damages.filter((damage: any) => damage.page !== this.currentPage);
        this.normalizeDamageNumbers();

        if (this.selectedDamage && this.selectedDamage.page === this.currentPage) {
            this.selectedDamage = null;
            this.showPanel = false;
            this.formData = this.newFormData();
        }

        this.renderMarkers();
        this.ref.detectChanges();
    }

    // ================================================================
    //  UNDO / REDO
    // ================================================================

    pushUndo(action: any) {
        this.undoStack.push(action);
        this.redoStack = [];
        this.scheduleLocalDraftSave(action?.type || 'edit');
    }

    get canUndo() { return this.undoStack.length > 0; }
    get canRedo() { return this.redoStack.length > 0; }

    async undo() {
        if (!this.canUndo) return;
        const action = this.undoStack.pop();
        let shouldNormalizeDamageNumbers = false;
        switch (action.type) {
            case 'add-damage': {
                const idx = this.damages.indexOf(action.data);
                if (idx > -1) this.damages.splice(idx, 1);
                if (this.selectedDamage === action.data) { this.selectedDamage = null; this.showPanel = false; }
                shouldNormalizeDamageNumbers = true;
                this.normalizeDamageNumbers();
                this.renderMarkers();
                break;
            }
            case 'duplicate-damage': {
                const idx = this.damages.indexOf(action.data);
                if (idx > -1) this.damages.splice(idx, 1);
                for (const item of action.renumbered || []) item.damage.number = item.before;
                if (this.selectedDamage === action.data) {
                    this.selectedDamage = null;
                    if (this.panelMode === 'form') this.showPanel = false;
                    this.formData = this.newFormData();
                }
                this.damageCounter = this.damages.length;
                this.renderMarkers();
                break;
            }
            case 'delete-damage': {
                this.damages.splice(action.index, 0, action.data);
                shouldNormalizeDamageNumbers = true;
                this.normalizeDamageNumbers();
                this.renderMarkers();
                break;
            }
            case 'clear-damages': {
                const removed = [...action.data].sort((a: any, b: any) => a.index - b.index);
                for (const item of removed) {
                    const index = Math.min(Math.max(item.index, 0), this.damages.length);
                    this.damages.splice(index, 0, item.damage);
                }
                shouldNormalizeDamageNumbers = true;
                this.normalizeDamageNumbers();
                this.renderMarkers();
                break;
            }
            case 'delete-damages': {
                const removed = [...action.data].sort((a: any, b: any) => a.index - b.index);
                for (const item of removed) {
                    const index = Math.min(Math.max(item.index, 0), this.damages.length);
                    this.damages.splice(index, 0, item.damage);
                }
                shouldNormalizeDamageNumbers = true;
                this.normalizeDamageNumbers();
                this.renderMarkers();
                break;
            }
            case 'add-drawing': {
                const idx = this.findDrawingActionIndex(action);
                if (idx > -1) {
                    action.data = this.drawings[idx];
                    action.drawingId = action.data?.id || action.drawingId;
                    this.drawings.splice(idx, 1);
                }
                this.renderDrawings();
                break;
            }
            case 'delete-drawing': {
                const existingIndex = this.findDrawingActionIndex(action);
                if (existingIndex < 0) {
                    const index = Math.min(Math.max(action.index ?? this.drawings.length, 0), this.drawings.length);
                    this.drawings.splice(index, 0, action.data);
                } else {
                    action.data = this.drawings[existingIndex];
                }
                this.renderDrawings();
                break;
            }
            case 'clear-drawings': {
                const restored: any[] = [];
                for (const drawing of action.data) {
                    const existingIndex = this.findDrawingActionIndex({ data: drawing, drawingId: drawing?.id });
                    if (existingIndex >= 0) {
                        restored.push(this.drawings[existingIndex]);
                    } else {
                        this.drawings.push(drawing);
                        restored.push(drawing);
                    }
                }
                action.data = restored;
                this.renderDrawings();
                break;
            }
            case 'fill-drawing': {
                const target = this.resolveFillDrawingActionTarget(action);
                if (target) this.applyDrawingFillState(target, action.before);
                this.renderDrawings();
                break;
            }
            case 'move-drawing': {
                const target = this.resolveFillDrawingActionTarget(action);
                if (target) target.points = this.cloneDrawingPoints(action.before);
                this.renderDrawings();
                break;
            }
            case 'rotate-drawing': { const target = this.resolveFillDrawingActionTarget(action); if (target) this.applyDrawingShapeRotation(target, action.before); this.renderDrawings(); break; }
            case 'add-arrow': {
                if (action.data.arrows) {
                    const idx = action.data.arrows.indexOf(action.arrow);
                    if (idx > -1) action.data.arrows.splice(idx, 1);
                }
                this.renderMarkers();
                break;
            }
            case 'delete-arrow': {
                if (!action.data.arrows) action.data.arrows = [];
                action.data.arrows.splice(action.arrowIndex, 0, action.arrow);
                this.renderMarkers();
                break;
            }
        }
        if (shouldNormalizeDamageNumbers === false && action.type === 'add-arrow') {
            this.damageCounter = this.damages.length;
        }
        this.redoStack.push(action);
        this.scheduleLocalDraftSave('undo');
        this.ref.detectChanges();
    }

    async redo() {
        if (!this.canRedo) return;
        const action = this.redoStack.pop();
        let shouldNormalizeDamageNumbers = false;
        switch (action.type) {
            case 'add-damage': {
                this.damages.push(action.data);
                shouldNormalizeDamageNumbers = true;
                this.normalizeDamageNumbers();
                this.renderMarkers();
                break;
            }
            case 'duplicate-damage': {
                for (const item of action.renumbered || []) item.damage.number = item.after;
                const existingIndex = this.damages.indexOf(action.data);
                if (existingIndex < 0) {
                    const index = Math.min(Math.max(action.index ?? this.damages.length, 0), this.damages.length);
                    this.damages.splice(index, 0, action.data);
                }
                this.damageCounter = this.damages.length;
                this.renderMarkers();
                break;
            }
            case 'delete-damage': {
                const idx = this.damages.indexOf(action.data);
                if (idx > -1) this.damages.splice(idx, 1);
                if (this.selectedDamage === action.data) {
                    this.selectedDamage = null;
                    if (this.panelMode === 'form') this.showPanel = false;
                    this.formData = this.newFormData();
                }
                shouldNormalizeDamageNumbers = true;
                this.normalizeDamageNumbers();
                this.renderMarkers();
                break;
            }
            case 'clear-damages': {
                const removedIds = new Set(action.data.map((item: any) => item.damage.id));
                this.damages = this.damages.filter((damage: any) => !removedIds.has(damage.id));
                if (this.selectedDamage && removedIds.has(this.selectedDamage.id)) {
                    this.selectedDamage = null;
                    this.showPanel = false;
                    this.formData = this.newFormData();
                }
                shouldNormalizeDamageNumbers = true;
                this.normalizeDamageNumbers();
                this.renderMarkers();
                break;
            }
            case 'delete-damages': {
                const removedIds = new Set(action.data.map((item: any) => item.damage.id));
                this.damages = this.damages.filter((damage: any) => !removedIds.has(damage.id));
                if (this.selectedDamage && removedIds.has(this.selectedDamage.id)) {
                    this.selectedDamage = null;
                    this.showPanel = false;
                    this.formData = this.newFormData();
                }
                this.checkedDamageIds = this.checkedDamageIds.filter((id: string) => !removedIds.has(id));
                shouldNormalizeDamageNumbers = true;
                this.normalizeDamageNumbers();
                this.renderMarkers();
                break;
            }
            case 'add-drawing': {
                const existingIndex = this.findDrawingActionIndex(action);
                if (existingIndex < 0) {
                    const index = Math.min(Math.max(action.index ?? this.drawings.length, 0), this.drawings.length);
                    this.drawings.splice(index, 0, action.data);
                } else {
                    action.data = this.drawings[existingIndex];
                }
                this.renderDrawings();
                break;
            }
            case 'delete-drawing': {
                const idx = this.findDrawingActionIndex(action);
                if (idx > -1) {
                    action.data = this.drawings[idx];
                    action.drawingId = action.data?.id || action.drawingId;
                    this.drawings.splice(idx, 1);
                }
                this.renderDrawings();
                break;
            }
            case 'clear-drawings': {
                action.data = this.drawings.filter((d: any) => d.page === action.page);
                this.drawings = this.drawings.filter((d: any) => d.page !== action.page);
                this.renderDrawings();
                break;
            }
            case 'fill-drawing': {
                const target = this.resolveFillDrawingActionTarget(action);
                if (target) this.applyDrawingFillState(target, action.after);
                this.renderDrawings();
                break;
            }
            case 'move-drawing': {
                const target = this.resolveFillDrawingActionTarget(action);
                if (target) target.points = this.cloneDrawingPoints(action.after);
                this.renderDrawings();
                break;
            }
            case 'rotate-drawing': { const target = this.resolveFillDrawingActionTarget(action); if (target) this.applyDrawingShapeRotation(target, action.after); this.renderDrawings(); break; }
            case 'add-arrow': {
                if (!action.data.arrows) action.data.arrows = [];
                action.data.arrows.push(action.arrow);
                this.renderMarkers();
                break;
            }
            case 'delete-arrow': {
                if (action.data.arrows) {
                    const idx = action.data.arrows.indexOf(action.arrow);
                    if (idx > -1) action.data.arrows.splice(idx, 1);
                }
                this.renderMarkers();
                break;
            }
        }
        if (shouldNormalizeDamageNumbers === false && action.type === 'add-arrow') {
            this.damageCounter = this.damages.length;
        }
        this.undoStack.push(action);
        this.scheduleLocalDraftSave('redo');
        this.ref.detectChanges();
    }

    // ================================================================
    //  DRAWING: RENDER
    // ================================================================

    renderDrawings() {
        if (!this.drawCtx || !this.drawCanvas) return;
        this.drawCtx.clearRect(0, 0, this.drawCanvas.width, this.drawCanvas.height);

        const pageDrawings = this.drawings.filter((d: any) => d.page === this.currentPage);
        for (const stroke of pageDrawings) {
            this.drawStroke(this.drawCtx, stroke);
        }
    }

    renderDrawingPreview() {
        if (!this.drawCtx || !this.drawCanvas) return;
        // Re-render all existing drawings, then overlay the in-progress stroke
        this.drawCtx.clearRect(0, 0, this.drawCanvas.width, this.drawCanvas.height);

        const pageDrawings = this.drawings.filter((d: any) => d.page === this.currentPage);
        for (const stroke of pageDrawings) {
            this.drawStroke(this.drawCtx, stroke);
        }

        if (this.currentStroke) {
            this.drawStroke(this.drawCtx, this.currentStroke);
        }
    }

    resolveLineDash(stroke: any): number[] {
        const lineStyle = this.LINE_STYLES.find(
            (item: any) => item.value === (stroke?.lineStyle || 'solid')
        );
        const unit = Math.max(1, Number(stroke?.width) || this.drawWidth || 3);
        return (lineStyle?.dash || []).map((length: number) => length * unit);
    }

    drawStroke(ctx: CanvasRenderingContext2D, stroke: any) {
        if (!stroke.points || stroke.points.length === 0) return;
        ctx.save();
        const isEraser = stroke.type === 'eraser';
        ctx.strokeStyle = isEraser ? 'rgba(0, 0, 0, 1)' : (stroke.color || '#ef4444');
        ctx.lineWidth = stroke.width || 3;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.globalAlpha = 1;

        if (isEraser) {
            ctx.globalCompositeOperation = 'destination-out';
        }

        const pts = stroke.points;

        switch (stroke.type) {
            case 'freehand':
                if (pts.length < 2) break;
                this.tracePolygonPath(ctx, pts, stroke.closed === true);
                if (stroke.closed === true) {
                    this.drawShapeHatch(ctx, stroke, pts, 'evenodd');
                    this.tracePolygonPath(ctx, pts, true);
                }
                ctx.strokeStyle = stroke.color || '#ef4444';
                ctx.lineWidth = stroke.width || 3;
                ctx.globalAlpha = 1;
                ctx.stroke();
                break;

            case 'eraser':
                if (pts.length < 2) break;
                ctx.beginPath();
                ctx.moveTo(pts[0].x, pts[0].y);
                for (let i = 1; i < pts.length; i++) {
                    ctx.lineTo(pts[i].x, pts[i].y);
                }
                ctx.stroke();
                break;

            case 'line':
                if (pts.length < 2) break;
                ctx.setLineDash(this.resolveLineDash(stroke));
                ctx.beginPath();
                ctx.moveTo(pts[0].x, pts[0].y);
                ctx.lineTo(pts[1].x, pts[1].y);
                ctx.stroke();
                break;

            case 'rect':
            case 'retaining-wall':
            case 'pier':
            case 'retaining-wall-2':
            case 'shape-1':
            case 'shape-2':
            case 'shape-3':
            case 'shape-4':
            case 'shape-5':
            case 'shape-6':
            case 'shape-7':
            case 'shape-8':
            case 'shape-5-new':
            case 'shape-8-new':
            case 'shape-9':
            case 'shape-10':
            case 'shape-11':
            case 'shape-12':
            case 'shape-13':
            case 'shape-14':
            case 'building-1':
            case 'building-2':
            case 'civil-1':
            case 'civil-2':
            case 'civil-3':
            case 'civil-4':
            case 'civil-5':
            case 'civil-6':
            case 'civil-7':
            case 'civil-8':
            case 'pier-3':
            case 'pier-2':
                this.drawPolygonShape(ctx, stroke);
                break;

            case 'ellipse':
                this.drawEllipseShape(ctx, stroke);
                break;

            case 'arrow':
                if (pts.length < 2) break;
                this.drawArrow(ctx, pts[1].x, pts[1].y, pts[0].x, pts[0].y, stroke.width);
                break;
        }

        ctx.restore();
    }

    drawArrow(ctx: CanvasRenderingContext2D, fromX: number, fromY: number, toX: number, toY: number, lineWidth: number) {
        const headLen = Math.max(lineWidth * 4, 16);
        const angle = Math.atan2(toY - fromY, toX - fromX);

        ctx.beginPath();
        ctx.moveTo(fromX, fromY);
        ctx.lineTo(toX, toY);
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(toX, toY);
        ctx.lineTo(toX - headLen * Math.cos(angle - Math.PI / 6), toY - headLen * Math.sin(angle - Math.PI / 6));
        ctx.moveTo(toX, toY);
        ctx.lineTo(toX - headLen * Math.cos(angle + Math.PI / 6), toY - headLen * Math.sin(angle + Math.PI / 6));
        ctx.stroke();
    }

    tracePolygonPath(ctx: CanvasRenderingContext2D, points: any[], closePath: boolean = true) {
        if (!points.length) return;
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        for (let index = 1; index < points.length; index++) {
            ctx.lineTo(points[index].x, points[index].y);
        }
        if (closePath) ctx.closePath();
    }

    traceEllipsePath(ctx: CanvasRenderingContext2D, start: any, end: any) {
        const centerX = (start.x + end.x) / 2;
        const centerY = (start.y + end.y) / 2;
        const radiusX = Math.abs(end.x - start.x) / 2;
        const radiusY = Math.abs(end.y - start.y) / 2;
        ctx.beginPath();
        ctx.ellipse(centerX, centerY, Math.max(radiusX, 1), Math.max(radiusY, 1), 0, 0, Math.PI * 2);
    }

    resolveHatchBounds(
        ctx: CanvasRenderingContext2D,
        points: any[],
        spacing: number
    ): { minX: number; minY: number; maxX: number; maxY: number; spacing: number } | null {
        const xs = points.map((point: any) => Number(point?.x)).filter(Number.isFinite);
        const ys = points.map((point: any) => Number(point?.y)).filter(Number.isFinite);
        if (!xs.length || !ys.length) return null;

        let minX = Math.min(...xs);
        let minY = Math.min(...ys);
        let maxX = Math.max(...xs);
        let maxY = Math.max(...ys);
        const canvasWidth = Number(ctx.canvas?.width);
        const canvasHeight = Number(ctx.canvas?.height);
        if (Number.isFinite(canvasWidth) && canvasWidth > 0) {
            minX = Math.max(0, minX);
            maxX = Math.min(canvasWidth, maxX);
        }
        if (Number.isFinite(canvasHeight) && canvasHeight > 0) {
            minY = Math.max(0, minY);
            maxY = Math.min(canvasHeight, maxY);
        }
        if (maxX <= minX || maxY <= minY) return null;
        return { minX, minY, maxX, maxY, spacing };
    }

    // moving-shape-hatch-preview-v2
    drawShapeHatch(e,t,i,r="nonzero"){let s=this.resolveDrawingFillPattern(t);if(!s)return;let o=t.width||3,a=this.getHatchSpacing(o),l=this.resolveHatchBounds(e,i,a),c=this.isMovingDrawingShape&&t===this.movingDrawingShape,u=c?"#9ca3af":this.resolveDrawingFillColor(t);l&&(e.save(),e.clip(r),e.strokeStyle=u,e.fillStyle=u,e.lineWidth=this.getHatchLineWidth(o),e.lineCap="butt",e.lineJoin="miter",e.globalAlpha=c ? .2:.44,this.drawFillPattern(e,s,l.minX,l.minY,l.maxX,l.maxY,l.spacing),e.restore())}
































    drawFillPattern(
        ctx: CanvasRenderingContext2D,
        pattern: string,
        minX: number,
        minY: number,
        maxX: number,
        maxY: number,
        spacing: number
    ) {
        if (pattern === 'grid') {
            this.drawGridPattern(ctx, minX, minY, maxX, maxY, spacing);
            return;
        }
        if (pattern === 'dots' || pattern === 'dots-2') {
            const isHollow = pattern === 'dots-2';
            const dotSpacing = isHollow ? spacing * 2 : spacing;
            const radius = isHollow
                ? Math.max(2, ctx.lineWidth * 2.1)
                : Math.max(1.2, ctx.lineWidth * 1.25);
            for (let x = minX + dotSpacing / 2; x < maxX; x += dotSpacing) {
                for (let y = minY + dotSpacing / 2; y < maxY; y += dotSpacing) {
                    ctx.beginPath();
                    ctx.arc(x, y, radius, 0, Math.PI * 2);
                    if (isHollow) ctx.stroke();
                    else ctx.fill();
                }
            }
            return;
        }
        if (pattern === 'cross') {
            const crossSpacing = spacing * 2;
            const arm = Math.max(2, spacing * 0.36);
            ctx.beginPath();
            for (let x = minX + crossSpacing / 2; x < maxX; x += crossSpacing) {
                for (let y = minY + crossSpacing / 2; y < maxY; y += crossSpacing) {
                    ctx.moveTo(x - arm, y);
                    ctx.lineTo(x + arm, y);
                    ctx.moveTo(x, y - arm);
                    ctx.lineTo(x, y + arm);
                }
            }
            ctx.stroke();
            return;
        }
        if (pattern === 'triangle') {
            const cellWidth = spacing * 4;
            const cellHeight = spacing * 4;
            const triangleWidth = spacing * 3;
            const triangleHeight = spacing * 2.7;
            const insetX = (cellWidth - triangleWidth) / 2;
            ctx.beginPath();
            for (let topY = minY; topY < maxY + cellHeight; topY += cellHeight) {
                for (let cellX = minX; cellX < maxX + cellWidth; cellX += cellWidth) {
                    const leftX = cellX + insetX;
                    const rightX = leftX + triangleWidth;
                    const centerX = leftX + triangleWidth / 2;
                    const bottomY = topY + triangleHeight;
                    ctx.moveTo(leftX, topY);
                    ctx.lineTo(rightX, topY);
                    ctx.lineTo(centerX, bottomY);
                    ctx.lineTo(leftX, topY);
                }
            }
            ctx.stroke();
            return;
        }
        if (pattern === 'exposed-rebar') {
            const cellWidth = spacing * 4;
            const cellHeight = spacing * 3;
            const railGap = Math.max(1, spacing * 0.42);
            const crossHalfWidth = Math.max(2, spacing * 0.7);
            const crossHalfHeight = Math.max(2, spacing * 0.9);
            ctx.beginPath();
            for (
                let centerY = minY + cellHeight / 2;
                centerY < maxY + cellHeight;
                centerY += cellHeight
            ) {
                ctx.moveTo(minX, centerY - railGap);
                ctx.lineTo(maxX, centerY - railGap);
                ctx.moveTo(minX, centerY + railGap);
                ctx.lineTo(maxX, centerY + railGap);
                for (let x = minX; x < maxX + cellWidth; x += cellWidth) {
                    ctx.moveTo(x - crossHalfWidth, centerY - crossHalfHeight);
                    ctx.lineTo(x + crossHalfWidth, centerY + crossHalfHeight);
                    ctx.moveTo(x - crossHalfWidth, centerY + crossHalfHeight);
                    ctx.lineTo(x + crossHalfWidth, centerY - crossHalfHeight);
                }
            }
            ctx.stroke();
            return;
        }

        const height = maxY - minY;
        ctx.beginPath();
        if (
            pattern === 'diagonal' ||
            pattern === 'diagonal-grid' ||
            pattern === 'hybrid-grid'
        ) {
            for (let x = minX - height; x < maxX + spacing; x += spacing) {
                ctx.moveTo(x, minY);
                ctx.lineTo(x + height, maxY);
            }
        }
        if (pattern === 'diagonal-grid' || pattern === 'hybrid-grid') {
            for (let x = minX; x < maxX + height + spacing; x += spacing) {
                ctx.moveTo(x, minY);
                ctx.lineTo(x - height, maxY);
            }
        }
        if (pattern === 'diagonal-2') {
            const diagonalSpacing = spacing * 1.75;
            for (let x = minX; x < maxX + height + diagonalSpacing; x += diagonalSpacing) {
                ctx.moveTo(x, minY);
                ctx.lineTo(x - height, maxY);
            }
        }
        if (pattern === 'hybrid-grid') {
            for (let y = minY + spacing; y < maxY; y += spacing) {
                ctx.moveTo(minX, y);
                ctx.lineTo(maxX, y);
            }
        }
        if (
            pattern === 'diagonal' ||
            pattern === 'diagonal-2' ||
            pattern === 'diagonal-grid' ||
            pattern === 'hybrid-grid'
        ) {
            ctx.stroke();
        }
    }

    getHatchSpacing(lineWidth: number): number {
        return Math.max(12, Math.round((lineWidth || 3) * 4));
    }

    getHatchLineWidth(lineWidth: number): number {
        return Math.max(1, (lineWidth || 3) * 0.45);
    }

    drawGridPattern(
        ctx: CanvasRenderingContext2D,
        minX: number,
        minY: number,
        maxX: number,
        maxY: number,
        spacing: number
    ) {
        ctx.beginPath();
        for (let x = minX + spacing; x < maxX; x += spacing) {
            ctx.moveTo(x, minY);
            ctx.lineTo(x, maxY);
        }
        for (let y = minY + spacing; y < maxY; y += spacing) {
            ctx.moveTo(minX, y);
            ctx.lineTo(maxX, y);
        }
        ctx.stroke();
    }

    // drawing-shape-moving-preview-v2
    drawPolygonShape(ctx,stroke){let polygons=this.getShapePolygons(stroke),lineSegments=this.getShapeLineSegments(stroke),lineOnly=this.isLineOnlyDrawingShape(stroke);if(polygons.length===0&&lineSegments.length===0)return;if(!lineOnly)for(let polygon of polygons){this.tracePolygonPath(ctx,polygon,true);this.drawShapeHatch(ctx,stroke,polygon)}ctx.beginPath();if(!lineOnly)for(let polygon of polygons){ctx.moveTo(polygon[0].x,polygon[0].y);for(let index=1;index<polygon.length;index++)ctx.lineTo(polygon[index].x,polygon[index].y);ctx.closePath()}for(let[start,end]of lineSegments){ctx.moveTo(start.x,start.y);ctx.lineTo(end.x,end.y)}let moving=this.isMovingDrawingShape&&stroke===this.movingDrawingShape;ctx.strokeStyle=moving?"#9ca3af":stroke.color||"#ef4444";ctx.lineWidth=stroke.width||3;ctx.lineCap="butt";ctx.lineJoin="miter";ctx.globalAlpha=moving ? .42 : 1;ctx.stroke()}

































    // drawing-ellipse-moving-preview-v2
    drawEllipseShape(ctx,stroke){let geometry=this.getDrawingEllipseGeometry(stroke);if(!geometry)return;let bounds=[{x:geometry.centerX-geometry.radiusX,y:geometry.centerY-geometry.radiusY},{x:geometry.centerX+geometry.radiusX,y:geometry.centerY+geometry.radiusY}];ctx.beginPath();ctx.ellipse(geometry.centerX,geometry.centerY,Math.max(geometry.radiusX,1),Math.max(geometry.radiusY,1),0,0,Math.PI*2);this.drawShapeHatch(ctx,stroke,bounds);ctx.beginPath();ctx.ellipse(geometry.centerX,geometry.centerY,Math.max(geometry.radiusX,1),Math.max(geometry.radiusY,1),0,0,Math.PI*2);let moving=this.isMovingDrawingShape&&stroke===this.movingDrawingShape;ctx.strokeStyle=moving?"#9ca3af":stroke.color||"#ef4444";ctx.lineWidth=stroke.width||3;ctx.globalAlpha=moving ? .42 : 1;ctx.stroke()}











    get pageDrawingsCount(): number {
        return this.drawings.filter((d: any) => d.page === this.currentPage).length;
    }

    normalizeDamageNumbers() {
        const pageStates: { [page: string]: { used: Set<number>; next: number } } = {};
        for (const damage of this.damages) {
            const pageKey = String(Number(damage?.page) || 1);
            const state = pageStates[pageKey] || { used: new Set<number>(), next: 1 };
            const currentNumber = Number(damage?.number);
            let resolvedNumber = Number.isInteger(currentNumber) && currentNumber > 0 && !state.used.has(currentNumber)
                ? currentNumber
                : state.next;
            while (state.used.has(resolvedNumber)) resolvedNumber += 1;
            damage.number = resolvedNumber;
            state.used.add(resolvedNumber);
            state.next = Math.max(state.next, resolvedNumber + 1);
            pageStates[pageKey] = state;
        }
        this.damageCounter = this.damages.length;
    }

    getNextDamageNumber(page: number): number {
        let maxNumber = 0;
        for (const damage of this.damages) {
            if ((Number(damage?.page) || 1) !== page) continue;
            const number = Number(damage?.number);
            if (Number.isInteger(number) && number > maxNumber) maxNumber = number;
        }
        return maxNumber + 1;
    }

    async adjustSelectedDamageNumber(delta: number) {
        if (!this.selectedDamage) return;
        const page = Number(this.selectedDamage.page) || this.currentPage;
        const pageDamages = this.damages.filter((damage: any) => (Number(damage?.page) || 1) === page);
        const selectedIndex = pageDamages.indexOf(this.selectedDamage);
        if (selectedIndex < 0) return;

        const amount = delta < 0 ? -1 : 1;
        const affected = new Set(pageDamages.slice(selectedIndex));
        const changes: Array<{ damage: any; number: number }> = [];
        const used = new Set<number>();

        for (const damage of pageDamages) {
            const currentNumber = Number(damage?.number);
            const nextNumber = currentNumber + (affected.has(damage) ? amount : 0);
            if (!Number.isInteger(currentNumber) || currentNumber < 1 || nextNumber < 1) {
                await this.service.alert.show({
                    title: '손상번호 변경 불가',
                    message: '손상번호는 1 이상이어야 합니다.',
                    status: 'error',
                    action: '확인',
                    cancel: false
                });
                return;
            }
            if (used.has(nextNumber)) {
                await this.service.alert.show({
                    title: '손상번호 변경 불가',
                    message: '손상번호 ' + nextNumber + '번이 앞선 손상번호와 중복되어 변경할 수 없습니다.',
                    status: 'error',
                    action: '확인',
                    cancel: false
                });
                return;
            }
            used.add(nextNumber);
            changes.push({ damage, number: nextNumber });
        }

        for (const change of changes) change.damage.number = change.number;
        this.damageCounter = this.damages.length;
        this.renderMarkers();
        this.ref.detectChanges();
    }

    duplicateSelectedDamage() {
        if (!this.selectedDamage) return;

        this.flushPendingDamageTypeCustom();
        const sourceDraft = this.buildSelectedDamageDraft();
        if (!sourceDraft) return;

        Object.assign(this.selectedDamage, sourceDraft);
        const sourceDamage = this.selectedDamage;
        const page = Number(sourceDamage.page) || this.currentPage;
        const rawSourceNumber = Number(sourceDamage.number);
        const sourceNumber = Number.isInteger(rawSourceNumber) && rawSourceNumber > 0
            ? rawSourceNumber
            : this.getNextDamageNumber(page);
        const duplicateNumber = sourceNumber + 1;
        const renumbered: Array<{ damage: any; before: number; after: number }> = [];

        for (const damage of this.damages) {
            if (damage === sourceDamage || (Number(damage?.page) || 1) !== page) continue;
            const number = Number(damage?.number);
            if (!Number.isInteger(number) || number < duplicateNumber) continue;
            renumbered.push({ damage, before: number, after: number + 1 });
            damage.number = number + 1;
        }

        const displayOffset = 48;
        const canvasOffset = this.rotatePointToCanvas(
            displayOffset,
            0,
            0,
            0,
            this.getPageRotation(page)
        );
        const sourceInfo = this.stripSyncOnlyFields(sourceDraft);
        const points = Array.isArray(sourceInfo.points)
            ? sourceInfo.points.map((point: any) => ({
                ...point,
                x: (Number(point?.x) || 0) + canvasOffset.x,
                y: (Number(point?.y) || 0) + canvasOffset.y
            }))
            : [];
        const arrows = Array.isArray(sourceInfo.arrows)
            ? sourceInfo.arrows.map((arrow: any) => ({
                ...arrow,
                toX: Number.isFinite(Number(arrow?.toX)) ? Number(arrow.toX) + canvasOffset.x : arrow?.toX,
                toY: Number.isFinite(Number(arrow?.toY)) ? Number(arrow.toY) + canvasOffset.y : arrow?.toY
            }))
            : [];
        const duplicate: any = {
            ...sourceInfo,
            id: this.generateId(),
            number: duplicateNumber,
            page,
            points,
            arrows,
            damageTypes: Array.isArray(sourceInfo.damageTypes) ? [...sourceInfo.damageTypes] : [],
            damageSubTypes: Array.isArray(sourceInfo.damageSubTypes) ? [...sourceInfo.damageSubTypes] : [],
            measurements: this.normalizeMeasurements(sourceInfo.measurements),
            photos: [],
            photoRepresentativeLocked: false,
            createdAt: new Date().toISOString()
        };

        const sourceIndex = this.damages.indexOf(sourceDamage);
        const insertIndex = sourceIndex >= 0 ? sourceIndex + 1 : this.damages.length;
        this.damages.splice(insertIndex, 0, duplicate);
        this.damageCounter = this.damages.length;
        this.pushUndo({
            type: 'duplicate-damage',
            data: duplicate,
            index: insertIndex,
            renumbered
        });
        this.selectedDamage = duplicate;
        this.openDamageForm(duplicate);
        this.renderMarkers();
    }

    // ================================================================
    //  DAMAGE MARKER CRUD
    // ================================================================

    createDamageMarker(type: string, points: { x: number; y: number }[]) {
        const marker: any = {
            id: this.generateId(),
            number: this.getNextDamageNumber(this.currentPage),
            type: type,
            page: this.currentPage,
            points: points,
            location: '',
            member: '',
            damageType: '',
            damageTypes: [],
            damageSubType: '',
            damageSubTypes: [],
            measurements: this.getDefaultMeasurements(),
            photos: [],
            photoRepresentativeLocked: false,
            remark: '신규',
            color: '#ef4444',
            createdAt: new Date().toISOString()
        };
        this.damages.push(marker);
        this.normalizeDamageNumbers();
        this.pushUndo({ type: 'add-damage', data: marker });
        this.selectedDamage = marker;
        this.openDamageForm(marker);
        this.renderMarkers();
    }

    findMarkerAt(x: number, y: number): any | null {
        const pageMarkers = this.damages.filter((d: any) => d.page === this.currentPage);
        const threshold = 25;
        for (let i = pageMarkers.length - 1; i >= 0; i--) {
            const m = pageMarkers[i];
            for (const p of m.points) {
                if (Math.sqrt((x - p.x) ** 2 + (y - p.y) ** 2) < threshold) return m;
            }
        }
        return null;
    }

    // ================================================================
    //  CANVAS RENDERING (Markers)
    // ================================================================

    renderMarkers() {
        if (!this.annotCtx || !this.annotCanvas) return;
        this.annotCtx.clearRect(0, 0, this.annotCanvas.width, this.annotCanvas.height);

        const pageMarkers = this.damages.filter((d: any) => d.page === this.currentPage);

        // Draw arrows first (under markers)
        for (const m of pageMarkers) {
            if (m.arrows && m.arrows.length > 0 && m.points[0]) {
                const ctx = this.annotCtx!;
                for (const arrow of m.arrows) {
                    ctx.save();
                    ctx.strokeStyle = '#000000';
                    ctx.lineWidth = 2.5;
                    ctx.lineCap = 'round';
                    this.drawArrow(ctx, m.points[0].x, m.points[0].y, arrow.toX, arrow.toY, 2.5);
                    ctx.restore();
                }
            }
        }

        // Draw markers on top
        for (const m of pageMarkers) {
            this.drawMarker(m, m === this.selectedDamage, false);
        }
    }

    drawMarker(m: any, selected: boolean, drawLabel: boolean = true) {
        const ctx = this.annotCtx!;
        const color = m.color || '#ef4444';
        const p = m.points[0];
        if (!p) return;
        const r = selected ? 20 : 16;
        ctx.beginPath();
        ctx.arc(p.x, p.y, r, 0, Math.PI * 2);
        ctx.fillStyle = color;
        ctx.globalAlpha = 0.9;
        ctx.fill();
        ctx.globalAlpha = 1;
        if (selected) {
            ctx.strokeStyle = '#ffffff';
            ctx.lineWidth = 4;
            ctx.stroke();
        }
        if (drawLabel) {
            this.drawMarkerLabel(ctx, m.number, p.x, p.y, selected);
        }
    }

    drawMarkerLabel(ctx: CanvasRenderingContext2D, number: string | number, x: number, y: number, selected: boolean) {
        ctx.fillStyle = '#ffffff';
        ctx.font = `bold ${selected ? 14 : 12}px "Pretendard", sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(String(number), x, y);
    }

    // ================================================================
    //  DAMAGE FORM
    // ================================================================

    newFormData(): any {
        return {
            drawingName: '',
            location: '',
            member: '',
            memberCustom: '',
            damageType: '',
            damageTypes: [],
            damageSubType: '',
            damageSubTypes: [],
            damageTypeCustom: '',
            measurements: this.getDefaultMeasurements(),
            photos: [],
            photoRepresentativeLocked: false,
            remark: '신규'
        };
    }

    getPageDrawingName(page: any): string {
        const pageKey = String(Number(page) || 1);
        return String(this.drawingNamesByPage[pageKey] || '').trim();
    }

    get isSelectedPageDrawingNameFixed(): boolean {
        if (!this.selectedDamage) return false;
        const fixedName = this.getPageDrawingName(this.selectedDamage.page);
        return !!fixedName && fixedName === String(this.formData.drawingName || '').trim();
    }

    async fixSelectedPageDrawingName() {
        if (!this.selectedDamage) return;
        const page = Number(this.selectedDamage.page) || this.currentPage;
        const name = String(this.formData.drawingName || '').trim();
        if (this.isSelectedPageDrawingNameFixed) {
            const nextDrawingNames = { ...this.drawingNamesByPage };
            delete nextDrawingNames[String(page)];
            this.drawingNamesByPage = nextDrawingNames;
            this.ref.detectChanges();
            return;
        }
        let message = '';
        if (!name) message = '도면명(장소명)을 입력해주세요.';
        else if (name.length > 31) message = '도면명은 엑셀 시트명 기준 31자 이하로 입력해주세요.';
        else if (/[\[\]:*?\/\\]/.test(name) || name.startsWith("'") || name.endsWith("'")) {
            message = '도면명에는 엑셀 시트명에서 사용할 수 없는 문자 [ ] : * ? / \\ 또는 앞뒤 작은따옴표를 사용할 수 없습니다.';
        } else {
            const duplicate = Object.entries(this.drawingNamesByPage).some(([pageKey, value]: [string, any]) => (
                Number(pageKey) !== page
                && String(value || '').trim().toLocaleLowerCase('ko-KR') === name.toLocaleLowerCase('ko-KR')
            ));
            if (duplicate) message = '다른 페이지에 동일한 도면명이 이미 고정되어 있습니다.';
        }

        if (message) {
            await this.service.alert.show({
                title: '도면명 고정 불가',
                message,
                status: 'error',
                action: '확인',
                cancel: false
            });
            return;
        }

        this.drawingNamesByPage = {
            ...this.drawingNamesByPage,
            [String(page)]: name
        };
        this.formData.drawingName = name;
        this.ref.detectChanges();
    }

    getDefaultMeasurements(): any {
        return {
            width: '',
            widthUnit: 'm',
            widthChecked: true,
            length: '',
            lengthUnit: 'm',
            lengthChecked: true,
            breadth: '',
            breadthUnit: 'm',
            breadthChecked: false,
            depth: '',
            depthUnit: 'm',
            depthChecked: false,
            count: '',
            quantity: '',
            quantityUnit: 'm²'
        };
    }

    normalizeMeasurementBoolean(value: any, fallback: boolean): boolean {
        if (typeof value === 'boolean') return value;
        if (typeof value === 'number') return value !== 0;
        if (typeof value === 'string') {
            const normalized = value.toLowerCase();
            if (['true', '1', 'y', 'yes', 'on'].includes(normalized)) return true;
            if (['false', '0', 'n', 'no', 'off'].includes(normalized)) return false;
        }
        return fallback;
    }

    normalizeMeasurements(measurements: any): any {
        const source = measurements && typeof measurements === 'object' ? measurements : {};
        const defaults = this.getDefaultMeasurements();
        const width = source.width !== undefined ? source.width : (source.dim1 !== undefined ? source.dim1 : defaults.width);
        const widthUnit = source.widthUnit !== undefined ? source.widthUnit : (source.dim1Unit !== undefined ? source.dim1Unit : defaults.widthUnit);
        const length = source.length !== undefined ? source.length : (source.dim2 !== undefined ? source.dim2 : defaults.length);
        const lengthUnit = source.lengthUnit !== undefined ? source.lengthUnit : (source.dim2Unit !== undefined ? source.dim2Unit : defaults.lengthUnit);
        const quantityUnit = this.BASE_QUANTITY_UNITS.includes(source.quantityUnit) ? source.quantityUnit : defaults.quantityUnit;

        return {
            width: width || '',
            widthUnit: widthUnit || 'm',
            widthChecked: this.normalizeMeasurementBoolean(source.widthChecked, defaults.widthChecked),
            length: length || '',
            lengthUnit: lengthUnit || 'm',
            lengthChecked: this.normalizeMeasurementBoolean(source.lengthChecked, defaults.lengthChecked),
            breadth: source.breadth || '',
            breadthUnit: source.breadthUnit || defaults.breadthUnit,
            breadthChecked: this.normalizeMeasurementBoolean(source.breadthChecked, defaults.breadthChecked),
            depth: source.depth || '',
            depthUnit: source.depthUnit || defaults.depthUnit,
            depthChecked: this.normalizeMeasurementBoolean(source.depthChecked, defaults.depthChecked),
            count: source.count || '',
            quantity: source.quantity || '',
            quantityUnit
        };
    }

    openDamageForm(damage: any) {
        const savedMember = damage.member || '';
        const memberCustom = savedMember && !this.MEMBERS.includes(savedMember) ? savedMember : '';
        const member = memberCustom ? '기타' : savedMember;
        const photoRepresentativeLocked = damage.photoRepresentativeLocked === true;
        const photos = this.cloneDamagePhotos(damage.photos, photoRepresentativeLocked);
        damage.photoRepresentativeLocked = photoRepresentativeLocked;
        damage.photos = this.cloneDamagePhotos(photos, photoRepresentativeLocked);

        const categoryNames = this.CATEGORIES.map((c: any) => c.name);
        let damageTypes = this.normalizeDamageTypes(damage.damageTypes, damage.damageType);
        let damageSubTypes = this.normalizeDamageSubTypes(damage.damageSubTypes, damage.damageSubType);
        const invalidDamageTypes = damageTypes.filter((item: string) => !categoryNames.includes(item));

        if (invalidDamageTypes.length > 0) {
            damageTypes = damageTypes.filter((item: string) => categoryNames.includes(item));
            if (!damageTypes.includes('기타')) {
                damageTypes = [...damageTypes, '기타'];
            }

            for (const invalidType of invalidDamageTypes) {
                if (!damageSubTypes.includes(invalidType)) {
                    damageSubTypes = [...damageSubTypes, invalidType];
                }
            }
        }

        this.selectedDamage = damage;
        this.formData = {
            drawingName: this.getPageDrawingName(damage.page || this.currentPage),
            location: damage.location || '',
            member,
            memberCustom,
            damageType: this.getRepresentativeDamageType(damageTypes),
            damageTypes,
            damageSubType: damageSubTypes[damageSubTypes.length - 1] || '',
            damageSubTypes,
            damageTypeCustom: '',
            measurements: this.normalizeMeasurements(damage.measurements),
            photos,
            photoRepresentativeLocked,
            remark: damage.remark || '신규'
        };
        this.showPanel = true;
        this.panelMode = 'form';
        this.ref.detectChanges();
    }

    closeDamageForm() {
        this.showPanel = false;
        this.selectedDamage = null;
        this.formData = this.newFormData();
        this.renderMarkers();
        this.ref.detectChanges();
    }

    saveDamageForm() {
        if (!this.selectedDamage) return;
        this.syncSelectedDamageFromForm(true);
        this.scheduleLocalDraftSave('damage-form-save', true);
    }

    deleteDamage() {
        if (!this.selectedDamage) return;
        this.removeDamageMarker(this.selectedDamage);
    }

    removeDamageMarker(damage: any) {
        const idx = this.damages.indexOf(damage);
        if (idx === -1) return;

        this.pushUndo({ type: 'delete-damage', data: damage, index: idx });
        this.damages.splice(idx, 1);
        this.normalizeDamageNumbers();
        this.checkedDamageIds = this.checkedDamageIds.filter((id: string) => id !== damage.id);

        if (this.selectedDamage === damage) {
            this.selectedDamage = null;
            if (this.panelMode === 'form') this.showPanel = false;
            this.formData = this.newFormData();
        }

        this.renderMarkers();
        this.ref.detectChanges();
    }

    setDamageType(cat: any) {
        const selectedTypes = this.selectedDamageTypes;
        const nextDamageTypes = selectedTypes.includes(cat.name)
            ? selectedTypes.filter((item: string) => item !== cat.name)
            : [...selectedTypes, cat.name];
        const availableSubtypes = new Set(this.getSubtypesByDamageTypes(nextDamageTypes));
        const keepCustom = nextDamageTypes.includes('기타');
        const nextDamageSubTypes = this.selectedDamageContents.filter((item: string) => {
            if (availableSubtypes.has(item)) return true;
            if (keepCustom && !this.isKnownDamageSubtype(item)) return true;
            return false;
        });

        this.formData.damageTypes = nextDamageTypes;
        this.formData.damageType = this.getRepresentativeDamageType(nextDamageTypes);
        this.formData.damageSubTypes = nextDamageSubTypes;
        this.formData.damageSubType = nextDamageSubTypes[nextDamageSubTypes.length - 1] || '';
        if (!keepCustom) {
            this.formData.damageTypeCustom = '';
        }
        this.ref.detectChanges();
    }

    setMember(member: string) {
        this.formData.member = member;
        if (member !== '기타') {
            this.formData.memberCustom = '';
        }
        this.ref.detectChanges();
    }

    appendDamageSubType(subType: string) {
        const normalized = String(subType || '').trim();
        if (!normalized) return;

        this.formData.damageSubTypes = [...this.selectedDamageContents, normalized];
        this.formData.damageSubType = normalized;
    }

    setDamageSubType(sub: string) {
        this.appendDamageSubType(sub);
        if (sub !== '기타') {
            this.formData.damageTypeCustom = '';
        }
        this.ref.detectChanges();
    }

    addDamageTypeCustom() {
        const value = String(this.formData.damageTypeCustom || '').trim();
        if (!value) return;

        this.appendDamageSubType(value);
        this.formData.damageTypeCustom = '';
        this.ref.detectChanges();
    }

    removeDamageSubType(index: number) {
        const items = this.selectedDamageContents;
        if (index < 0 || index >= items.length) return;

        this.formData.damageSubTypes = items.filter((_: string, itemIndex: number) => itemIndex !== index);
        this.formData.damageSubType = this.formData.damageSubTypes[this.formData.damageSubTypes.length - 1] || '';
        this.ref.detectChanges();
    }

    onDamageTypeCustomInput(value: string) {
        this.formData.damageTypeCustom = value;
        this.ref.detectChanges();
    }

    getSubtypesByDamageType(damageType: string): string[] {
        const cat = this.CATEGORIES.find((c: any) => c.name === damageType);
        return cat ? cat.subs : [];
    }

    get selectedSubtypes(): string[] {
        return this.getSubtypesByDamageTypes(this.selectedDamageTypes);
    }

    // ================================================================
    //  DAMAGE LIST
    // ================================================================

    openDamageList() {
        this.panelMode = 'list';
        this.showPanel = true;
        this.ref.detectChanges();
    }

    isDamageChecked(damageId: string): boolean {
        return this.checkedDamageIds.includes(damageId);
    }

    toggleDamageChecked(damageId: string) {
        if (this.isDamageChecked(damageId)) {
            this.checkedDamageIds = this.checkedDamageIds.filter((id: string) => id !== damageId);
        } else {
            this.checkedDamageIds = [...this.checkedDamageIds, damageId];
        }
        this.ref.detectChanges();
    }

    get checkedPageDamagesCount(): number {
        const pageDamageIds = new Set(this.pageDamages.map((damage: any) => damage.id));
        return this.checkedDamageIds.filter((id: string) => pageDamageIds.has(id)).length;
    }

    get allPageDamagesChecked(): boolean {
        return this.pageDamages.length > 0 && this.checkedPageDamagesCount === this.pageDamages.length;
    }

    toggleAllPageDamages() {
        if (this.allPageDamagesChecked) {
            const pageDamageIds = new Set(this.pageDamages.map((damage: any) => damage.id));
            this.checkedDamageIds = this.checkedDamageIds.filter((id: string) => !pageDamageIds.has(id));
        } else {
            const merged = new Set(this.checkedDamageIds);
            for (const damage of this.pageDamages) merged.add(damage.id);
            this.checkedDamageIds = Array.from(merged);
        }
        this.ref.detectChanges();
    }

    async deleteCheckedDamages() {
        const selected = this.pageDamages.filter((damage: any) => this.checkedDamageIds.includes(damage.id));
        if (selected.length === 0) return;

        const confirmed = await this.service.alert.show({
            title: '선택 삭제',
            message: `선택한 손상 ${selected.length}건을 삭제하시겠습니까?`,
            status: 'warning',
            action: '삭제',
            actionBtn: 'btn-red',
            cancel: '취소'
        });
        if (!confirmed) return;

        const removed = selected.map((damage: any) => ({
            damage,
            index: this.damages.indexOf(damage)
        })).filter((item: any) => item.index > -1);

        if (removed.length === 0) return;

        const removedIds = new Set(removed.map((item: any) => item.damage.id));
        this.pushUndo({ type: 'delete-damages', data: removed, page: this.currentPage });
        this.damages = this.damages.filter((damage: any) => !removedIds.has(damage.id));
        this.normalizeDamageNumbers();
        this.checkedDamageIds = this.checkedDamageIds.filter((id: string) => !removedIds.has(id));

        if (this.selectedDamage && removedIds.has(this.selectedDamage.id)) {
            this.selectedDamage = null;
            if (this.panelMode === 'form') this.showPanel = false;
            this.formData = this.newFormData();
        }

        this.renderMarkers();
        this.ref.detectChanges();
    }

    get pageDamages(): any[] {
        return this.damages.filter((d: any) => d.page === this.currentPage);
    }

    get allDamagesCount(): number {
        return this.damages.length;
    }

    selectDamage(damage: any) {
        this.selectedDamage = damage;
        this.openDamageForm(damage);
        this.renderMarkers();
    }

    getCategoryColor(name: string): string {
        const cat = this.CATEGORIES.find((c: any) => c.name === name);
        return cat ? cat.color : '#6b7280';
    }

    getCategoryIcon(name: string): string {
        const cat = this.CATEGORIES.find((c: any) => c.name === name);
        return cat ? cat.icon : 'fa-circle';
    }

    getModeName(mode: string): string {
        const names: any = { pan: '이동', point: '손상 표시', draw: '드로잉' };
        return names[mode] || '이동';
    }

    getModeIcon(mode: string): string {
        const icons: any = { pan: 'fa-hand', point: 'fa-location-dot', draw: 'fa-pen' };
        return icons[mode] || 'fa-hand';
    }

    getPointToolName(tool: string): string {
        const names: any = { add: '손상 추가', select: '손상 선택', erase: '손상 지우기' };
        return names[tool] || '손상 표시';
    }

    getPointToolIcon(tool: string): string {
        const icons: any = { add: 'fa-location-dot', select: 'fa-crosshairs', erase: 'fa-eraser' };
        return icons[tool] || 'fa-location-dot';
    }

    getCurrentToolName(): string {
        if (this.currentMode === 'point') {
            return this.getPointToolName(this.pointTool);
        }
        return this.getModeName(this.currentMode);
    }

    getCurrentToolIcon(): string {
        if (this.currentMode === 'point') {
            return this.getPointToolIcon(this.pointTool);
        }
        return this.getModeIcon(this.currentMode);
    }

    getMarkerTypeName(type: string): string {
        return '점';
    }

    getRemarkClass(remark: string): string {
        const classMap: any = {
            '기존': 'remark-existing',
            '신규': 'remark-new',
            '보수': 'remark-repair',
            '보수부': 'remark-repair-part',
            '증가': 'remark-increase'
        };
        return classMap[remark] || '';
    }

    getDamageDisplayName(damage: any): string {
        if (!damage) return '손상 사진';

        const damageContent = this.getDamageContentSummary(damage);
        if (damageContent !== '유형 미지정') return damageContent;

        const parts = [damage.member, damage.location].filter((item: any) => !!item);
        if (parts.length > 0) return parts.join(' · ');

        return '손상 사진';
    }

    get activePhotoPreview(): any | null {
        if (this.photoPreviewIndex < 0 || this.photoPreviewIndex >= this.photoPreviewPhotos.length) return null;
        return this.photoPreviewPhotos[this.photoPreviewIndex] || null;
    }

    openDamagePhotoPreview(damage: any, photoId: string = '') {
        const photos = this.cloneDamagePhotos(this.getDamagePhotos(damage), damage?.photoRepresentativeLocked === true);
        if (photos.length === 0) return;

        let previewIndex = -1;
        if (photoId) {
            previewIndex = photos.findIndex((photo: any) => photo.id === photoId);
        }
        if (previewIndex < 0) {
            previewIndex = photos.findIndex((photo: any) => photo.isRepresentative === true);
        }
        if (previewIndex < 0) {
            previewIndex = photos.length - 1;
        }

        this.photoPreviewDamage = { ...damage };
        this.photoPreviewPhotos = photos;
        this.photoPreviewIndex = previewIndex;
        this.photoPreviewVisible = true;
        this.ref.detectChanges();
    }

    closeDamagePhotoPreview() {
        this.photoPreviewVisible = false;
        this.photoPreviewDamage = null;
        this.photoPreviewPhotos = [];
        this.photoPreviewIndex = 0;
        this.damagePhotoPreviewWasLongPress = false;
        this.cancelDamagePhotoPreviewPress();
        this.ref.detectChanges();
    }

    setDamagePhotoPreviewIndex(index: number) {
        if (index < 0 || index >= this.photoPreviewPhotos.length) return;
        this.photoPreviewIndex = index;
        this.ref.detectChanges();
    }

    showPrevDamagePhoto() {
        if (this.photoPreviewPhotos.length < 2) return;
        const nextIndex = (this.photoPreviewIndex - 1 + this.photoPreviewPhotos.length) % this.photoPreviewPhotos.length;
        this.setDamagePhotoPreviewIndex(nextIndex);
    }

    showNextDamagePhoto() {
        if (this.photoPreviewPhotos.length < 2) return;
        const nextIndex = (this.photoPreviewIndex + 1) % this.photoPreviewPhotos.length;
        this.setDamagePhotoPreviewIndex(nextIndex);
    }

    startDamagePhotoPreviewPress(event: Event, damage: any, photoId: string) {
        event.stopPropagation();
        this.cancelDamagePhotoPreviewPress();
        this.damagePhotoPreviewWasLongPress = false;
        this.damagePhotoPreviewPressTimer = setTimeout(() => {
            this.damagePhotoPreviewPressTimer = null;
            this.damagePhotoPreviewWasLongPress = true;
            this.openDamagePhotoPreview(damage, photoId);
        }, 450);
    }

    cancelDamagePhotoPreviewPress() {
        if (!this.damagePhotoPreviewPressTimer) return;
        clearTimeout(this.damagePhotoPreviewPressTimer);
        this.damagePhotoPreviewPressTimer = null;
    }

    onDamagePhotoThumbClick(event: Event, damage: any) {
        event.stopPropagation();
        this.cancelDamagePhotoPreviewPress();
        if (this.damagePhotoPreviewWasLongPress) {
            this.damagePhotoPreviewWasLongPress = false;
            return;
        }
        this.selectDamage(damage);
    }

    // ================================================================
    //  PHOTO CAPTURE
    // ================================================================

    triggerPhotoCapture() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.capture = 'environment';
        input.multiple = true;
        input.onchange = (e: any) => {
            const files = e.target.files;
            if (!files || files.length === 0) return;
            for (let i = 0; i < files.length; i++) {
                this.processPhoto(files[i]);
            }
        };
        input.click();
    }

    processPhoto(file: File) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
            const base64 = e.target.result;
            const nextPhotos = Array.isArray(this.formData.photos) ? [...this.formData.photos] : [];
            nextPhotos.push({
                id: this.generateId(),
                name: file.name,
                data: base64,
                timestamp: new Date().toISOString()
            });
            this.formData.photos = this.normalizeDamagePhotos(nextPhotos, {
                keepRepresentative: this.formData.photoRepresentativeLocked === true
            });
            this.ref.detectChanges();
        };
        reader.readAsDataURL(file);
    }

    setRepresentativePhoto(photoId: string) {
        const photos = Array.isArray(this.formData.photos) ? this.formData.photos : [];
        if (photos.length === 0) return;

        this.formData.photoRepresentativeLocked = true;
        this.formData.photos = this.normalizeDamagePhotos(photos.map((photo: any) => ({
            ...photo,
            isRepresentative: photo.id === photoId
        })), { keepRepresentative: true });
        this.ref.detectChanges();
    }

    removePhoto(photoId: string) {
        if (!this.formData.photos) return;
        const remainingPhotos = this.formData.photos.filter((p: any) => p.id !== photoId);
        const keepRepresentative = this.formData.photoRepresentativeLocked === true
            && remainingPhotos.some((photo: any) => photo.isRepresentative === true);
        this.formData.photoRepresentativeLocked = keepRepresentative;
        this.formData.photos = this.normalizeDamagePhotos(remainingPhotos, { keepRepresentative });
        this.ref.detectChanges();
    }

    onMeasurementValueChange(key: string, value: string) {
        this.formData.measurements = this.normalizeMeasurements(this.formData.measurements);
        this.formData.measurements[key] = value;
        this.autoCalcQuantity();
    }

    onMeasurementUnitChange(key: string, value: string) {
        this.formData.measurements = this.normalizeMeasurements(this.formData.measurements);
        this.formData.measurements[`${key}Unit`] = value;
        this.autoCalcQuantity();
    }

    onMeasurementCheckedChange(key: string, checked: boolean) {
        this.formData.measurements = this.normalizeMeasurements(this.formData.measurements);
        this.formData.measurements[`${key}Checked`] = checked;
        this.autoCalcQuantity();
    }

    formatQuantityValue(value: number): string {
        if (!Number.isFinite(value)) return '';
        const fixed = value.toFixed(2);
        return fixed.replace(/\.00$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
    }

    get quantityUnitOptions(): string[] {
        return [...this.BASE_QUANTITY_UNITS];
    }

    autoCalcQuantity() {
        const m = this.normalizeMeasurements(this.formData.measurements);
        this.formData.measurements = m;

        const factors: number[] = [];

        for (const field of this.MEASUREMENT_FIELDS) {
            if (m[`${field.key}Checked`] !== true) continue;

            const value = parseFloat(m[field.key]);
            if (!Number.isFinite(value) || value <= 0) continue;

            factors.push(value);
        }

        const count = parseFloat(m.count);
        const hasCount = Number.isFinite(count) && count > 0;

        if (factors.length === 0) {
            if (hasCount) {
                m.quantity = this.formatQuantityValue(count);
            } else {
                m.quantity = '';
            }
            this.ref.detectChanges();
            return;
        }

        let quantity = factors.reduce((acc: number, current: number) => acc * current, 1);
        if (hasCount) quantity *= count;

        m.quantity = this.formatQuantityValue(quantity);
        this.ref.detectChanges();
    }

    // ================================================================
    //  SAVE (통합 저장: JSON + PDF + XLSX + Photos)
    // ================================================================

    private async queueOfflineInspectionSave(
        syncPayload: any,
        snapshotDamages: any[],
        snapshotDrawings: any[],
        showSuccessAlert: boolean,
        alertMessage: string = '로컬에 저장되었습니다. 네트워크가 복구되면 동기화됩니다.'
    ): Promise<boolean> {
        const offlinePayload = { ...syncPayload, annotated_pdf: '' };
        if (!wiz.offline || !wiz.offline.sync || typeof wiz.offline.sync.queueWrite !== 'function') return false;

        if (wiz.offline.storage) {
            await wiz.offline.storage.put('damages', {
                drawing_id: this.drawingId,
                data: snapshotDamages,
                localModified: Date.now()
            });
            await wiz.offline.storage.put('annotations', {
                drawing_id: this.drawingId,
                data: snapshotDrawings,
                localModified: Date.now()
            });
            await wiz.offline.storage.setMeta(
                `inspection_viewer_overview:${this.facilityId}`,
                this.facilityOverviewPhotos
            );
        }

        await wiz.offline.sync.queueWrite({
            entity_type: 'inspection_save',
            entity_id: this.drawingId,
            action: 'save',
            payload: offlinePayload,
            api_endpoint: wiz.url('save'),
            operation_id: offlinePayload.operation_id,
            client_id: offlinePayload.client_id,
            base_revision: offlinePayload.base_revision
        });
        await this.markLocalDraftQueued(offlinePayload.operation_id);
        this.lastSavedEntityState = this.buildSyncEntityState();
        this.lastSavedSnapshot = this.buildSaveStateSnapshot();
        this.hasSnapshotBaseline = true;
        await this.recordViewerPhotoManifest(snapshotDamages);
        if (showSuccessAlert) {
            await this.service.alert.show({
                title: '오프라인 저장',
                message: alertMessage,
                status: 'success',
                action: '확인',
                cancel: false
            });
        }
        return true;
    }

    async save(showSuccessAlert: boolean = true, showErrorAlert: boolean = true): Promise<boolean> {
        if (this.isSaving) return false;

        this.syncSelectedDamageFromForm(false);
        this.localDraftDirty = true;
        const autosaveVersion = await this.flushLocalDraft('manual-save');
        this.isSaving = true;
        this.ref.detectChanges();
        await this.service.loading.show();

        let saved = false;
        let snapshotDamages: any[] = [];
        let snapshotDrawings: any[] = [];
        let operations: any[] = [];
        let syncPayload: any = null;
        try {
            this.ensureSyncMetadataForCurrentState(false);
            snapshotDamages = this.buildSnapshotDamages();
            snapshotDrawings = this.buildSnapshotDrawingPayload();
            operations = this.buildSyncOperations();
            const operationId = this.buildSaveOperationId(operations);











            // 손상·주석 JSON만 전송하고 표기 PDF는 서버가 원본 도면에서 생성한다.
            // 모바일에서 전체 페이지를 PNG로 렌더링·업로드하던 장시간 지연을 제거한다.
            const annotatedPdfBase64 = '';



            syncPayload = {
                drawing_id: this.drawingId,
                facility_id: this.facilityId,
                project_id: this.project?.id || '',
                damages: JSON.stringify(snapshotDamages),
                drawings: JSON.stringify(snapshotDrawings),
                overview_photos: JSON.stringify(this.facilityOverviewPhotos),
                annotated_pdf: annotatedPdfBase64,
                operations: JSON.stringify(operations),
                operation_id: operationId,
                client_id: this.syncClientId,
                base_revision: String(this.syncState?.revision || 0)
            };

            const formData = new FormData();
            for (const key of Object.keys(syncPayload)) {
                formData.append(key, syncPayload[key]);
            }

            const executeSave = () => fetch(wiz.url('save'), {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });
            let resp = await executeSave();
            if ((resp.status === 401 || resp.status === 403)
                && wiz.offline?.sync
                && typeof wiz.offline.sync.ensureServerSessionForEndpoint === 'function'
                && await wiz.offline.sync.ensureServerSessionForEndpoint(wiz.url('save'))) {
                resp = await executeSave();
            }
            const result = await resp.json();
            const code = result.code || resp.status;
            const data = result.data;
            await this.service.loading.hide();
            if (code === 200) {
                this.facilityOverviewPhotos = this.normalizeFacilityOverviewPhotos(data?.overview_photos || this.facilityOverviewPhotos);
                if (Array.isArray(data?.damages)) {
                    this.damages = data.damages;
                    this.normalizeLoadedDamages();
                    this.ensureSyncMetadataForCurrentState(false);
                }
                if (data?.drawings) {
                    const drawingPayload = this.parseDrawingPayload(data.drawings);
                    this.drawings = drawingPayload.drawings;
                    this.pageRotations = drawingPayload.pageRotations;
                    this.legacyRotationDegrees = drawingPayload.legacyRotation;
                    this.blankPageCount = drawingPayload.blankPageCount;
            this.blankPageIds = drawingPayload.blankPageIds;
            this.drawingNamesByPage = drawingPayload.drawingNamesByPage;
                    this.syncVirtualPages();
                    this.ensureSyncMetadataForCurrentState(false);
                    this.renderDrawings();
                }
                if (data?.sync) {
                    this.syncState = data.sync;
                    this.syncConflicts = data.sync.conflicts || [];
                }
                this.lastSavedEntityState = this.buildSyncEntityState();
                this.lastSavedSnapshot = this.buildSaveStateSnapshot();
                this.hasSnapshotBaseline = true;
                await this.clearLocalDraft(autosaveVersion);
                this.hasSavedExportFiles = data?.exports_ready === true;
                saved = true;
                await this.recordViewerPhotoManifest(this.damages);
                if (showSuccessAlert) {
                    const conflictCount = Number(data?.sync?.conflict_count || 0); const renumberedDamages = Array.isArray(data?.renumbered_damages) ? data.renumbered_damages : []; const renumberedSummary = renumberedDamages.map((item: any) => `${item.page}페이지 ${item.from_number}번→${item.to_number}번`).join(', ');
                    await this.service.alert.show({
                        title: conflictCount > 0 ? '충돌 확인 필요' : renumberedSummary ? '저장 완료 · 번호 조정' : '저장 완료',
                        message: conflictCount > 0
                            ? `${conflictCount}건의 동시 수정 충돌이 남아 있습니다. 서버 저장본은 덮어쓰지 않았습니다.${renumberedSummary ? ` 손상번호 자동 조정: ${renumberedSummary}.` : ''}`
                            : renumberedSummary ? `동시 작업으로 손상번호가 자동 조정되었습니다: ${renumberedSummary}.` : '저장되었습니다.',
                        status: conflictCount > 0 || renumberedSummary ? 'warning' : 'success',
                        action: '확인',
                        cancel: false
                    });
                }
            } else if (code === 401 || code === 403) {
                saved = await this.queueOfflineInspectionSave(
                    syncPayload,
                    snapshotDamages,
                    snapshotDrawings,
                    showSuccessAlert,
                    '서버 로그인이 만료되어 로컬에 저장했습니다. 다시 로그인하면 대기 중인 작업이 동기화됩니다.'
                );
                if (!saved && showErrorAlert) {
                    await this.service.alert.show({
                        title: '저장 실패',
                        message: data || '로그인이 필요합니다.',
                        status: 'error',
                        action: '확인',
                        cancel: false
                    });
                }
            } else if (showErrorAlert) {
                await this.service.alert.show({
                    title: '저장 실패',
                    message: data || '저장 중 오류가 발생했습니다.',
                    status: 'error',
                    action: '확인',
                    cancel: false
                });
            }
        } catch (e) {
            await this.service.loading.hide();
            console.error('Save error:', e);
            try {
                if (!syncPayload) {
                    this.ensureSyncMetadataForCurrentState(false);
                    snapshotDamages = this.buildSnapshotDamages();
                    snapshotDrawings = this.buildSnapshotDrawingPayload();
                    operations = this.buildSyncOperations();
                    syncPayload = {
                        drawing_id: this.drawingId,
                        facility_id: this.facilityId,
                        project_id: this.project?.id || '',
                        damages: JSON.stringify(snapshotDamages),
                        drawings: JSON.stringify(snapshotDrawings),
                        overview_photos: JSON.stringify(this.facilityOverviewPhotos),
                        operations: JSON.stringify(operations),
                        operation_id: this.buildSaveOperationId(operations),
                        client_id: this.syncClientId,
                        base_revision: String(this.syncState?.revision || 0)
                    };
                }
                saved = await this.queueOfflineInspectionSave(syncPayload, snapshotDamages, snapshotDrawings, showSuccessAlert);
            } catch (queueError) {
                console.error('Offline queue error:', queueError);
            }
            if (!saved && showErrorAlert) {
                await this.service.alert.show({
                    title: '저장 실패',
                    message: '저장 중 오류가 발생했습니다.',
                    status: 'error',
                    action: '확인',
                    cancel: false
                });
            }
        } finally {
            this.isSaving = false;
            this.ref.detectChanges();
        }

        return saved;
    }

    async generateAnnotatedPdfBase64(): Promise<string> {
        const pages: string[] = [];
        for (let i = 1; i <= this.totalPages; i++) {
            const { sourcePage, viewport: vp } = await this.getVirtualPageViewport(i, 2);

            const tmpCanvas = document.createElement('canvas');
            tmpCanvas.width = vp.width;
            tmpCanvas.height = vp.height;
            const tmpCtx = tmpCanvas.getContext('2d')!;

            const markerCanvas = document.createElement('canvas');
            markerCanvas.width = vp.width;
            markerCanvas.height = vp.height;
            const markerCtx = markerCanvas.getContext('2d')!;

            const drawingCanvas = document.createElement('canvas');
            drawingCanvas.width = vp.width;
            drawingCanvas.height = vp.height;
            const drawingCtx = drawingCanvas.getContext('2d')!;

            tmpCtx.fillStyle = '#ffffff';
            tmpCtx.fillRect(0, 0, vp.width, vp.height);
            if (sourcePage) {
                await sourcePage.render({ canvasContext: tmpCtx, viewport: vp }).promise;
            }

            // Draw arrows and markers for this page
            const pageMarkers = this.damages.filter((d: any) => d.page === i);

            // Draw arrows first
            for (const m of pageMarkers) {
                if (m.arrows && m.arrows.length > 0 && m.points[0]) {
                    for (const arrow of m.arrows) {
                        markerCtx.save();
                        markerCtx.strokeStyle = '#000000';
                        markerCtx.lineWidth = 2.5;
                        markerCtx.lineCap = 'round';
                        this.drawArrow(markerCtx, m.points[0].x, m.points[0].y, arrow.toX, arrow.toY, 2.5);
                        markerCtx.restore();
                    }
                }
            }

            // Draw markers on top
            const origAnnotCtx = this.annotCtx;
            this.annotCtx = markerCtx;
            for (const m of pageMarkers) {
                this.drawMarker(m, false, false);
            }
            this.annotCtx = origAnnotCtx;

            // Draw drawings for this page
            const pageDrawings = this.drawings.filter((d: any) => d.page === i);
            for (const stroke of pageDrawings) {
                this.drawStroke(drawingCtx, stroke);
            }

            tmpCtx.drawImage(markerCanvas, 0, 0);
            tmpCtx.drawImage(drawingCanvas, 0, 0);

            const pageRotation = this.getPageRotation(i);
            const rotatedCanvas = this.rotateCanvasForExport(tmpCanvas, pageRotation);
            const rotatedCtx = rotatedCanvas.getContext('2d');
            if (rotatedCtx) {
                for (const m of pageMarkers) {
                    const point = m.points?.[0];
                    if (!point) continue;
                    const rotatedPoint = this.rotatePointForDisplay(point.x, point.y, tmpCanvas.width, tmpCanvas.height, pageRotation);
                    this.drawMarkerLabel(rotatedCtx, m.number, rotatedPoint.x, rotatedPoint.y, false);
                }
            }
            pages.push(rotatedCanvas.toDataURL('image/png'));
        }
        return JSON.stringify(pages);
    }

    rotateCanvasForExport(sourceCanvas: HTMLCanvasElement, rotationDegrees: number = this.rotationDegrees): HTMLCanvasElement {
        if (rotationDegrees === 0) return sourceCanvas;

        const canvas = document.createElement('canvas');
        const sideways = rotationDegrees === 90 || rotationDegrees === 270;
        canvas.width = sideways ? sourceCanvas.height : sourceCanvas.width;
        canvas.height = sideways ? sourceCanvas.width : sourceCanvas.height;

        const ctx = canvas.getContext('2d');
        if (!ctx) return sourceCanvas;

        switch (rotationDegrees) {
            case 90:
                ctx.translate(canvas.width, 0);
                ctx.rotate(Math.PI / 2);
                break;
            case 180:
                ctx.translate(canvas.width, canvas.height);
                ctx.rotate(Math.PI);
                break;
            case 270:
                ctx.translate(0, canvas.height);
                ctx.rotate(-Math.PI / 2);
                break;
        }

        ctx.drawImage(sourceCanvas, 0, 0);
        return canvas;
    }

    syncVirtualPages(renderCurrent: boolean = true) {
        if (!this.pdfDoc) return;
        this.totalPages = Math.max(
            1,
            this.sourcePageCount + this.normalizeBlankPageCount(this.blankPageCount)
        );
        this.currentPage = Math.min(Math.max(this.currentPage, 1), this.totalPages);
        this.initPageThumbnails();
        void this.generatePageThumbnails();
        if (renderCurrent) {
            void this.renderPage(this.currentPage).then(() => this.fitToScreen());
        }
    }

    async addBlankPage() {
        if (!this.pdfDoc || this.isAddingPage) return;
        if (this.blankPageCount >= 200) {
            await this.service.alert.show({
                title: '페이지 추가 불가',
                message: '빈 페이지는 최대 200장까지 추가할 수 있습니다.',
                status: 'warning',
                action: '확인',
                cancel: false
            });
            return;
        }

        this.isAddingPage = true;
        this.syncSelectedDamageFromForm(false);
        this.blankPageIds = this.normalizeBlankPageIds(this.blankPageIds, this.blankPageCount);
        this.blankPageIds = [...this.blankPageIds, `blank_${this.generateId()}`].slice(0, 200);
        this.blankPageCount = this.blankPageIds.length;
        this.totalPages = this.sourcePageCount + this.blankPageCount;
        this.currentPage = this.totalPages;
        this.initPageThumbnails();
        void this.generatePageThumbnails();
        this.ref.detectChanges();
        try {
            await this.renderPage(this.currentPage);
            this.fitToScreen();
        } finally {
            this.isAddingPage = false;
            this.ref.detectChanges();
        }
    }

    // ================================================================
    //  PAGE NAVIGATION
    // ================================================================

    isBlankPage(pageNumber: number): boolean {
        return Number.isInteger(pageNumber)
            && pageNumber > this.sourcePageCount
            && pageNumber <= this.totalPages;
    }

    private shiftPageMapAfterDeletion(values: { [page: string]: any }, deletedPage: number): { [page: string]: any } {
        const shifted: { [page: string]: any } = {};
        if (!values || typeof values !== 'object') return shifted;

        for (const [pageKey, value] of Object.entries(values)) {
            const pageNumber = Number(pageKey);
            if (!Number.isInteger(pageNumber) || pageNumber < 1 || pageNumber === deletedPage) continue;
            shifted[String(pageNumber > deletedPage ? pageNumber - 1 : pageNumber)] = value;
        }
        return shifted;
    }

    async deleteBlankPage(pageNumber: number, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.pdfDoc || this.deletingBlankPage > 0 || !this.isBlankPage(pageNumber)) return;

        const blankPageIds = this.normalizeBlankPageIds(this.blankPageIds, this.blankPageCount);
        const blankIndex = pageNumber - this.sourcePageCount - 1;
        if (blankIndex < 0 || blankIndex >= blankPageIds.length) return;

        const pageHasContent = this.damages.some((damage: any) => (Number(damage?.page) || 1) === pageNumber)
            || this.drawings.some((drawing: any) => (Number(drawing?.page) || 1) === pageNumber)
            || this.pageRotations[String(pageNumber)] !== undefined
            || !!this.drawingNamesByPage[String(pageNumber)];
        const confirmed = await this.service.alert.show({
            title: '추가 페이지 삭제',
            message: pageHasContent
                ? '이 추가 페이지와 페이지 안의 손상·드로잉을 모두 삭제하시겠습니까?'
                : '이 추가 빈 페이지를 삭제하시겠습니까?',
            status: 'warning',
            action: '삭제',
            actionBtn: 'btn-red',
            cancel: '취소'
        });
        if (!confirmed) return;

        this.deletingBlankPage = pageNumber;
        this.syncSelectedDamageFromForm(false);
        const selectedDamageId = String(this.selectedDamage?.id || '');
        try {
            this.blankPageIds = blankPageIds.filter((_: string, index: number) => index !== blankIndex);
            this.blankPageCount = this.blankPageIds.length;
            this.damages = this.damages
                .filter((damage: any) => (Number(damage?.page) || 1) !== pageNumber)
                .map((damage: any) => {
                    const itemPage = Number(damage?.page) || 1;
                    return itemPage > pageNumber ? { ...damage, page: itemPage - 1 } : damage;
                });
            this.drawings = this.drawings
                .filter((drawing: any) => (Number(drawing?.page) || 1) !== pageNumber)
                .map((drawing: any) => {
                    const itemPage = Number(drawing?.page) || 1;
                    return itemPage > pageNumber ? { ...drawing, page: itemPage - 1 } : drawing;
                });
            this.pageRotations = this.shiftPageMapAfterDeletion(this.pageRotations, pageNumber);
            this.drawingNamesByPage = this.shiftPageMapAfterDeletion(this.drawingNamesByPage, pageNumber);

            this.selectedDamage = selectedDamageId
                ? this.damages.find((damage: any) => String(damage?.id || '') === selectedDamageId) || null
                : null;
            if (selectedDamageId && !this.selectedDamage) {
                if (this.panelMode === 'form') this.showPanel = false;
                this.formData = this.newFormData();
            }
            const remainingDamageIds = new Set(this.damages.map((damage: any) => String(damage?.id || '')));
            this.checkedDamageIds = this.checkedDamageIds.filter((id: string) => remainingDamageIds.has(String(id)));
            this.normalizeDamageNumbers();

            this.isDrawing = false;
            this.currentStroke = null;
            this.drawStartPoint = null;
            this.isDraggingMarker = false;
            this.dragTarget = null;
            if (this.longPressTimer) {
                clearTimeout(this.longPressTimer);
                this.longPressTimer = null;
            }
            if (this.drawingShapeLongPressTimer) {
                clearTimeout(this.drawingShapeLongPressTimer);
                this.drawingShapeLongPressTimer = null;
            }
            this.isMovingDrawingShape = false;
            this.movingDrawingShape = null;
            this.drawingShapeMoveStartPoint = null;
            this.drawingShapeMoveOriginalPoints = [];
            this.undoStack = [];
            this.redoStack = [];

            this.totalPages = Math.max(1, this.sourcePageCount + this.blankPageCount);
            if (this.currentPage > pageNumber) this.currentPage -= 1;
            else if (this.currentPage === pageNumber) this.currentPage = Math.min(pageNumber, this.totalPages);

            this.ensureSyncMetadataForCurrentState(false);
            this.initPageThumbnails();
            void this.generatePageThumbnails();
            this.ref.detectChanges();
            await this.renderPage(this.currentPage);
            this.fitToScreen();
        } finally {
            this.deletingBlankPage = 0;
            this.ref.detectChanges();
        }
    }

    async prevPage() {
        if (this.currentPage > 1) {
            await this.renderPage(this.currentPage - 1);
            this.fitToScreen();
        }
    }

    async nextPage() {
        if (this.currentPage < this.totalPages) {
            await this.renderPage(this.currentPage + 1);
            this.fitToScreen();
        }
    }

    // ================================================================
    //  UTILITY
    // ================================================================

    generateId(): string {
        return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
    }

    stripFileExtension(name: string): string {
        return String(name || '').replace(/\.[^/.]+$/, '');
    }

    normalizeFacilityOverviewPhotos(photos: any): any[] {
        if (!Array.isArray(photos)) return [];

        return photos
            .filter((photo: any) => photo && typeof photo === 'object' && typeof photo.data === 'string' && photo.data.startsWith('data:image/'))
            .map((photo: any, index: number) => ({
                id: photo.id || this.generateId(),
                name: photo.name || `facility_photo_${index + 1}`,
                locationName: photo.locationName || photo.title || '',
                data: photo.data,
                timestamp: photo.timestamp || new Date().toISOString()
            }));
    }

    getFacilityOverviewPhotoCount(): number {
        return this.facilityOverviewPhotos.length;
    }

    trackFacilityOverviewPhoto(index: number, photo: any): string | number {
        return photo?.id || index;
    }

    openFacilityOverviewPhotoModal() {
        this.overviewPhotoModalVisible = true;
        this.ref.detectChanges();
    }

    closeFacilityOverviewPhotoModal() {
        this.overviewPhotoModalVisible = false;
        this.ref.detectChanges();
    }

    triggerFacilityOverviewPhotoCapture() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.capture = 'environment';
        input.multiple = true;
        input.onchange = (event: any) => {
            const files = event.target.files;
            if (!files || files.length === 0) return;
            for (let index = 0; index < files.length; index++) {
                this.processFacilityOverviewPhoto(files[index]);
            }
        };
        input.click();
    }

    processFacilityOverviewPhoto(file: File) {
        const reader = new FileReader();
        reader.onload = (event: any) => {
            const nextPhotos = [...this.facilityOverviewPhotos];
            nextPhotos.push({
                id: this.generateId(),
                name: file.name,
                locationName: this.stripFileExtension(file.name),
                data: event.target.result,
                timestamp: new Date().toISOString()
            });
            this.facilityOverviewPhotos = this.normalizeFacilityOverviewPhotos(nextPhotos);
            this.ref.detectChanges();
        };
        reader.readAsDataURL(file);
    }

    updateFacilityOverviewPhotoLocation(photoId: string, value: string) {
        const photo = this.facilityOverviewPhotos.find((item: any) => item.id === photoId);
        if (!photo) return;

        photo.locationName = value;
        this.ref.detectChanges();
    }

    removeFacilityOverviewPhoto(photoId: string) {
        this.facilityOverviewPhotos = this.normalizeFacilityOverviewPhotos(this.facilityOverviewPhotos.filter((photo: any) => photo.id !== photoId));
        this.ref.detectChanges();
    }

    navigateBack() {
        const projectId = this.project?.id || this.facility?.project_id || '';
        if (projectId) this.service.href(`/project/detail/${projectId}`);
        else this.service.href('/inspection');
    }

    async goBack() {
        if (!this.hasUnsavedChanges) {
            this.navigateBack();
            return;
        }

        const shouldSave = await this.service.alert.show({
            title: '저장 확인',
            message: '수정사항이 있습니다. 저장하시겠습니까?',
            status: 'warning',
            action: '예',
            cancel: '아니오'
        });

        if (shouldSave) {
            const saved = await this.save(false);
            if (!saved) return;
        }

        this.navigateBack();
    }

    // ================================================================
    //  ZIP EXPORT
    // ================================================================

    private resolveNativeUrl(url: string): string {
        const normalized = String(url || '').trim();
        if (!normalized || /^https?:\/\//.test(normalized) || !this.isCapacitor()) return normalized;

        return normalized.startsWith('/')
            ? `https://ipro.autopro.ai.kr${normalized}`
            : `https://ipro.autopro.ai.kr/${normalized}`;
    }

    private isCapacitor(): boolean {
        return typeof window !== 'undefined'
            && !!(window as any).Capacitor
            && (window as any).Capacitor.isNativePlatform
            && (window as any).Capacitor.isNativePlatform();
    }

    private async writeBlobToExportDirectory(blob: Blob, filename: string): Promise<{ label: string; uri: string }> {
        const { Filesystem, Directory } = await import('@capacitor/filesystem');
        const arrayBuffer = await blob.arrayBuffer();
        const uint8 = new Uint8Array(arrayBuffer);
        let binary = '';
        const chunkSize = 8192;
        for (let i = 0; i < uint8.length; i += chunkSize) {
            binary += String.fromCharCode.apply(null, Array.from(uint8.subarray(i, i + chunkSize)));
        }
        const base64 = btoa(binary);

        try {
            const permissions = await Filesystem.checkPermissions();
            if (permissions.publicStorage !== 'granted') {
                await Filesystem.requestPermissions();
            }
        } catch {}

        const path = `inspectPRO/${filename}`;
        const attempts = [
            { directory: Directory.Documents, label: 'Downloads/inspectPRO' },
            { directory: Directory.External, label: '앱 저장소/inspectPRO' }
        ];

        let lastError: any = null;
        for (const attempt of attempts) {
            try {
                await Filesystem.writeFile({
                    path,
                    data: base64,
                    directory: attempt.directory,
                    recursive: true
                });

                const uriResult = await Filesystem.getUri({
                    path,
                    directory: attempt.directory
                });

                return {
                    label: attempt.label,
                    uri: uriResult.uri || ''
                };
            } catch (error) {
                lastError = error;
            }
        }

        throw new Error(lastError?.message || '추출 파일 저장에 실패했습니다.');
    }

    private getExportCacheId(): string {
        return `inspection_export_zip:${this.project?.id || ''}:${this.facilityId}`;
    }

    private async recordCacheManifestItem(item: any) {
        try {
            const projectId = this.project?.id || '';
            if (!projectId || !wiz.offline?.storage?.updateCacheManifestItem) return;
            await wiz.offline.storage.updateCacheManifestItem(projectId, item);
        } catch (error) {
            console.warn('Cache manifest update failed:', error);
        }
    }

    private getDataUrlSize(value: any): number {
        const data = String(value || '');
        if (!data) return 0;
        const commaIndex = data.indexOf(',');
        if (data.startsWith('data:') && commaIndex >= 0) {
            return Math.floor(data.slice(commaIndex + 1).length * 0.75);
        }
        return data.length;
    }

    private async recordViewerPhotoManifest(damages: any[] = this.damages) {
        const projectId = this.project?.id || '';
        if (!projectId || !wiz.offline?.storage?.updateCacheManifestItem) return;

        for (let index = 0; index < this.facilityOverviewPhotos.length; index++) {
            const photo = this.facilityOverviewPhotos[index];
            const photoId = photo?.id || `${this.facilityId}:${index + 1}`;
            await this.recordCacheManifestItem({
                id: `overview_photo:${this.facilityId}:${photoId}`,
                category: 'overview_photo',
                label: photo?.locationName || photo?.name || `전경사진 ${index + 1}`,
                status: photo?.data ? 'cached' : 'missing',
                ref_id: photoId,
                parent_id: this.facilityId,
                filename: photo?.name || '',
                size: this.getDataUrlSize(photo?.data),
                cached_at: photo?.data ? Date.now() : undefined,
                error: photo?.data ? '' : '사진 데이터가 비어 있습니다.'
            });
        }

        const rows = Array.isArray(damages) ? damages : [];
        for (const damage of rows) {
            const photos = Array.isArray(damage?.photos) ? damage.photos : [];
            for (let index = 0; index < photos.length; index++) {
                const photo = photos[index];
                const ownerId = damage?.id || damage?.number || this.drawingId;
                const photoId = photo?.id || `${ownerId}:${index + 1}`;
                await this.recordCacheManifestItem({
                    id: `damage_photo:${ownerId}:${photoId}`,
                    category: 'damage_photo',
                    label: photo?.name || `손상 사진 ${index + 1}`,
                    status: photo?.data ? 'cached' : 'missing',
                    ref_id: photoId,
                    parent_id: this.drawingId,
                    filename: photo?.name || '',
                    size: this.getDataUrlSize(photo?.data),
                    cached_at: photo?.data ? Date.now() : undefined,
                    error: photo?.data ? '' : '사진 데이터가 비어 있습니다.'
                });
            }
        }
    }

    private async cacheExportBlob(blob: Blob, filename: string) {
        try {
            if (!wiz.offline || !wiz.offline.storage) return;
            await wiz.offline.storage.put('files', {
                id: this.getExportCacheId(),
                type: 'inspection_export_zip',
                ref_id: this.facilityId,
                filename,
                mime_type: blob.type || 'application/zip',
                blob,
                cached_at: Date.now()
            });
            await this.recordCacheManifestItem({
                id: `export:${this.getExportCacheId()}`,
                category: 'export',
                label: `${this.facility?.name || '시설물'} 마지막 도면 ZIP 추출본`,
                status: 'cached',
                required: false,
                ref_id: this.facilityId,
                filename,
                size: blob.size,
                cached_at: Date.now()
            });
        } catch (error) {
            console.warn('Export cache write failed:', error);
        }
    }

    private async getCachedExportBlob(): Promise<{ blob: Blob; filename: string } | null> {
        try {
            if (!wiz.offline || !wiz.offline.storage) return null;
            const cached = await wiz.offline.storage.get('files', this.getExportCacheId());
            if (!cached || !cached.blob) return null;
            return {
                blob: cached.blob,
                filename: cached.filename || `${this.facility?.name || '시설물'}_offline.zip`
            };
        } catch (error) {
            console.warn('Export cache read failed:', error);
            return null;
        }
    }

    private async deliverExportBlob(blob: Blob, filename: string, fromCache: boolean = false) {
        if (this.isCapacitor()) {
            const saved = await this.writeBlobToExportDirectory(blob, filename);
            await this.service.alert.show({
                title: fromCache ? '캐시 추출 완료' : '추출 완료',
                message: `${saved.label} 폴더에 저장되었습니다.\n파일명: ${filename}${saved.uri ? `\n위치: ${saved.uri}` : ''}${fromCache ? '\n오프라인 상태라 마지막으로 생성된 추출본을 저장했습니다.' : ''}`,
                status: fromCache ? 'warning' : 'success',
                action: '확인',
                cancel: false
            });
            return;
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        if (fromCache) {
            await this.service.alert.show({
                title: '캐시 추출 완료',
                message: '오프라인 상태라 마지막으로 생성된 추출본을 저장했습니다.',
                status: 'warning',
                action: '확인',
                cancel: false
            });
        }
    }

    async exportZip() {
        if (this.exporting) return;
        this.exporting = true;
        this.exportStage = 'saving';
        let loadingShown = false;
        await this.service.render();
        try {
            let exportWarning = '';
            if (await this.blockExportForPendingConflicts()) {
                return;
            }
            const shouldSaveBeforeExport = !this.hasSavedExportFiles || !this.hasSnapshotBaseline || this.hasUnsavedChanges;
            if (!shouldSaveBeforeExport) {
                this.exportStage = 'exporting';
                await this.service.render();
            }
            if (shouldSaveBeforeExport) {
                const saved = await this.save(false, false);
                if (!saved) {
                    if (!this.hasSavedExportFiles) {
                        throw new Error('추출 준비 중 저장에 실패했습니다.');
                    }
                    exportWarning = '최신 변경사항 저장에 실패하여 마지막 저장본으로 추출했습니다.';
                }

                this.exportStage = 'exporting';
                await this.service.render();
            }
            if (await this.blockExportForPendingConflicts()) {
                return;
            }

            await this.service.loading.show();
            loadingShown = true;
            const formData = new FormData();
            formData.append('project_id', this.project?.id || '');
            formData.append('facility_id', this.facilityId);
            formData.append('drawing_id', this.drawingId);



            const response = await fetch(wiz.url('export_zip'), {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });
            if (!response.ok || response.headers.get('content-type')?.includes('json')) {
            
                let msg = '추출 중 오류가 발생했습니다.';
                let errData: any = null;
                try {
                    errData = await response.json();
                    msg = typeof errData?.data === 'string' ? errData.data : errData?.message || msg;
                } catch {}
                const error: any = new Error(msg);
                const errorCode = Number(errData?.code || response.status);
                if (errorCode === 409 || msg.includes('미해결 충돌')) error.skipCacheFallback = true;
                throw error;
            }

            const blob = await response.blob();
            const projectName = this.project?.title || '프로젝트';
            const facilityName = this.facility?.name || '시설물';
            const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
            const zipName = `${projectName}_${facilityName}_${today}.zip`;

            await this.cacheExportBlob(blob, zipName);
            if (loadingShown) {
                await this.service.loading.hide();
                loadingShown = false;
            }
            await this.deliverExportBlob(blob, zipName);

            if (exportWarning) {
                if (loadingShown) {
                    await this.service.loading.hide();
                    loadingShown = false;
                }
                await this.service.alert.show({
                    title: '일부 변경사항 미반영',
                    message: exportWarning,
                    status: 'warning',
                    action: '확인',
                    cancel: false
                });
            }
        } catch (e: any) {
            if (loadingShown) {
                await this.service.loading.hide();
                loadingShown = false;
            }
            const cachedExport = e?.skipCacheFallback ? null : await this.getCachedExportBlob();
            if (cachedExport) {
                try {
                    await this.deliverExportBlob(cachedExport.blob, cachedExport.filename, true);
                    return;
                } catch (cacheError) {
                    console.error('Cached export failed:', cacheError);
                }
            }
            await this.service.alert.show({
                title: '추출 실패',
                message: e.message && e.message !== 'Failed to fetch'
                    ? e.message
                    : '파일 추출 중 오류가 발생했습니다. 온라인에서 한 번 추출한 뒤 오프라인 캐시 추출을 사용할 수 있습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        } finally {
            this.exporting = false;
            this.exportStage = 'idle';
            if (loadingShown) {
                await this.service.loading.hide();
            }
            this.ref.detectChanges();
        }
    }
}

export default PageInspectionViewerComponent;